import * as api from '../api/property';
import * as eventApi from '@modules/events/api/event';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';
import { WORK_ITEMS_UPDATED } from '../constants/property';

const namespace = 'APPRAISAL';

export const FETCH_PROPERTY_TAX_RATES_START = `${namespace}/FETCH_PROPERTY_TAX_RATES_START`;
export const FETCH_PROPERTY_TAX_RATES_SUCCESS = `${namespace}/FETCH_PROPERTY_TAX_RATES_SUCCESS`;
export const FETCH_PROPERTY_TAX_RATES_ERROR = `${namespace}/FETCH_PROPERTY_TAX_RATES_ERROR`;

export const FETCH_SEARCH_CONFIG_START = `${namespace}/FETCH_SEARCH_CONFIG_START`;
export const FETCH_SEARCH_CONFIG_SUCCESS = `${namespace}/FETCH_SEARCH_CONFIG_SUCCESS`;
export const FETCH_SEARCH_CONFIG_ERROR = `${namespace}/FETCH_SEARCH_CONFIG_ERROR`;

export const FETCH_APPLICATION_EVENTS_START = `${namespace}/FETCH_APPLICATION_EVENTS_START`;
export const FETCH_APPLICATION_EVENTS_SUCCESS = `${namespace}/FETCH_APPLICATION_EVENTS_SUCCESS`;
export const FETCH_APPLICATION_EVENTS_ERROR = `${namespace}/FETCH_APPLICATION_EVENTS_ERROR`;

export const DELETE_APPLICATION_EVENTS_START = `${namespace}/DELETE_APPLICATION_EVENTS_START`;
export const DELETE_APPLICATION_EVENTS_SUCCESS = `${namespace}/DELETE_APPLICATION_EVENTS_SUCCESS`;
export const DELETE_APPLICATION_EVENTS_ERROR = `${namespace}/DELETE_APPLICATION_EVENTS_ERROR`;

export const FETCH_SEARCH_RESULTS_CONFIG_START = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_START`;
export const FETCH_SEARCH_RESULTS_CONFIG_SUCCESS = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_SUCCESS`;
export const FETCH_SEARCH_RESULTS_CONFIG_ERROR = `${namespace}/FETCH_SEARCH_RESULTS_CONFIG_ERROR`;

export const PROPERTY_SEARCH_START = `${namespace}/PROPERTY_SEARCH_START`;
export const PROPERTY_SEARCH_SUCCESS = `${namespace}/PROPERTY_SEARCH_SUCCESS`;
export const PROPERTY_SEARCH_ERROR = `${namespace}/PROPERTY_SEARCH_ERROR`;

export const PROPERTY_SEARCH_STANDALONE_START = `${namespace}/PROPERTY_SEARCH_STANDALONE_START`;
export const PROPERTY_SEARCH_STANDALONE_SUCCESS = `${namespace}/PROPERTY_SEARCH_STANDALONE_SUCCESS`;
export const PROPERTY_SEARCH_STANDALONE_ERROR = `${namespace}/PROPERTY_SEARCH_STANDALONE_ERROR`;

export const FETCH_APPRAISAL_CONFIGURATION_START = `${namespace}/FETCH_APPRAISAL_CONFIGURATION_START`;
export const FETCH_APPRAISAL_CONFIGURATION_SUCCESS = `${namespace}/FETCH_APPRAISAL_CONFIGURATION_SUCCESS`;
export const FETCH_APPRAISAL_CONFIGURATION_ERROR = `${namespace}/FETCH_APPRAISAL_CONFIGURATION_ERROR`;

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;
export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;
export const CHANGE_SORT_MODEL = `${namespace}/CHANGE_SORT_MODEL`;
export const CHANGE_FILTER_MODEL = `${namespace}/CHANGE_FILTER_MODEL`;

export const PROPERTY_RESET_DATA = 'APPRAISAL/PROPERTY_RESET_DATA';
export const PROPERTY_FETCH_START = 'APPRAISAL/PROPERTY_FETCH_START';
export const PROPERTY_FETCH_SUCCESS = 'APPRAISAL/PROPERTY_FETCH_SUCCESS';
export const PROPERTY_FETCH_ERROR = 'APPRAISAL/PROPERTY_FETCH_ERROR';

export const PROPERTY_FULL_FETCH_START = 'APPRAISAL/PROPERTY_FULL_FETCH_START';
export const PROPERTY_FULL_FETCH_SUCCESS =
  'APPRAISAL/PROPERTY_FULL_FETCH_SUCCESS';
export const PROPERTY_FULL_FETCH_ERROR = 'APPRAISAL/PROPERTY_FULL_FETCH_ERROR';

export const PROPERTY_FULL_MASS_FETCH_START =
  'APPRAISAL/PROPERTY_FULL_MASS_FETCH_START';
export const PROPERTY_FULL_MASS_FETCH_SUCCESS =
  'APPRAISAL/PROPERTY_FULL_MASS_FETCH_SUCCESS';
export const PROPERTY_FULL_MASS_FETCH_ERROR =
  'APPRAISAL/PROPERTY_FULL_MASS_FETCH_ERROR';

export const PROPERTY_UPDATE_START = 'APPRAISAL/PROPERTY_UPDATE_START';
export const PROPERTY_UPDATE_SUCCESS = 'APPRAISAL/PROPERTY_UPDATE_SUCCESS';
export const PROPERTY_UPDATE_ERROR = 'APPRAISAL/PROPERTY_UPDATE_ERROR';

export const PROPERTY_UPDATE_PRIMARY_IMAGE_START =
  'APPRAISAL/PROPERTY_UPDATE_PRIMARY_IMAGE_START';
export const PROPERTY_UPDATE_PRIMARY_IMAGE_SUCCESS =
  'APPRAISAL/PROPERTY_UPDATE_PRIMARY_IMAGE_SUCCESS';
export const PROPERTY_UPDATE_PRIMARY_IMAGE_ERROR =
  'APPRAISAL/PROPERTY_UPDATE_PRIMARY_IMAGE_ERROR';

export const PROPERTY_NOTES_FETCH_START =
  'APPRAISAL/PROPERTY_NOTES_FETCH_START';
export const PROPERTY_NOTES_FETCH_SUCCESS =
  'APPRAISAL/PROPERTY_NOTES_FETCH_SUCCESS';
export const PROPERTY_NOTES_FETCH_ERROR =
  'APPRAISAL/PROPERTY_NOTES_FETCH_ERROR';

export const PROPERTY_NOTE_ADD_START = 'APPRAISAL/PROPERTY_NOTE_ADD_START';
export const PROPERTY_NOTE_ADD_SUCCESS = 'APPRAISAL/PROPERTY_NOTE_ADD_SUCCESS';
export const PROPERTY_NOTE_ADD_ERROR = 'APPRAISAL/PROPERTY_NOTE_ADD_ERROR';

export const PROPERTY_NOTE_UPDATE_START =
  'APPRAISAL/PROPERTY_NOTE_UPDATE_START';
export const PROPERTY_NOTE_UPDATE_SUCCESS =
  'APPRAISAL/PROPERTY_NOTE_UPDATE_SUCCESS';
export const PROPERTY_NOTE_UPDATE_ERROR =
  'APPRAISAL/PROPERTY_NOTE_UPDATE_ERROR';

export const PROPERTY_NOTE_TAGS_UPDATE_START =
  'APPRAISAL/PROPERTY_NOTE_TAGS_UPDATE_START';
export const PROPERTY_NOTE_TAGS_UPDATE_SUCCESS =
  'APPRAISAL/PROPERTY_NOTE_TAGS_UPDATE_SUCCESS';
export const PROPERTY_NOTE_TAGS_UPDATE_ERROR =
  'APPRAISAL/PROPERTY_NOTE_TAGS_UPDATE_ERROR';

export const PROPERTY_NOTE_DELETE_START =
  'APPRAISAL/PROPERTY_NOTE_DELETE_START';
export const PROPERTY_NOTE_DELETE_SUCCESS =
  'APPRAISAL/PROPERTY_NOTE_DELETE_SUCCESS';
export const PROPERTY_NOTE_DELETE_ERROR =
  'APPRAISAL/PROPERTY_NOTE_DELETE_ERROR';

export const PROPERTY_VALIDATE_START = 'APPRAISAL/PROPERTY_VALIDATE_START';
export const PROPERTY_VALIDATE_SUCCESS = 'APPRAISAL/PROPERTY_VALIDATE_SUCCESS';
export const PROPERTY_VALIDATE_ERROR = 'APPRAISAL/PROPERTY_VALIDATE_ERROR';

export const FETCH_APPLICATIONS_START = 'APPRAISAL/FETCH_APPLICATIONS_START';
export const FETCH_APPLICATIONS_SUCCESS =
  'APPRAISAL/FETCH_APPLICATIONS_SUCCESS';
export const FETCH_APPLICATIONS_ERROR = 'APPRAISAL/FETCH_APPLICATIONS_ERROR';

export const FETCH_APPLICATION = createRequestTypes(
  'APPRAISAL/FETCH_APPLICATION',
);

export const RESET_APPLICATIONS = 'APPRAISAL/RESET_APPLICATIONS';

export const FETCH_APPLICATION_EXEMPTIONS_START =
  'APPRAISAL/FETCH_APPLICATION_EXEMPTIONS_START';
export const FETCH_APPLICATION_EXEMPTIONS_SUCCESS =
  'APPRAISAL/FETCH_APPLICATION_EXEMPTIONS_SUCCESS';
export const FETCH_APPLICATION_EXEMPTIONS_ERROR =
  'APPRAISAL/FETCH_APPLICATION_EXEMPTIONS_ERROR';

export const DELETE_APPLICATION_START = 'APPRAISAL/DELETE_APPLICATION_START';
export const DELETE_APPLICATION_SUCCESS =
  'APPRAISAL/DELETE_APPLICATION_SUCCESS';
export const DELETE_APPLICATION_ERROR = 'APPRAISAL/DELETE_APPLICATION_ERROR';

export const FETCH_APPLICATION_TYPE_START =
  'APPRAISAL/FETCH_APPLICATION_TYPE_START';
export const FETCH_APPLICATION_TYPE_SUCCESS =
  'APPRAISAL/FETCH_APPLICATION_TYPE_SUCCESS';
export const FETCH_APPLICATION_TYPE_ERROR =
  'APPRAISAL/FETCH_APPLICATION_TYPE_ERROR';

export const FETCH_APPLICATION_STATUS_START =
  'APPRAISAL/FETCH_APPLICATION_STATUS_START';
export const FETCH_APPLICATION_STATUS_SUCCESS =
  'APPRAISAL/FETCH_APPLICATION_STATUS_SUCCESS';
export const FETCH_APPLICATION_STATUS_ERROR =
  'APPRAISAL/FETCH_APPLICATION_STATUS_ERROR';

export const FETCH_APPLICATION_OWNERS_START =
  'APPRAISAL/FETCH_APPLICATION_OWNERS_START';
export const FETCH_APPLICATION_OWNERS_SUCCESS =
  'APPRAISAL/FETCH_APPLICATION_OWNERS_SUCCESS';
export const FETCH_APPLICATION_OWNERS_ERROR =
  'APPRAISAL/FETCH_APPLICATION_OWNERS_ERROR';

export const FETCH_APPLICATION_ID_TYPE_START =
  'APPRAISAL/FETCH_APPLICATION_ID_TYPE_START';
export const FETCH_APPLICATION_ID_TYPE_SUCCESS =
  'APPRAISAL/FETCH_APPLICATION_ID_TYPE_SUCCESS';
export const FETCH_APPLICATION_ID_TYPE_ERROR =
  'APPRAISAL/FETCH_APPLICATION_ID_TYPE_ERROR';

export const CREATE_APPLICATION_START = 'APPRAISAL/CREATE_APPLICATION_START';
export const CREATE_APPLICATION_SUCCESS =
  'APPRAISAL/CREATE_APPLICATION_SUCCESS';
export const CREATE_APPLICATION_ERROR = 'APPRAISAL/CREATE_APPLICATION_ERROR';

export const UPDATE_APPLICATION_START = 'APPRAISAL/UPDATE_APPLICATION_START';
export const UPDATE_APPLICATION_SUCCESS =
  'APPRAISAL/UPDATE_APPLICATION_SUCCESS';
export const UPDATE_APPLICATION_ERROR = 'APPRAISAL/UPDATE_APPLICATION_ERROR';

export const COMPLETE_APPLICATION = createRequestTypes(
  'APPRAISAL/COMPLETE_APPLICATION',
);
export const COMPLETE_APPLICATION_MULTI_YEAR = createRequestTypes(
  'APPRAISAL/COMPLETE_APPLICATION_MULTI_YEAR',
);

export const FETCH_APPLICATION_PROPERTY_LIST = createRequestTypes(
  'APPRAISAL/FETCH_APPLICATION_PROPERTY_LIST',
);

export const FETCH_CYCLOMEDIA_BETTER_VIEW = createRequestTypes(
  'APPRAISAL/FETCH_CYCLOMEDIA_BETTER_VIEW',
);

export const FETCH_EXEMPTION_CODEFILES_START =
  'APPRAISAL/FETCH_EXEMPTION_CODEFILES_START';
export const FETCH_EXEMPTION_CODEFILES_SUCCESS =
  'APPRAISAL/FETCH_EXEMPTION_CODEFILES_SUCCESS';
export const FETCH_EXEMPTION_CODEFILES_ERROR =
  'APPRAISAL/FETCH_EXEMPTION_CODEFILES_ERROR';

export const FETCH_APPLICATION_ROLL_CORRECTION_CODES_START =
  'APPRAISAL/FETCH_APPLICATION_ROLL_CORRECTION_CODES_START';
export const FETCH_APPLICATION_ROLL_CORRECTION_CODES_SUCCESS =
  'APPRAISAL/FETCH_APPLICATION_ROLL_CORRECTION_CODES_SUCCESS';
export const FETCH_APPLICATION_ROLL_CORRECTION_CODES_ERROR =
  'APPRAISAL/FETCH_APPLICATION_ROLL_CORRECTION_CODES_ERROR';

export const FETCH_AUTO_COMPLETE_LEGAL_START =
  'APPRAISAL/FETCH_AUTO_COMPLETE_LEGAL_START';
export const FETCH_AUTO_COMPLETE_LEGAL_SUCCESS =
  'APPRAISAL/FETCH_AUTO_COMPLETE_LEGAL_SUCCESS';
export const FETCH_AUTO_COMPLETE_LEGAL_ERROR =
  'APPRAISAL/FETCH_AUTO_COMPLETE_LEGAL_ERROR';

export const FETCH_EXEMPTION_YEARS_START =
  'APPRAISAL/FETCH_EXEMPTION_YEARS_START';
export const FETCH_EXEMPTION_YEARS_SUCCESS =
  'APPRAISAL/FETCH_EXEMPTION_YEARS_SUCCESS';
export const FETCH_EXEMPTION_YEARS_ERROR =
  'APPRAISAL/FETCH_EXEMPTION_YEARS_ERROR';

export const CREATE_EXEMPTION_START = 'APPRAISAL/CREATE_EXEMPTION_START';
export const CREATE_EXEMPTION_SUCCESS = 'APPRAISAL/CREATE_EXEMPTION_SUCCESS';
export const CREATE_EXEMPTION_ERROR = 'APPRAISAL/CREATE_EXEMPTION_ERROR';

export const UPDATE_EXEMPTION_START = 'APPRAISAL/UPDATE_EXEMPTION_START';
export const UPDATE_EXEMPTION_SUCCESS = 'APPRAISAL/UPDATE_EXEMPTION_SUCCESS';
export const UPDATE_EXEMPTION_ERROR = 'APPRAISAL/UPDATE_EXEMPTION_ERROR';

export const DELETE_EXEMPTION_START = 'APPRAISAL/DELETE_EXEMPTION_START';
export const DELETE_EXEMPTION_SUCCESS = 'APPRAISAL/DELETE_EXEMPTION_SUCCESS';
export const DELETE_EXEMPTION_ERROR = 'APPRAISAL/DELETE_EXEMPTION_ERROR';

export const DENY_EXEMPTION_START = 'APPRAISAL/DENY_EXEMPTION_START';
export const DENY_EXEMPTION_SUCCESS = 'APPRAISAL/DENY_EXEMPTION_SUCCESS';
export const DENY_EXEMPTION_ERROR = 'APPRAISAL/DENY_EXEMPTION_ERROR';

export const APPROVE_EXEMPTION_START = 'APPRAISAL/APPROVE_EXEMPTION_START';
export const APPROVE_EXEMPTION_SUCCESS = 'APPRAISAL/APPROVE_EXEMPTION_SUCCESS';
export const APPROVE_EXEMPTION_ERROR = 'APPRAISAL/APPROVE_EXEMPTION_ERROR';

export const UNDO_EXEMPTION_START = 'APPRAISAL/UNDO_EXEMPTION_START';
export const UNDO_EXEMPTION_SUCCESS = 'APPRAISAL/UNDO_EXEMPTION_SUCCESS';
export const UNDO_EXEMPTION_ERROR = 'APPRAISAL/UNDO_EXEMPTION_ERROR';

export const GENERATE_GEOID_START = 'APPRAISAL/GENERATE_GEOID_START';
export const GENERATE_GEOID_SUCCESS = 'APPRAISAL/GENERATE_GEOID_SUCCESS';
export const GENERATE_GEOID_ERROR = 'APPRAISAL/GENERATE_GEOID_ERROR';

export const UPLOAD_APPLICATION_FILE_START =
  'APPRAISAL/UPLOAD_APPLICATION_FILE_START';
export const UPLOAD_APPLICATION_FILE_SUCCESS =
  'APPRAISAL/UPLOAD_APPLICATION_FILE_SUCCESS';
export const UPLOAD_APPLICATION_FILE_ERROR =
  'APPRAISAL/UPLOAD_APPLICATION_FILE_ERROR';

export const UPDATE_APPLICATION_FILE_START =
  'APPRAISAL/UPDATE_APPLICATION_FILE_START';
export const UPDATE_APPLICATION_FILE_SUCCESS =
  'APPRAISAL/UPDATE_APPLICATION_FILE_SUCCESS';
export const UPDATE_APPLICATION_FILE_ERROR =
  'APPRAISAL/UPDATE_APPLICATION_FILE_ERROR';

export const DOWNLOAD_APPLICATION_FILE_START =
  'APPRAISAL/DOWNLOAD_APPLICATION_FILE_START';
export const DOWNLOAD_APPLICATION_FILE_SUCCESS =
  'APPRAISAL/DOWNLOAD_APPLICATION_FILE_SUCCESS';
export const DOWNLOAD_APPLICATION_FILE_ERROR =
  'APPRAISAL/DOWNLOAD_APPLICATION_FILE_ERROR';

export const RETRIEVE_APPLICATION_FILE = createRequestTypes(
  'APPRAISAL/RETRIEVE_APPLICATION_FILE',
);

export const DELETE_APPLICATION_FILE_START =
  'APPRAISAL/DELETE_APPLICATION_FILE_START';
export const DELETE_APPLICATION_FILE_SUCCESS =
  'APPRAISAL/DELETE_APPLICATION_FILE_SUCCESS';
export const DELETE_APPLICATION_FILE_ERROR =
  'APPRAISAL/DELETE_APPLICATION_FILE_ERROR';

export const SEARCH_APPLICATION_EVENTS_START =
  'APPRAISAL/SEARCH_APPLICATION_EVENTS_START';
export const SEARCH_APPLICATION_EVENTS_SUCCESS =
  'APPRAISAL/SEARCH_APPLICATION_EVENTS_SUCCESS';
export const SEARCH_APPLICATION_EVENTS_ERROR =
  'APPRAISAL/SEARCH_APPLICATION_EVENTS_ERROR';

export const FETCH_APPLICATION_EVENT_TAGS_START =
  'APPRAISAL/FETCH_APPLICATION_EVENT_TAGS_START';
export const FETCH_APPLICATION_EVENT_TAGS_SUCCESS =
  'APPRAISAL/FETCH_APPLICATION_EVENT_TAGS_SUCCESS';
export const FETCH_APPLICATION_EVENT_TAGS_ERROR =
  'APPRAISAL/FETCH_APPLICATION_EVENT_TAGS_ERROR';

export const FETCH_APPLICATION_EVENT_TYPES_START =
  'APPRAISAL/FETCH_APPLICATION_EVENT_TYPES_START';
export const FETCH_APPLICATION_EVENT_TYPES_SUCCESS =
  'APPRAISAL/FETCH_APPLICATION_EVENT_TYPES_SUCCESS';
export const FETCH_APPLICATION_EVENT_TYPES_ERROR =
  'APPRAISAL/FETCH_APPLICATION_EVENT_TYPES_ERROR';

export const FETCH_APPLICATION_EVENT_FORMS_START =
  'APPRAISAL/FETCH_APPLICATION_EVENT_FORMS_START';
export const FETCH_APPLICATION_EVENT_FORMS_SUCCESS =
  'APPRAISAL/FETCH_APPLICATION_EVENT_FORMS_SUCCESS';
export const FETCH_APPLICATION_EVENT_FORMS_ERROR =
  'APPRAISAL/FETCH_APPLICATION_EVENT_FORMS_ERROR';

export const SET_SELECTDATA = `${namespace}/SET_SELECTDATA`;

export const SET_SPLITPROPERTYDATA = `${namespace}/SET_SPLITPROPERTYDATA`;

export const SET_PRINT_CARD_DATA = `${namespace}/SET_PRINT_CARD_DATA`;

export const PROPERTY_CREATE = createRequestTypes('APPRAISAL/PROPERTY_CREATE');
export const PROPERTY_FETCH_MENU_PROFILES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_MENU_PROFILES',
);
export const PROPERTY_FETCH_SUB_PAGE = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_SUB_PAGE',
);

export const PROPERTY_FETCH_HEADER = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_HEADER',
);
export const PROPERTY_FETCH_SUMMARY = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_SUMMARY',
);
export const PROPERTY_FETCH_OWNER_SUMMARY = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_OWNER_SUMMARY',
);
export const PROPERTY_CLEAR_SUMMARY = 'APPRAISAL/PROPERTY_CLEAR_SUMMARY';

export const PROPERTY_FETCH_LEGAL_DESCRIPTION = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_LEGAL_DESCRIPTION',
);
export const PROPERTY_FETCH_MOBILE_HOMES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_MOBILE_HOMES',
);
export const PROPERTY_UPDATE_LEGAL_DESCRIPTION = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_LEGAL_DESCRIPTION',
);
export const PROPERTY_FETCH_MINERAL_LEGAL_DESCRIPTION = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_MINERAL_LEGAL_DESCRIPTION',
);
export const PROPERTY_UPDATE_MINERAL_LEGAL_DESCRIPTION = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_MINERAL_LEGAL_DESCRIPTION',
);
export const FETCH_AUTO_COMPLETE_MINERAL_LEGAL = createRequestTypes(
  'APPRAISAL/FETCH_AUTO_COMPLETE_MINERAL_LEGAL',
);

export const PROPERTY_FETCH_IDENTIFICATION = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_IDENTIFICATION',
);
export const PROPERTY_UPDATE_IDENTIFICATION = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_IDENTIFICATION',
);
export const PROPERTY_FETCH_SUMMARY_BPP = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_SUMMARY_BPP',
);
export const PROPERTY_FETCH_CHARACTERISTICS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_CHARACTERISTICS',
);
export const PROPERTY_UPDATE_CHARACTERISTICS = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_CHARACTERISTICS',
);

export const PROPERTY_FETCH_PRIMARY_OWNER = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_PRIMARY_OWNER',
);

export const PROPERTY_ADD_DUMMY_TAXING_UNIT =
  'APPRAISAL/PROPERTY_ADD_DUMMY_TAXING_UNIT';

export const PROPERTY_FETCH_TAXING_UNITS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_TAXING_UNITS',
);
export const PROPERTY_UPDATE_BUILDER_ADJUSTMENTS = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_BUILDER_ADJUSTMENTS',
);
export const PROPERTY_GET_BUILDER_ADJUSTMENTS = createRequestTypes(
  'APPRAISAL/PROPERTY_GET_BUILDER_ADJUSTMENTS',
);
export const PROPERTY_FETCH_ALL_TAXING_UNITS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_ALL_TAXING_UNITS',
);
export const PROPERTY_CREATE_TAXING_UNIT = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_TAXING_UNIT',
);
export const PROPERTY_UPDATE_TAXING_UNIT = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_TAXING_UNIT',
);
export const PROPERTY_DELETE_TAXING_UNIT = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_TAXING_UNIT',
);
export const PROPERTY_FETCH_DROPDOWNS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_DROPDOWNS',
);

export const PROPERTY_FETCH_OWNERS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_OWNERS',
);
export const PROPERTY_FETCH_EXEMPTIONS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_EXEMPTIONS',
);
export const PROPERTY_FETCH_EXEMPTION = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_EXEMPTION',
);
export const PROPERTY_CLEAR_EXEMPTIONS = 'APPRAISAL/PROPERTY_CLEAR_EXEMPTIONS';

export const PROPERTY_CREATE_EXEMPTION = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_EXEMPTION',
);
export const CLEAR_EXEMPTIONS = 'APPRAISAL/CLEAR_EXEMPTIONS';
export const PROPERTY_DELETE_EXEMPTION = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_EXEMPTION',
);
export const PROPERTY_UPDATE_EXEMPTION = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_EXEMPTION',
);
export const FETCH_EXEMPTION = createRequestTypes('APPRAISAL/FETCH_EXEMPTION');
export const PROPERTY_RESET_EXEMPTION = 'APPRAISAL/PROPERTY_RESET_EXEMPTION';

export const UPDATE_EVENT_SEARCH_VALUE = 'APPRAISAL/UPDATE_EVENT_SEARCH_VALUE';

export function updateEventSearchValue(data) {
  return async (dispatch) => {
    dispatch({ type: UPDATE_EVENT_SEARCH_VALUE, payload: data });
  };
}

export const PROPERTY_FETCH_EVENTS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_EVENTS',
);
export const PROPERTY_CREATE_EVENT = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_EVENT',
);
export const PROPERTY_UPDATE_EVENT = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_EVENT',
);
export const PROPERTY_DELETE_EVENT = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_EVENT',
);
export const PROPERTY_UPDATE_EVENT_TAG_OBJECT = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_EVENT_TAG_OBJECT',
);
export const PROPERTY_FETCH_PRIMARY_SITUS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_PRIMARY_SITUS',
);
export const PROPERTY_FETCH_ALL_SITUS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_ALL_SITUS',
);
export const PROPERTY_CREATE_SITUS = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_SITUS',
);
export const PROPERTY_DELETE_SITUS = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_SITUS',
);
export const PROPERTY_SET_PRIMARY_SITUS = createRequestTypes(
  'APPRAISAL/PROPERTY_SET_PRIMARY_SITUS',
);
export const PROPERTY_UPDATE_SITUS = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_SITUS',
);
export const FETCH_WORK_ITEM_TYPES = createRequestTypes(
  'APPRAISAL/FETCH_WORK_ITEM_TYPES',
);
export const INSERT_WORK_ITEM = createRequestTypes(
  'APPRAISAL/INSERT_WORK_ITEM',
);
export const INSERT_WORK_ITEM_AND_PROPERTIES = createRequestTypes(
  'APPRAISAL/INSERT_WORK_ITEM_AND_PROPERTIES',
);
export const INSERT_WORK_ITEM_PROPERTY = createRequestTypes(
  'APPRAISAL/INSERT_WORK_ITEM_PROPERTY',
);
export const INSERT_WORK_ITEM_INTEGRITY_CHECK = createRequestTypes(
  'APPRAISAL/INSERT_WORK_ITEM_INTEGRITY_CHECK',
);
export const INSERT_WORK_ITEM_FILE = createRequestTypes(
  'APPRAISAL/INSERT_WORK_ITEM_FILE',
);
export const DELETE_WORK_ITEM_FILE = createRequestTypes(
  'APPRAISAL/DELETE_WORK_ITEM_FILE',
);
export const DOWNLOAD_WORK_ITEM_FILE = createRequestTypes(
  'APPRAISAL/DOWNLOAD_WORK_ITEM_FILE',
);
export const FETCH_WORK_ITEM_FILES = createRequestTypes(
  'APPRAISAL/FETCH_WORK_ITEM_FILES',
);
export const EDIT_RENDITION_EXTENSION_FILE = createRequestTypes(
  'APPRAISAL/EDIT_RENDITION_EXTENSION_FILE',
);
export const INSERT_RENDITION_EXTENSION_FILE = createRequestTypes(
  'APPRAISAL/INSERT_RENDITION_EXTENSION_FILE',
);
export const DELETE_RENDITION_EXTENSION_FILE = createRequestTypes(
  'APPRAISAL/DELETE_RENDITION_EXTENSION_FILE',
);
export const DOWNLOAD_RENDITION_EXTENSION_FILE = createRequestTypes(
  'APPRAISAL/DOWNLOAD_RENDITION_EXTENSION_FILE',
);
export const FETCH_RENDITION_EXTENSION_FILES = createRequestTypes(
  'APPRAISAL/FETCH_RENDITION_EXTENSION_FILES',
);
export const INSERT_LATE_PENALTY_FILE = createRequestTypes(
  'APPRAISAL/INSERT_LATE_PENALTY_FILE',
);
export const DELETE_LATE_PENALTY_FILE = createRequestTypes(
  'APPRAISAL/DELETE_LATE_PENALTY_FILE',
);
export const EDIT_LATE_PENALTY_FILE = createRequestTypes(
  'APPRAISAL/EDIT_LATE_PENALTY_FILE',
);
export const DOWNLOAD_LATE_PENALTY_FILE = createRequestTypes(
  'APPRAISAL/DOWNLOAD_LATE_PENALTY_FILE',
);
export const FETCH_LATE_PENALTY_FILES = createRequestTypes(
  'APPRAISAL/FETCH_LATE_PENALTY_FILES',
);
export const FETCH_PROPERTY_VALUE_READY = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_VALUE_READY',
);
export const UPDATE_PROPERTY_VALUE_READY = createRequestTypes(
  'APPRAISAL/UPDATE_PROPERTY_VALUE_READY',
);
export const UPDATE_PROPERTY_SPECIAL_USE_RESET = createRequestTypes(
  'APPRAISAL/UPDATE_PROPERTY_SPECIAL_USE_RESET',
);
export const PROPERTY_FETCH_VALUATION_TYPES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_VALUATION_TYPES',
);
export const PROPERTY_FETCH_IMPROVEMENT_TYPES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_IMPROVEMENT_TYPES',
);
export const PROPERTY_SET_VALUATION_WIDGET_STATE =
  'APPRAISAL/PROPERTY_SET_VALUATION_WIDGET_STATE';

export const PROPERTY_FETCH_VALUATIONS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_VALUATIONS',
);
export const PROPERTY_MARKET_INCLUDE_PRESENTATION = createRequestTypes(
  'APPRAISAL/PROPERTY_MARKET_INCLUDE_PRESENTATION',
);
export const PROPERTY_EQUITY_INCLUDE_PRESENTATION = createRequestTypes(
  'APPRAISAL/PROPERTY_EQUITY_INCLUDE_PRESENTATION',
);
export const PROPERTY_CREATE_VALUATION = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_VALUATION',
);
export const PROPERTY_SET_PRIMARY_VALUATION = createRequestTypes(
  'APPRAISAL/PROPERTY_SET_PRIMARY_VALUATION',
);
export const PROPERTY_UPDATE_VALUATION = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_VALUATION',
);
export const PROPERTY_DELETE_VALUATION = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_VALUATION',
);
export const PROPERTY_DISTRIBUTE_VALUATION = createRequestTypes(
  'APPRAISAL/PROPERTY_DISTRIBUTE_VALUATION',
);
export const PROPERTY_FETCH_IMPROVEMENTS = createRequestTypes(
  'PROPERTY_FETCH_IMPROVEMENTS',
);
export const PROPERTY_CREATE_IMPROVEMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_IMPROVEMENT',
);
export const PROPERTY_UPDATE_IMPROVEMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_IMPROVEMENT',
);
export const PROPERTY_DELETE_IMPROVEMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_IMPROVEMENT',
);
export const PROPERTY_FETCH_IMPROVEMENT_DETAILS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_IMPROVEMENT_DETAILS',
);
export const PROPERTY_CREATE_IMPROVEMENT_DETAIL = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_IMPROVEMENT_DETAIL',
);
export const PROPERTY_UPDATE_IMPROVEMENT_DETAIL = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_IMPROVEMENT_DETAIL',
);
export const PROPERTY_DELETE_IMPROVEMENT_DETAIL = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_IMPROVEMENT_DETAIL',
);
export const PROPERTY_FETCH_IMPROVEMENT_DETAIL_FEATURES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_IMPROVEMENT_DETAIL_FEATURES',
);
export const PROPERTY_SAVE_IMPROVEMENT_DETAIL_FEATURES = createRequestTypes(
  'APPRAISAL/PROPERTY_SAVE_IMPROVEMENT_DETAIL_FEATURES',
);
export const PROPERTY_CREATE_LAND = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_LAND',
);
export const PROPERTY_FETCH_LAND = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_LAND',
);
export const PROPERTY_UPDATE_LAND = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_LAND',
);
export const PROPERTY_DELETE_LAND = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_LAND',
);
export const PROPERTY_FETCH_SUBCOMPONENT_CONFIG = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_SUBCOMPONENT_CONFIG',
);
export const PROPERTY_FETCH_IMPROVEMENT_ADJUSTMENTS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_IMPROVEMENT_ADJUSTMENTS',
);
export const PROPERTY_FETCH_IMPROVEMENT_ADJUST_TYPES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_IMPROVEMENT_ADJUST_TYPES',
);
export const PROPERTY_CREATE_IMPROVEMENT_ADJUSTMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_IMPROVEMENT_ADJUSTMENT',
);
export const PROPERTY_UPDATE_IMPROVEMENT_ADJUSTMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_IMPROVEMENT_ADJUSTMENT',
);
export const PROPERTY_DELETE_IMPROVEMENT_ADJUSTMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_IMPROVEMENT_ADJUSTMENT',
);
export const PROPERTY_FETCH_LAND_ADJUSTMENTS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_LAND_ADJUSTMENTS',
);
export const PROPERTY_FETCH_LAND_ADJUST_TYPES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_LAND_ADJUST_TYPES',
);
export const PROPERTY_CREATE_LAND_ADJUSTMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_LAND_ADJUSTMENT',
);
export const PROPERTY_UPDATE_LAND_ADJUSTMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_LAND_ADJUSTMENT',
);
export const PROPERTY_DELETE_LAND_ADJUSTMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_LAND_ADJUSTMENT',
);
export const PROPERTY_FETCH_IMPRV_DETAIL_ADJUSTMENTS = createRequestTypes(
  'APPRAISAL/POPERTY_FETCH_IMPRV_DETAIL_ADJUSTMENTS',
);
export const PROPERTY_FETCH_IMPRV_DETAIL_ADJUST_TYPES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_IMPRV_DETAIL_ADJUST_TYPES',
);
export const PROPERTY_CREATE_IMPRV_DETAIL_ADJUSTMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_IMPRV_DETAIL_ADJUSTMENT',
);
export const PROPERTY_UPDATE_IMPRV_DETAIL_ADJUSTMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_IMPRV_DETAIL_ADJUSTMENT',
);
export const PROPERTY_DELETE_IMPRV_DETAIL_ADJUSTMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_IMPRV_DETAIL_ADJUSTMENT',
);

export const ZILLOW_ZESTIMATE_FETCH = createRequestTypes(
  'APPRAISAL/ZILLOW_ZESTIMATE_FETCH',
);
export const ZILLOW_ZPROPERTY_FETCH = createRequestTypes(
  'APPRAISAL/ZILLOW_ZPROPERTY_FETCH',
);
export const ZILLOW_ZCOMPS_FETCH = createRequestTypes(
  'APPRAISAL/ZILLOW_ZCOMPS_FETCH',
);
export const ZILLOW_PROPERTY_HEADER_FETCH = createRequestTypes(
  'APPRAISAL/ZILLOW_PROPERTY_HEADER_FETCH',
);

export const PROPERTY_FETCH_IMPROVEMENT_INFLUENCER = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_IMPROVEMENT_INFLUENCER',
);
export const PROPERTY_UPDATE_IMPROVEMENT_INFLUENCER = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_IMPROVEMENT_INFLUENCER',
);
export const PROPERTY_FETCH_LAND_INFLUENCER = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_LAND_INFLUENCER',
);
export const PROPERTY_UPDATE_LAND_INFLUENCER = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_LAND_INFLUENCER',
);
export const PROPERTY_FETCH_IMPRV_DETAIL_INFLUENCER = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_IMPRV_DETAIL_INFLUENCER',
);
export const PROPERTY_UPDATE_IMPRV_DETAIL_INFLUENCER = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_IMPRV_DETAIL_INFLUENCER',
);

export const PROPERTY_CREATE_LAND_NOTE = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_LAND_NOTE',
);
export const PROPERTY_FETCH_LAND_NOTES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_LAND_NOTES',
);
export const PROPERTY_UPDATE_LAND_NOTE = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_LAND_NOTE',
);
export const PROPERTY_DELETE_LAND_NOTE = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_LAND_NOTE',
);

export const PROPERTY_FETCH_SIZE = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_SIZE',
);
export const PROPERTY_FETCH_EXEMPTION_CARD = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_EXEMPTION_CARD',
);
export const PROPERTY_FETCH_VALUE_SUMMARY = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_VALUE_SUMMARY',
);

export const PROPERTY_RECALCULATE = createRequestTypes(
  'APPRAISAL/PROPERTY_RECALCULATE',
);

export const PROPERTY_MASS_CREATE_FETCH = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_FETCH',
);

export const PROPERTY_INDIVIDUAL_MASS_CREATE_FETCH = createRequestTypes(
  'APPRAISAL/PROPERTY_INDIVIDUAL_MASS_CREATE_FETCH',
);

export const PROPERTY_MASS_CREATE_CREATE = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_CREATE',
);

export const PROPERTY_MASS_CREATE_PREP_DATA = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_PREP_DATA',
);

export const PROPERTY_MASS_CREATE_LEGAL_DESC = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_LEGAL_DESC',
);

export const PROPERTY_MASS_CREATE_CLEAR_PREP_DATA =
  'APPRAISAL/PROPERTY_MASS_CREATE_CLEAR_PREP_DATA';

export const PROPERTY_MASS_CREATE_CREATE_PROPERTIES = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_CREATE_PROPERTIES',
);

export const PROPERTY_MASS_CREATE_FINALIZE = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_FINALIZE',
);

export const PROPERTY_MASS_CREATE_PROPERTIES = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_PROPERTIES',
);

export const PROPERTY_MASS_CREATE_DELETE = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_DELETE',
);

export const PROPERTY_MASS_CREATE_SETTINGS_FETCH_ALL = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_SETTINGS_FETCH_ALL',
);

export const PROPERTY_MASS_CREATE_SETTING_FETCH = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_SETTING_FETCH',
);

export const PROPERTY_MASS_CREATE_SETTING_DELETE = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_SETTING_DELETE',
);

export const PROPERTY_MASS_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES =
  createRequestTypes(
    'APPRAISAL/PROPERTY_MASS_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES',
  );

export const PROPERTY_MASS_CREATE_SETTING_ADD = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_SETTING_ADD',
);

export const PROPERTY_MASS_CREATE_SETTING_EDIT = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_SETTING_EDIT',
);

export const PROPERTY_MASS_CREATE_PAGE_FETCH = createRequestTypes(
  'APPRAISAL/PROPERTY_MASS_CREATE_PAGE_FETCH',
);

export const OPEN_PROPERTY_LOOKUP_MODAL =
  'APPRAISAL/OPEN_PROPERTY_LOOKUP_MODAL';
export const CLOSE_PROPERTY_LOOKUP_MODAL =
  'APPRAISAL/CLOSE_PROPERTY_LOOKUP_MODAL';
export const LOOKUP_PROPERTY = createRequestTypes('APPRAISAL/LOOKUP_PROPERTY');
export const MODAL_SELECT_PROPERTY_RECORDS =
  'APPRAISAL/MODAL_SELECT_PROPERTY_RECORDS';

export const PROPERTY_EXEMPTION_RESET_UPDATE = createRequestTypes(
  'APPRAISAL/PROPERTY_EXEMPTION_RESET_UPDATE',
);
export const PROPERTY_TAX_DEFERRAL_UPDATE = createRequestTypes(
  'APPRAISAL/PROPERTY_TAX_DEFERRAL_UPDATE',
);
export const PROPERTY_TAX_DEFERRAL_FETCH = createRequestTypes(
  'APPRAISAL/PROPERTY_TAX_DEFERRAL_FETCH',
);

export const WALKTHROUGH_SETTINGS_POST = createRequestTypes(
  'APPRAISAL/WALKTHROUGH_SETTINGS_POST',
);

export const WALKTHROUGH_SETTINGS_FETCH_ALL = createRequestTypes(
  'APPRAISAL/WALKTHROUGH_SETTINGS_FETCH_ALL',
);

export const WALKTHROUGH_SETTING_UPDATE = createRequestTypes(
  'APPRAISAL/WALKTHROUGH_SETTING_UPDATE',
);

export const WALKTHROUGH_SETTING_DELETE = createRequestTypes(
  'APPRAISAL/WALKTHROUGH_SETTING_DELETE',
);

export const PROPERTY_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES =
  createRequestTypes(
    'APPRAISAL/PROPERTY_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES',
  );

export const ADD_MERGE_PROPERTY = 'APPRAISAL/ADD_MERGE_PROPERTY';
export const REMOVE_MERGE_PROPERTY = 'APPRAISAL/REMOVE_MERGE_PROPERTY';
export const RESET_MERGE_PROPERTY = 'APPRAISAL/RESET_MERGE_PROPERTY';

export const CREATE_PROPERTY_MERGE = createRequestTypes(
  'APPRAISAL/CREATE_PROPERTY_MERGE',
);

export const UPLOAD_PROPERTY_MERGE_FILE = createRequestTypes(
  'APPRAISAL/UPLOAD_PROPERTY_MERGE_FILE',
);

export const FETCH_MERGE_TO_PROPERTY_OWNERS = createRequestTypes(
  'APPRAISAL/FETCH_MERGE_TO_PROPERTY_OWNERS',
);

export const FETCH_MERGE_FROM_PROPERTY_OWNERS = createRequestTypes(
  'APPRAISAL/FETCH_MERGE_FROM_PROPERTY_OWNERS',
);

export const CREATE_PROPERTY_SPLIT = createRequestTypes(
  'APPRAISAL/CREATE_PROPERTY_SPLIT',
);

export const UPDATE_OWNERSHIP_PERCENT = createRequestTypes(
  'APPRAISAL/UPDATE_OWNERSHIP_PERCENT',
);

export const UPDATE_LEGAL_ACREAGE = createRequestTypes(
  'APPRAISAL/UPDATE_LEGAL_ACREAGE',
);

export const GET_PROPERTY_INACTIVE_REASONS = createRequestTypes(
  'APPRAISAL/GET_PROPERTY_INACTIVE_REASONS',
);

export const GET_PROPERTY_REACTIVATE_REASONS = createRequestTypes(
  'APPRAISAL/GET_PROPERTY_REACTIVATE_REASONS',
);

export const PROPERTY_INACTIVATE = createRequestTypes(
  'APPRAISAL/PROPERTY_INACTIVATE',
);

export const PROPERTY_REACTIVATE = createRequestTypes(
  'APPRAISAL/PROPERTY_REACTIVATE',
);

export const GET_SPLIT_REASONS = createRequestTypes(
  'APPRAISAL/GET_SPLIT_REASONS',
);

export const RESET_PROPERTY_SPLIT_DATA = 'APPRAISAL/RESET_PROPERTY_SPLIT_DATA';

export const FETCH_SPLIT_MERGE_HISTORY_DEED_INFO = createRequestTypes(
  'APPRAISAL/FETCH_SPLIT_MERGE_HISTORY_DEED_INFO',
);

export const UPDATE_SPLIT_MERGE_HISTORY_CHILDREN = createRequestTypes(
  'APPRAISAL/UPDATE_SPLIT_MERGE_HISTORY_CHILDREN',
);

export const FETCH_SPLIT_MERGE_HISTORY_SUMMARY = createRequestTypes(
  'APPRAISAL/FETCH_SPLIT_MERGE_HISTORY_SUMMARY',
);

export const CREATE_SINGLE_PROPERTY = createRequestTypes(
  'APPRAISAL/CREATE_SINGLE_PROPERTY',
);

export const DELETE_SINGLE_PROPERTY = createRequestTypes(
  'APPRAISAL/DELETE_SINGLE_PROPERTY',
);

export const FETCH_ALL_VALUATIONS_BPP = createRequestTypes(
  'APPRAISAL/FETCH_ALL_VALUATIONS_BPP',
);

export const FETCH_BPP_SUB_DETAILS = createRequestTypes(
  'APPRAISAL/FETCH_BPP_SUB_DETAILS',
);

export const CREATE_BPP_SUB_DETAIL = createRequestTypes(
  'APPRAISAL/CREATE_BPP_SUB_DETAIL',
);

export const UPDATE_BPP_SUB_DETAIL = createRequestTypes(
  'APPRAISAL/UPDATE_BPP_SUB_DETAIL',
);

export const DELETE_BPP_SUB_DETAIL = createRequestTypes(
  'APPRAISAL/DELETE_BPP_SUB_DETAIL',
);

export const DELETE_ALL_BPP_SUB_DETAILS = createRequestTypes(
  'APPRAISAL/DELETE_ALL_BPP_SUB_DETAILS',
);

export const MASS_UPDATE_BPP_SUB_DETAIL = createRequestTypes(
  'APPRAISAL/MASS_UPDATE_BPP_SUB_DETAIL',
);

export const PROPERTY_CREATE_VALUATION_BPP = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_VALUATION_BPP',
);

export const PROPERTY_CREATE_ECONOMIC_VALUATION = createRequestTypes(
  'APPRAISAL/PROPERTY_CREATE_ECONOMIC_VALUATION',
);

export const FETCH_PERSONAL_DEPRECIATION_CATEGORY_METHODS = createRequestTypes(
  'APPRAISAL/FETCH_PERSONAL_DEPRECIATION_CATEGORY_METHODS',
);

export const FETCH_PERSONAL_DETAIL_SUMMARY = createRequestTypes(
  'APPRAISAL/FETCH_PERSONAL_DETAIL_SUMMARY',
);

export const FETCH_ALL_PERSONAL_DETAILS = createRequestTypes(
  'APPRAISAL/FETCH_ALL_PERSONAL_DETAILS',
);

export const EXPORT_ALL_PERSONAL_DETAILS = createRequestTypes(
  'APPRAISAL/EXPORT_ALL_PERSONAL_DETAILS',
);

export const FETCH_PERSONAL_DETAIL = createRequestTypes(
  'APPRAISAL/FETCH_PERSONAL_DETAIL',
);

export const INSERT_PERSONAL_DETAIL = createRequestTypes(
  'APPRAISAL/INSERT_PERSONAL_DETAIL',
);

export const UPDATE_PERSONAL_DETAIL = createRequestTypes(
  'APPRAISAL/UPDATE_PERSONAL_DETAIL',
);

export const DELETE_PERSONAL_DETAIL = createRequestTypes(
  'APPRAISAL/DELETE_PERSONAL_DETAIL',
);

export const DELETE_ALL_PERSONAL_DETAILS = createRequestTypes(
  'APPRAISAL/DELETE_ALL_PERSONAL_DETAILS',
);

export const FETCH_PERSONAL_DETAIL_TAXING_UNITS = createRequestTypes(
  'APPRAISAL/FETCH_PERSONAL_DETAIL_TAXING_UNITS',
);

export const INSERT_PERSONAL_DETAIL_TAXING_UNIT = createRequestTypes(
  'APPRAISAL/INSERT_PERSONAL_DETAIL_TAXING_UNIT',
);

export const UPDATE_PERSONAL_DETAIL_TAXING_UNIT = createRequestTypes(
  'APPRAISAL/UPDATE_PERSONAL_DETAIL_TAXING_UNIT',
);

export const DELETE_PERSONAL_DETAIL_TAXING_UNIT = createRequestTypes(
  'APPRAISAL/DELETE_PERSONAL_DETAIL_TAXING_UNIT',
);

export const FETCH_VALUATION_BPP_TYPES = createRequestTypes(
  'APPRAISAL/FETCH_VALUATION_BPP_TYPES',
);

export const UPDATE_VALUATION_BPP = createRequestTypes(
  'APPRAISAL/UPDATE_VALUATION_BPP',
);

export const FETCH_ALL_RENDITIONS_BPP = createRequestTypes(
  'APPRAISAL/FETCH_ALL_RENDITIONS_BPP',
);

export const RESET_RENDITIONS_BPP = 'APPRAISAL/RESET_RENDITIONS_BPP';

export const INSERT_PERSONAL_RENDITION = createRequestTypes(
  'APPRAISAL/INSERT_PERSONAL_RENDITION',
);

export const UPDATE_PERSONAL_RENDITION = createRequestTypes(
  'APPRAISAL/UPDATE_PERSONAL_RENDITION',
);

export const PERSONAL_RENDITION_ACTIVATE = createRequestTypes(
  'APPRAISAL/PERSONAL_RENDITION_ACTIVATE',
);

export const PERSONAL_RENDITION_DEACTIVATE = createRequestTypes(
  'APPRAISAL/PERSONAL_RENDITION_DEACTIVATE',
);

export const DELETE_PERSONAL_RENDITION = createRequestTypes(
  'APPRAISAL/DELETE_PERSONAL_RENDITION',
);

export const INSERT_PERSONAL_RENDITION_FILES = createRequestTypes(
  'APPRAISAL/INSERT_PERSONAL_RENDITION_FILES',
);

export const UPDATE_PERSONAL_RENDITION_FILE = createRequestTypes(
  'APPRAISAL/UPDATE_PERSONAL_RENDITION_FILE',
);

export const FETCH_PERSONAL_RENDITION_FILE = createRequestTypes(
  'APPRAISAL/FETCH_PERSONAL_RENDITION_FILE',
);

export const DELETE_PERSONAL_RENDITION_FILE = createRequestTypes(
  'APPRAISAL/DELETE_PERSONAL_RENDITION_FILE',
);

export const openPropertyLookupModal = (params) => ({
  type: OPEN_PROPERTY_LOOKUP_MODAL,
  payload: params,
});

export const VERIFY_PERSONAL_RENDITION = createRequestTypes(
  'APPRAISAL/VERIFY_PERSONAL_RENDITION',
);

export const UNVERIFY_PERSONAL_RENDITION = createRequestTypes(
  'APPRAISAL/UNVERIFY_PERSONAL_RENDITION',
);

export const FETCH_PRIMARY_OWNER_DETAILS = createRequestTypes(
  'APPRAISAL/FETCH_PRIMARY_OWNER_DETAILS',
);

export const CLEAR_PRIMARY_OWNER_DETAILS =
  'APPRAISAL/CLEAR_PRIMARY_OWNER_DETAILS';

export const FETCH_PREVIOUS_YEAR_DETAILS = createRequestTypes(
  'APPRAISAL/FETCH_PREVIOUS_YEAR_DETAILS',
);

export const INSERT_PERSONAL_DETAIL_RENDITION = createRequestTypes(
  'APPRAISAL/INSERT_PERSONAL_DETAIL_RENDITION',
);

export const FETCH_CAN_PROCESS_RENDITION = createRequestTypes(
  'APPRAISAL/FETCH_CAN_PROCESS_RENDITION',
);

export const DELETE_RENDITION_WALKTHRU_DETAIL =
  'APPRAISAL/DELETE_RENDITION_WALKTHRU_DETAIL';

export const DELETE_ALL_RENDITION_WALKTHRU_DETAILS =
  'APPRAISAL/DELETE_ALL_RENDITION_WALKTHRU_DETAILS';

export const INSERT_RENDITION_WALKTHRU_DETAIL =
  'APPRAISAL/INSERT_RENDITION_WALKTHRU_DETAIL';

export const UPDATE_RENDITION_WALKTHRU_DETAIL =
  'APPRAISAL/UPDATE_RENDITION_WALKTHRU_DETAIL';

export const EXEMPTION_NOTES_FETCH_START =
  'APPRAISAL/EXEMPTION_NOTES_FETCH_START';
export const EXEMPTION_NOTES_FETCH_SUCCESS =
  'APPRAISAL/EXEMPTION_NOTES_FETCH_SUCCESS';
export const EXEMPTION_NOTES_FETCH_ERROR =
  'APPRAISAL/EXEMPTION_NOTES_FETCH_ERROR';

export const EXEMPTION_NOTE_ADD_START = 'APPRAISAL/EXEMPTION_NOTE_ADD_START';
export const EXEMPTION_NOTE_ADD_SUCCESS =
  'APPRAISAL/EXEMPTION_NOTE_ADD_SUCCESS';
export const EXEMPTION_NOTE_ADD_ERROR = 'APPRAISAL/EXEMPTION_NOTE_ADD_ERROR';

export const EXEMPTION_NOTE_UPDATE_START =
  'APPRAISAL/EXEMPTION_NOTE_UPDATE_START';
export const EXEMPTION_NOTE_UPDATE_SUCCESS =
  'APPRAISAL/EXEMPTION_NOTE_UPDATE_SUCCESS';
export const EXEMPTION_NOTE_UPDATE_ERROR =
  'APPRAISAL/EXEMPTION_NOTE_UPDATE_ERROR';

export const EXEMPTION_NOTE_DELETE_START =
  'APPRAISAL/EXEMPTION_NOTE_DELETE_START';
export const EXEMPTION_NOTE_DELETE_SUCCESS =
  'APPRAISAL/EXEMPTION_NOTE_DELETE_SUCCESS';
export const EXEMPTION_NOTE_DELETE_ERROR =
  'APPRAISAL/EXEMPTION_NOTE_DELETE_ERROR';

export const FETCH_ALL_DISTINCT_EXEMPTIONS = createRequestTypes(
  'APPRAISAL/FETCH_ALL_DISTINCT_EXEMPTIONS',
);

export const FETCH_CURRENT_APPLICATION_OWNERS = createRequestTypes(
  'APPRAISAL/FETCH_CURRENT_APPLICATION_OWNERS',
);

export const FETCH_HS_DETAILS = createRequestTypes(
  'APPRAISAL/FETCH_HS_DETAILS',
);

export const PROPERTY_FETCH_MARKET_MODIFIERS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_MARKET_MODIFIERS',
);

export const PROPERTY_FETCH_OWNER_NAMES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_OWNER_NAMES',
);

export const PROPERTY_FETCH_TAXABLES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_TAXABLES',
);

export const PROPERTY_FETCH_TAXABLE_DETAILS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_TAXABLE_DETAILS',
);

export const PROPERTY_FETCH_TAXING_UNIT_SPLIT_BOUNDARY_LINES =
  createRequestTypes(
    'APPRAISAL/PROPERTY_FETCH_TAXING_UNIT_SPLIT_BOUNDARY_LINES',
  );

export const TAXING_UNIT_SPLIT_BOUNDARY_LINES_UPDATE = createRequestTypes(
  'APPRAISAL/TAXING_UNIT_SPLIT_BOUNDARY_LINES_UPDATE',
);

export const PROPERTY_FETCH_TAXING_UNIT_SEGMENTS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_TAXING_UNIT_SEGMENTS',
);

export const PROPERTY_FETCH_TAXING_UNIT_SEGMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_TAXING_UNIT_SEGMENT',
);

export const PROPERTY_UPDATE_TAXING_UNIT_SEGMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_TAXING_UNIT_SEGMENT',
);

export const PROPERTY_FETCH_SMART_GROUPS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_SMART_GROUPS',
);

export const PROPERTY_FETCH_SMART_GROUP_PROPERTIES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_SMART_GROUP_PROPERTIES',
);

export const PROPERTY_INSERT_SMART_GROUP_PROPERTY = createRequestTypes(
  'APPRAISAL/PROPERTY_INSERT_SMART_GROUP_PROPERTY',
);

export const PROPERTY_DELETE_SMART_GROUP_PROPERTY = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_SMART_GROUP_PROPERTY',
);

export const PROPERTY_FETCH_SMART_GROUP = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_SMART_GROUP',
);

export const PROPERTY_EXCLUDE_OWNER_FROM_HS_SMART_GROUP_CALC =
  createRequestTypes(
    'APPRAISAL/PROPERTY_EXCLUDE_OWNER_FROM_HS_SMART_GROUP_CALC',
  );

export const PROPERTY_UPDATE_SMART_GROUP = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_SMART_GROUP',
);

export const PROPERTY_INSERT_SMART_GROUP_FILE = createRequestTypes(
  'APPRAISAL/PROPERTY_INSERT_SMART_GROUP_FILE',
);

export const PROPERTY_DELETE_SMART_GROUP_FILE = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_SMART_GROUP_FILE',
);

export const PROPERTY_DOWNLOAD_SMART_GROUP_FILE = createRequestTypes(
  'APPRAISAL/PROPERTY_DOWNLOAD_SMART_GROUP_FILE',
);

export const PROPERTY_UPDATE_SMART_GROUP_FILE = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_SMART_GROUP_FILE',
);

export const FETCH_PROPERTY_LINKS = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_LINKS',
);

export const PROPERTY_LINK_DELETE = createRequestTypes(
  'APPRAISAL/PROPERTY_LINK_DELETE',
);

export const PROPERTY_LINK_INSERT = createRequestTypes(
  'APPRAISAL/PROPERTY_LINK_INSERT',
);

export const SKETCH_SEARCH_START = 'APPRAISAL/SKETCH_SEARCH_START';
export const SKETCH_SEARCH_SUCCESS = 'APPRAISAL/SKETCH_SEARCH_SUCCESS';
export const SKETCH_SEARCH_ERROR = 'APPRAISAL/SKETCH_SEARCH_ERROR';
export const sketchSearch = makeApiActionCreatorV3(
  api.sketchSearch,
  SKETCH_SEARCH_START,
  SKETCH_SEARCH_SUCCESS,
  SKETCH_SEARCH_ERROR,
);

export const LINK_SKETCH_START = 'APPRAISAL/LINK_SKETCH_START';
export const LINK_SKETCH_SUCCESS = 'APPRAISAL/LINK_SKETCH_SUCCESS';
export const LINK_SKETCH_ERROR = 'APPRAISAL/LINK_SKETCH_ERROR';
export const linkSketch = makeApiActionCreatorV3(
  api.linkSketch,
  LINK_SKETCH_START,
  LINK_SKETCH_SUCCESS,
  LINK_SKETCH_ERROR,
);

export const PROPERTY_FETCH_SMART_GROUP_TYPES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_SMART_GROUP_TYPES',
);

export const PROPERTY_INSERT_SMART_GROUP = createRequestTypes(
  'APPRAISAL/PROPERTY_INSERT_SMART_GROUP',
);

export const PROPERTY_FETCH_SMART_GROUPS_BY_SEARCH = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_SMART_GROUPS_BY_SEARCH',
);

export const PROPERTY_RESET_SMART_GROUPS_BY_SEARCH =
  'APPRAISAL/PROPERTY_RESET_SMART_GROUPS_BY_SEARCH';

export const PROPERTY_SMART_GROUP_RESET =
  'APPRAISAL/PROPERTY_SMART_GROUP_RESET';

export const PROPERTY_FETCH_INSPECTIONS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_INSPECTIONS',
);

export const PROPERTY_INSPECTIONS_RESET =
  'APPRAISAL/PROPERTY_INSPECTIONS_RESET';

export const PROPERTY_INSERT_INSPECTION = createRequestTypes(
  'APPRAISAL/PROPERTY_INSERT_INSPECTION',
);

export const PROPERTY_FETCH_REASON_CODES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_REASON_CODES',
);

export const PROPERTY_FETCH_INSPECTION = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_INSPECTION',
);

export const PROPERTY_INSERT_INSPECTION_TAGS = createRequestTypes(
  'APPRAISAL/PROPERTY_INSERT_INSPECTION_TAGS',
);

export const PROPERTY_UPDATE_INSPECTION = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_INSPECTION',
);

export const PROPERTY_INSERT_INSPECTION_FILE = createRequestTypes(
  'APPRAISAL/PROPERTY_INSERT_INSPECTION_FILE',
);

export const PROPERTY_DELETE_INSPECTION_FILE = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_INSPECTION_FILE',
);

export const PROPERTY_DOWNLOAD_INSPECTION_FILE = createRequestTypes(
  'APPRAISAL/PROPERTY_DOWNLOAD_INSPECTION_FILE',
);

export const PROPERTY_UPDATE_INSPECTION_FILE = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_INSPECTION_FILE',
);

export const PROPERTY_FETCH_APPRAISERS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_APPRAISERS',
);

export const PROPERTY_UPDATE_APPRAISERS = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_APPRAISERS',
);

export const PROPERTY_DELETE_INSPECTION = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_INSPECTION',
);

export const PROPERTY_FETCH_PRIMARY_APPRAISER = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_PRIMARY_APPRAISER',
);

export const PROPERTY_FETCH_EDITABLE_STATUS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_EDITABLE_STATUS',
);

export const PROPERTY_FETCH_STATUS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_STATUS',
);

export const PROPERTY_DELETE_SMART_GROUP = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_SMART_GROUP',
);

export const PROPERTY_FETCH_PRIMARY_IMAGE_URL = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_PRIMARY_IMAGE_URL',
);

export const FETCH_OBJECT_EVENTS = createRequestTypes(
  'APPRAISAL/FETCH_OBJECT_EVENTS',
);

export const FETCH_PHOTOS_AND_DOCUMENTS = createRequestTypes(
  'APPRAISAL/FETCH_PHOTOS_AND_DOCUMENTS',
);

export const PROPERTY_FETCH_AGENT_SUMMARY = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_AGENT_SUMMARY',
);

export const PROPERTY_FETCH_AGENT_SUMMARY_LISTING = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_AGENT_SUMMARY_LISTING',
);

export const PROPERTY_FETCH_BUILDING_PERMITS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_BUILDING_PERMITS',
);

export const PROPERTY_RESET_BUILDING_PERMITS =
  'APPRAISAL/PROPERTY_RESET_BUILDING_PERMITS';

export const PROPERTY_FETCH_ALL_HS_VALUE_LIMITATIONS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_ALL_HS_VALUE_LIMITATIONS',
);

export const PROPERTY_UPDATE_HS_VALUE_LIMITATION = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_HS_VALUE_LIMITATION',
);

export const PROPERTY_FETCH_BUILDING_PERMIT_ISSUER_CODES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_BUILDING_PERMIT_ISSUER_CODES',
);

export const PROPERTY_FETCH_BUILDING_PERMIT_TYPES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_BUILDING_PERMIT_TYPES',
);

export const PROPERTY_FETCH_BUILDING_PERMIT_SUB_TYPES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_BUILDING_PERMIT_SUB_TYPES',
);

export const PROPERTY_FETCH_SPLIT_MERGE_HISTORY = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_SPLIT_MERGE_HISTORY',
);

export const PROPERTY_FETCH_BUILDING_PERMIT_STATUS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_BUILDING_PERMIT_STATUS',
);

export const PROPERTY_FETCH_BUILDING_PERMIT_CAD_STATUS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_BUILDING_PERMIT_CAD_STATUS',
);

export const PROPERTY_FETCH_BUILDING_PERMIT_PROPERTY_CATEGORIES =
  createRequestTypes(
    'APPRAISAL/PROPERTY_FETCH_BUILDING_PERMIT_PROPERTY_CATEGORIES',
  );

export const PROPERTY_INSERT_BUILDING_PERMIT = createRequestTypes(
  'APPRAISAL/PROPERTY_INSERT_BUILDING_PERMIT',
);

export const PROPERTY_UPDATE_BUILDING_PERMIT_TAGS = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_BUILDING_PERMIT_TAGS',
);

export const PROPERTY_FETCH_BUILDING_PERMIT = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_BUILDING_PERMIT',
);

export const PROPERTY_UPDATE_BUILDING_PERMIT = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_BUILDING_PERMIT',
);

export const PROPERTY_FETCH_BUILDING_PERMIT_PROPERTIES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_BUILDING_PERMIT_PROPERTIES',
);

export const PROPERTY_INSERT_BUILDING_PERMIT_PROPERTY = createRequestTypes(
  'APPRAISAL/PROPERTY_INSERT_BUILDING_PERMIT_PROPERTY',
);

export const PROPERTY_DELETE_BUILDING_PERMIT_PROPERTY = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_BUILDING_PERMIT_PROPERTY',
);

export const INSERT_BUILDING_PERMIT_FILE = createRequestTypes(
  'APPRAISAL/INSERT_BUILDING_PERMIT_FILE',
);

export const DELETE_BUILDING_PERMIT_FILE = createRequestTypes(
  'APPRAISAL/DELETE_BUILDING_PERMIT_FILE',
);

export const DOWNLOAD_BUILDING_PERMIT_FILE = createRequestTypes(
  `APPRAISAL/DOWNLOAD_BUILDING_PERMIT_FILE`,
);

export const UPDATE_BUILDING_PERMIT_FILE = createRequestTypes(
  `APPRAISAL/UPDATE_BUILDING_PERMIT_FILE`,
);

export const RESET_BUILDING_PERMIT = 'APPRAISAL/RESET_BUILDING_PERMIT';

export const PROPERTY_FETCH_LAST_APPRAISAL = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_LAST_APPRAISAL',
);

export const PROPERTY_UPDATE_LAST_APPRAISAL = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_LAST_APPRAISAL',
);

export const PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS',
);

export const PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS_BY_YEAR = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS_BY_YEAR',
);

export const PROPERTY_FETCH_IMPROVEMENT_DETAIL_TYPES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_IMPROVEMENT_DETAIL_TYPES',
);

export const PROPERTY_FETCH_PROPERTY_TAGS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_PROPERTY_TAGS',
);

export const PROPERTY_INSERT_PROPERTY_TAG = createRequestTypes(
  'APPRAISAL/PROPERTY_INSERT_PROPERTY_TAG',
);

export const PROPERTY_DELETE_PROPERTY_TAG = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_PROPERTY_TAG',
);

export const PROPERTY_FETCH_RECALCULATION_JOB = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_RECALCULATION_JOB',
);

export const IMPROVEMENT_DUPLICATE = createRequestTypes(
  'APPRAISAL/IMPROVEMENT_DUPLICATE',
);

export const IMPROVEMENT_DETAIL_DUPLICATE = createRequestTypes(
  'APPRAISAL/IMPROVEMENT_DETAIL_DUPLICATE',
);

export const LAND_DUPLICATE = createRequestTypes('APPRAISAL/LAND_DUPLICATE');

export const PROPERTY_RESET_RECALCULATION_JOB =
  'APPRAISAL/PROPERTY_RESET_RECALCULATION_JOB';

export const resetRecalculationJob = () => ({
  type: PROPERTY_RESET_RECALCULATION_JOB,
});

export const PROPERTY_SET_ACCOUNT_STATUS =
  'APPRAISAL/PROPERTY_SET_ACCOUNT_STATUS';

export const setAccountStatus = (data) => ({
  type: PROPERTY_SET_ACCOUNT_STATUS,
  payload: data,
});

export const FETCH_MOST_CURRENT_PROPERTY = createRequestTypes(
  'APPRAISAL/FETCH_MOST_CURRENT_PROPERTY',
);

export const PROPERTY_FETCH_ROLL_HISTORY = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_ROLL_HISTORY',
);

export const PROPERTY_FETCH_APPRAISAL_NOTICE_HISTORY = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_APPRAISAL_NOTICE_HISTORY',
);

export const PROPERTY_FETCH_CURRENT_IMPROVEMENTS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_CURRENT_IMPROVEMENTS',
);

export const PROPERTY_RESET_CURRENT_IMPROVEMENTS =
  'APPRAISAL/PROPERTY_RESET_CURRENT_IMPROVEMENTS';

export const resetCurrentImprovements = () => ({
  type: PROPERTY_RESET_CURRENT_IMPROVEMENTS,
});

export const PROPERTY_COPY_SPECIFIC_IMPROVEMENT = createRequestTypes(
  'APPRAISAL/PROPERTY_COPY_SPECIFIC_IMPROVEMENT',
);

export const PROPERTY_FETCH_CURRENT_LANDS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_CURRENT_LANDS',
);

export const PROPERTY_RESET_CURRENT_LANDS =
  'APPRAISAL/PROPERTY_RESET_CURRENT_LANDS';

export const resetCurrentLands = () => ({
  type: PROPERTY_RESET_CURRENT_LANDS,
});

export const PROPERTY_COPY_SPECIFIC_LAND = createRequestTypes(
  'APPRAISAL/PROPERTY_COPY_SPECIFIC_LAND',
);

export const FETCH_OPEN_ROLL_CORRECTIONS = createRequestTypes(
  'APPRAISAL/FETCH_OPEN_ROLL_CORRECTIONS',
);

export const FETCH_PROPERTY_ROLL_CORRECTION_INFO = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_ROLL_CORRECTION_INFO',
);

export const UPDATE_PROPERTY_ROLL_CORRECTION_INFO = createRequestTypes(
  'APPRAISAL/UPDATE_PROPERTY_ROLL_CORRECTION_INFO',
);

export const INSERT_ROLL_CORRECTION = createRequestTypes(
  'APPRAISAL/INSERT_ROLL_CORRECTION',
);

export const CREATE_PROPERTY_ROLL_CORRECTION = createRequestTypes(
  'APPRAISAL/CREATE_PROPERTY_ROLL_CORRECTION',
);

export const REMOVE_PROPERTY_FROM_ROLL_CORRECTION = createRequestTypes(
  'APPRAISAL/REMOVE_PROPERTY_FROM_ROLL_CORRECTION',
);

export const GET_PROPERTY_FILES = createRequestTypes(
  'APPRAISAL/GET_PROPERTY_FILES',
);
export const UPLOAD_PROPERTY_FILE = createRequestTypes(
  'APPRAISAL/UPLOAD_PROPERTY_FILE',
);
export const UPLOAD_PROPERTY_PRIMARY_IMAGE = createRequestTypes(
  'APPRAISAL/UPLOAD_PROPERTY_PRIMARY_IMAGE',
);
export const UPDATE_CURRENT_PROPERTY_PRIMARY_IMAGE = createRequestTypes(
  'APPRAISAL/UPDATE_CURRENT_PROPERTY_PRIMARY_IMAGE',
);
export const DELETE_PROPERTY_FILE = createRequestTypes(
  'APPRAISAL/DELETE_PROPERTY_FILE',
);
export const UPDATE_PROPERTY_FILE = createRequestTypes(
  'APPRAISAL/UPDATE_PROPERTY_FILE',
);
export const DOWNLOAD_PROPERTY_FILE = createRequestTypes(
  'APPRAISAL/DOWNLOAD_PROPERTY_FILE',
);

export const PROPERTY_FETCH_PLATS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_PLATS',
);

export const PROPERTY_DELETE_MASS_CREATE_PROPERTY = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_MASS_CREATE_PROPERTY',
);

export const RESET_PROPERTY_PLATS = 'APPRAISAL/RESET_PROPERTY_PLATS';

export const resetPropertyPlats = () => ({ type: RESET_PROPERTY_PLATS });

export const PROPERTY_DOWNLOAD_PLAT = createRequestTypes(
  'APPRAISAL/PROPERTY_DOWNLOAD_PLAT',
);

export const FETCH_JAN_ONE_OWNER = createRequestTypes(
  'APPRAISAL/FETCH_JAN_ONE_OWNER',
);

export const FETCH_CALCULATION_RULES = createRequestTypes(
  'APPRAISAL/FETCH_CALCULATION_RULES',
);

export const FETCH_ALLOCATION_FACTORS = createRequestTypes(
  'APPRAISAL/FETCH_ALLOCATION_FACTORS',
);

export const DELETE_ALLOCATION_FACTOR = createRequestTypes(
  'APPRAISAL/DELETE_ALLOCATION_FACTOR',
);

export const UPDATE_ALLOCATION_FACTOR = createRequestTypes(
  'APPRAISAL/UPDATE_ALLOCATION_FACTOR',
);

export const INSERT_ALLOCATION_FACTOR = createRequestTypes(
  'APPRAISAL/INSERT_ALLOCATION_FACTOR',
);

export const FETCH_TAXING_UNIT_LOOKUP = createRequestTypes(
  'APPRAISAL/FETCH_TAXING_UNIT_LOOKUP',
);

export const PROCESS_TAXING_UNIT_AFFIDAVIT = createRequestTypes(
  'APPRAISAL/PROCESS_TAXING_UNIT_AFFIDAVIT',
);

export const FETCH_PROPERTY_FOR_SIT = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_FOR_SIT',
);

export const ENABLE_SIT = createRequestTypes('APPRAISAL/ENABLE_SIT');

export const DISABLE_SIT = createRequestTypes('APPRAISAL/DISABLE_SIT');

export const FETCH_SIT_DETAILS = createRequestTypes(
  'APPRAISAL/FETCH_SIT_DETAILS',
);

export const FETCH_SIT = createRequestTypes('APPRAISAL/FETCH_SIT');

export const RESET_SIT_DETAILS = 'APPRAISAL/RESET_SIT_DETAILS';

export const resetSITDetails = () => ({ type: RESET_SIT_DETAILS });

export const RESET_SIT = 'APPRAISAL/RESET_SIT';

export const resetSIT = () => ({ type: RESET_SIT });

export const UPDATE_SIT = createRequestTypes('APPRAISAL/ UPDATE_SIT');

export const FETCH_SIT_DETAIL = createRequestTypes(
  'APPRAISAL/FETCH_SIT_DETAIL',
);

export const UPDATE_SIT_DETAIL = createRequestTypes(
  'APPRAISAL/UPDATE_SIT_DETAIL',
);

export const INSERT_SIT_DETAIL = createRequestTypes(
  'APPRAISAL/INSERT_SIT_DETAIL',
);

export const DELETE_SIT_DETAIL = createRequestTypes(
  'APPRAISAL/DELETE_SIT_DETAIL',
);

export const RESET_SIT_DETAIL = 'APPRAISAL/RESET_SIT_DETAIL';

export const resetSitDetail = () => ({
  type: RESET_SIT_DETAIL,
});

export const INSERT_SIT_DETAIL_FILE = createRequestTypes(
  'APPRAISAL/INSERT_SIT_DETAIL_FILE',
);

export const DELETE_SIT_DETAIL_FILE = createRequestTypes(
  'APPRAISAL/DELETE_SIT_DETAIL_FILE',
);

export const DOWNLOAD_SIT_DETAIL_FILE = createRequestTypes(
  'APPRAISAL/DOWNLOAD_SIT_DETAIL_FILE',
);

export const UPDATE_SIT_DETAIL_FILE = createRequestTypes(
  'APPRAISAL/UPDATE_SIT_DETAIL_FILE',
);

export const INSERT_SIT_FILE = createRequestTypes('APPRAISAL/INSERT_SIT_FILE');

export const DELETE_SIT_FILE = createRequestTypes('APPRAISAL/DELETE_SIT_FILE');

export const DOWNLOAD_SIT_FILE = createRequestTypes(
  'APPRAISAL/DOWNLOAD_SIT_FILE',
);

export const UPDATE_SIT_FILE = createRequestTypes('APPRAISAL/UPDATE_SIT_FILE');

export const CREATE_BPP_IMPORT = createRequestTypes(
  'APPRAISAL/CREATE_BPP_IMPORT',
);

export const FETCH_BPP_IMPORT = createRequestTypes(
  'APPRAISAL/FETCH_BPP_IMPORT',
);

export const FETCH_BPP_IMPORT_ERRORS = createRequestTypes(
  'APPRAISAL/FETCH_BPP_IMPORT_ERRORS',
);

export const CLEAR_IMPORT_ERRORS = createRequestTypes(
  'APPRAISAL/CLEAR_IMPORT_ERRORS',
);

export const FETCH_MARKET_APPROACH_VALUATION = createRequestTypes(
  'APPRAISAL/FETCH_MARKET_APPROACH_VALUATION',
);

export const UPDATE_MARKET_APPROACH_AUTO_SELECT = createRequestTypes(
  'APPRAISAL/FETCH_MARKET_APPROACH_AUTO_SELECT',
);

export const FETCH_MARKET_APPROACH_COMP_IMAGES = createRequestTypes(
  'APPRAISAL/FETCH_MARKET_APPROACH_COMP_IMAGES',
);

export const REFRESH_MARKET_APPROACH = createRequestTypes(
  'APPRAISAL/REFRESH_MARKET_APPROACH',
);

export const DELETE_MARKET_APPROACH_COMPS = createRequestTypes(
  'APPRAISAL/DELETE_MARKET_APPROACH_COMPS',
);

export const FETCH_EQUITY_APPROACH_VALUATION = createRequestTypes(
  'APPRAISAL/FETCH_EQUITY_APPROACH_VALUATION',
);

export const UPDATE_EQUITY_APPROACH_AUTO_SELECT = createRequestTypes(
  'APPRAISAL/FETCH_EQUITY_APPROACH_AUTO_SELECT',
);

export const FETCH_EQUITY_APPROACH_COMP_IMAGES = createRequestTypes(
  'APPRAISAL/FETCH_EQUITY_APPROACH_COMP_IMAGES',
);

export const REFRESH_EQUITY_APPROACH = createRequestTypes(
  'APPRAISAL/REFRESH_EQUITY_APPROACH',
);

export const DELETE_EQUITY_APPROACH_COMPS = createRequestTypes(
  'APPRAISAL/DELETE_EQUITY_APPROACH_COMPS',
);

export const FETCH_APPEALS = createRequestTypes('APPRAISAL/FETCH_APPEALS');

export const PROPERTY_FETCH_ECON_UNIT = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_ECON_UNIT',
);

export const FETCH_GROUP_OPEN_ROLL_CORRECTIONS = createRequestTypes(
  'APPRAISAL/FETCH_GROUP_OPEN_ROLL_CORRECTIONS',
);

export const COPY_PROPERTY_OTHER_YEARS = createRequestTypes(
  'APPRAISAL/COPY_PROPERTY_OTHER_YEARS',
);

export const MOVE_PROPERTY_OTHER_CORRECTION = createRequestTypes(
  'APPRAISAL/MOVE_PROPERTY_OTHER_CORRECTION',
);

export const QUICK_PROPERTY_LOOKUP = createRequestTypes(
  'APPRAISAL/QUICK_PROPERTY_LOOKUP',
);

export const FETCH_PROPERTY_NOTIFICATIONS = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_NOTIFICATIONS',
);

export const FETCH_BPP_LATE_RENDITION_PENALTY = createRequestTypes(
  'APPRAISAL/FETCH_BPP_LATE_RENDITION_PENALTY',
);

export const UPDATE_BPP_LATE_RENDITION_PENALTY = createRequestTypes(
  'APPRAISAL/UPDATE_BPP_LATE_RENDITION_PENALTY',
);

export const FETCH_BPP_LATE_RENDITION_PENALTY_NEW = createRequestTypes(
  'APPRAISAL/FETCH_BPP_LATE_RENDITION_PENALTY_NEW',
);

export const UPDATE_BPP_LATE_RENDITION_PENALTY_NEW = createRequestTypes(
  'APPRAISAL/UPDATE_BPP_LATE_RENDITION_PENALTY_NEW',
);

export const UPDATE_BPP_LATE_RENDITION_PENALTY_INIT = createRequestTypes(
  'APPRAISAL/UPDATE_BPP_LATE_RENDITION_PENALTY_INIT',
);

export const FETCH_BPP_RENDITION_EXTENSION_REQUESTS = createRequestTypes(
  'APPRAISAL/FETCH_BPP_RENDITION_EXTENSION_REQUESTS',
);

export const UPDATE_BPP_RENDITION_EXTENSION_REQUESTS = createRequestTypes(
  'APPRAISAL/UPDATE_BPP_RENDITION_EXTENSION_REQUESTS',
);

export const UPDATE_BPP_RENDITION_EXTENSION_REQUESTS_INIT = createRequestTypes(
  'APPRAISAL/UPDATE_BPP_RENDITION_EXTENSION_REQUESTS_INIT',
);

export const FETCH_PROPERTY_CASES = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_CASES',
);

export const lookupProperty = makeApiActionCreatorV3(
  api.lookupProperty,
  LOOKUP_PROPERTY[START],
  LOOKUP_PROPERTY[SUCCESS],
  LOOKUP_PROPERTY[ERROR],
);

export const fetchApplicationEvents = makeApiActionCreatorV3(
  api.fetchApplicationEvents,
  FETCH_APPLICATION_EVENTS_START,
  FETCH_APPLICATION_EVENTS_SUCCESS,
  FETCH_APPLICATION_EVENTS_ERROR,
);

export const deleteApplicationEvents = makeApiActionCreatorV3(
  api.deleteApplicationEvents,
  DELETE_APPLICATION_EVENTS_START,
  DELETE_APPLICATION_EVENTS_SUCCESS,
  DELETE_APPLICATION_EVENTS_ERROR,
);

export const closePropertyLookupModal = () => ({
  type: CLOSE_PROPERTY_LOOKUP_MODAL,
});

export const propertyLookupModalSelectRecords = (properties) => ({
  type: MODAL_SELECT_PROPERTY_RECORDS,
  payload: properties,
});

export const fetchPropertyTaxRates = makeApiActionCreatorV3(
  api.fetchPropertyTaxRates,
  FETCH_PROPERTY_TAX_RATES_START,
  FETCH_PROPERTY_TAX_RATES_SUCCESS,
  FETCH_PROPERTY_TAX_RATES_ERROR,
);
export const fetchProperty = makeApiActionCreatorV3(
  api.fetchProperty,
  PROPERTY_FETCH_START,
  PROPERTY_FETCH_SUCCESS,
  PROPERTY_FETCH_ERROR,
);
export const fetchPropertyFull = makeApiActionCreatorV3(
  api.fetchPropertyFull,
  PROPERTY_FULL_FETCH_START,
  PROPERTY_FULL_FETCH_SUCCESS,
  PROPERTY_FULL_FETCH_ERROR,
);
export const fetchPropertyFullMass = makeApiActionCreatorV3(
  api.fetchPropertyFullMass,
  PROPERTY_FULL_MASS_FETCH_START,
  PROPERTY_FULL_MASS_FETCH_SUCCESS,
  PROPERTY_FULL_MASS_FETCH_ERROR,
);
export const updateProperty = makeApiActionCreatorV3(
  api.updateProperty,
  PROPERTY_UPDATE_START,
  PROPERTY_UPDATE_SUCCESS,
  PROPERTY_UPDATE_ERROR,
);
export const updatePropertyPrimaryImage = makeApiActionCreatorV3(
  api.updatePropertyPrimaryImage,
  PROPERTY_UPDATE_PRIMARY_IMAGE_START,
  PROPERTY_UPDATE_PRIMARY_IMAGE_SUCCESS,
  PROPERTY_UPDATE_PRIMARY_IMAGE_ERROR,
);
export const createProperty = makeApiActionCreatorV3(
  api.createProperty,
  PROPERTY_CREATE[START],
  PROPERTY_CREATE[SUCCESS],
  PROPERTY_CREATE[ERROR],
);
export const fetchPropertyNotes = makeApiActionCreatorV3(
  api.fetchPropertyNotes,
  PROPERTY_NOTES_FETCH_START,
  PROPERTY_NOTES_FETCH_SUCCESS,
  PROPERTY_NOTES_FETCH_ERROR,
);
export const updatePropertyNote = makeApiActionCreatorV3(
  api.updatePropertyNote,
  PROPERTY_NOTE_UPDATE_START,
  PROPERTY_NOTE_UPDATE_SUCCESS,
  PROPERTY_NOTE_UPDATE_ERROR,
);
export const updatePropertyNoteTags = makeApiActionCreatorV3(
  api.updatePropertyNoteTags,
  PROPERTY_NOTE_TAGS_UPDATE_START,
  PROPERTY_NOTE_TAGS_UPDATE_SUCCESS,
  PROPERTY_NOTE_TAGS_UPDATE_ERROR,
);
export const fetchWorkItemTypes = makeApiActionCreatorV3(
  api.fetchWorkItemTypes,
  FETCH_WORK_ITEM_TYPES[START],
  FETCH_WORK_ITEM_TYPES[SUCCESS],
  FETCH_WORK_ITEM_TYPES[ERROR],
);
export const insertWorkItemAndProperties = makeApiActionCreatorV3(
  api.insertWorkItemAndProperties,
  INSERT_WORK_ITEM_AND_PROPERTIES[START],
  INSERT_WORK_ITEM_AND_PROPERTIES[SUCCESS],
  INSERT_WORK_ITEM_AND_PROPERTIES[ERROR],
);
export const insertWorkItem = makeApiActionCreatorV3(
  api.insertWorkItem,
  INSERT_WORK_ITEM[START],
  INSERT_WORK_ITEM[SUCCESS],
  INSERT_WORK_ITEM[ERROR],
);
export const insertWorkItemProperty = makeApiActionCreatorV3(
  api.insertWorkItemProperty,
  INSERT_WORK_ITEM_PROPERTY[START],
  INSERT_WORK_ITEM_PROPERTY[SUCCESS],
  INSERT_WORK_ITEM_PROPERTY[ERROR],
);
export const insertWorkItemIntegrityCheck = makeApiActionCreatorV3(
  api.insertWorkItemIntegrityCheck,
  INSERT_WORK_ITEM_INTEGRITY_CHECK[START],
  INSERT_WORK_ITEM_INTEGRITY_CHECK[SUCCESS],
  INSERT_WORK_ITEM_INTEGRITY_CHECK[ERROR],
);
export const insertWorkItemFile = makeApiActionCreatorV3(
  api.insertWorkItemFile,
  INSERT_WORK_ITEM_FILE[START],
  INSERT_WORK_ITEM_FILE[SUCCESS],
  INSERT_WORK_ITEM_FILE[ERROR],
);
export const deleteWorkItemFile = makeApiActionCreatorV3(
  api.deleteWorkItemFile,
  DELETE_WORK_ITEM_FILE[START],
  DELETE_WORK_ITEM_FILE[SUCCESS],
  DELETE_WORK_ITEM_FILE[ERROR],
);
export const downloadWorkItemFile = makeApiActionCreatorV3(
  api.downloadWorkItemFile,
  DOWNLOAD_WORK_ITEM_FILE[START],
  DOWNLOAD_WORK_ITEM_FILE[SUCCESS],
  DOWNLOAD_WORK_ITEM_FILE[ERROR],
);
export const fetchWorkItemFiles = makeApiActionCreatorV3(
  api.fetchWorkItemFiles,
  FETCH_WORK_ITEM_FILES[START],
  FETCH_WORK_ITEM_FILES[SUCCESS],
  FETCH_WORK_ITEM_FILES[ERROR],
);
export const insertLatePenaltyFile = makeApiActionCreatorV3(
  api.insertLatePenaltyFile,
  INSERT_LATE_PENALTY_FILE[START],
  INSERT_LATE_PENALTY_FILE[SUCCESS],
  INSERT_LATE_PENALTY_FILE[ERROR],
);
export const deleteLatePenaltyFile = makeApiActionCreatorV3(
  api.deleteLatePenaltyFile,
  DELETE_LATE_PENALTY_FILE[START],
  DELETE_LATE_PENALTY_FILE[SUCCESS],
  DELETE_LATE_PENALTY_FILE[ERROR],
);
export const editLatePenaltyFile = makeApiActionCreatorV3(
  api.editLatePenaltyFile,
  EDIT_LATE_PENALTY_FILE[START],
  EDIT_LATE_PENALTY_FILE[SUCCESS],
  EDIT_LATE_PENALTY_FILE[ERROR],
);
export const downloadLatePenaltyFile = makeApiActionCreatorV3(
  api.downloadLatePenaltyFile,
  DOWNLOAD_LATE_PENALTY_FILE[START],
  DOWNLOAD_LATE_PENALTY_FILE[SUCCESS],
  DOWNLOAD_LATE_PENALTY_FILE[ERROR],
);
export const fetchLatePenaltyFiles = makeApiActionCreatorV3(
  api.fetchLatePenaltyFiles,
  FETCH_LATE_PENALTY_FILES[START],
  FETCH_LATE_PENALTY_FILES[SUCCESS],
  FETCH_LATE_PENALTY_FILES[ERROR],
);
export const editRenditionExtensionFile = makeApiActionCreatorV3(
  api.editRenditionExtensionFile,
  EDIT_RENDITION_EXTENSION_FILE[START],
  EDIT_RENDITION_EXTENSION_FILE[SUCCESS],
  EDIT_RENDITION_EXTENSION_FILE[ERROR],
);
export const insertRenditionExtensionFile = makeApiActionCreatorV3(
  api.insertRenditionExtensionFile,
  INSERT_RENDITION_EXTENSION_FILE[START],
  INSERT_RENDITION_EXTENSION_FILE[SUCCESS],
  INSERT_RENDITION_EXTENSION_FILE[ERROR],
);
export const deleteRenditionExtensionFile = makeApiActionCreatorV3(
  api.deleteRenditionExtensionFile,
  DELETE_RENDITION_EXTENSION_FILE[START],
  DELETE_RENDITION_EXTENSION_FILE[SUCCESS],
  DELETE_RENDITION_EXTENSION_FILE[ERROR],
);
export const downloadRenditionExtensionFile = makeApiActionCreatorV3(
  api.downloadRenditionExtensionFile,
  DOWNLOAD_RENDITION_EXTENSION_FILE[START],
  DOWNLOAD_RENDITION_EXTENSION_FILE[SUCCESS],
  DOWNLOAD_RENDITION_EXTENSION_FILE[ERROR],
);
export const fetchRenditionExtensionFiles = makeApiActionCreatorV3(
  api.fetchRenditionExtensionFiles,
  FETCH_RENDITION_EXTENSION_FILES[START],
  FETCH_RENDITION_EXTENSION_FILES[SUCCESS],
  FETCH_RENDITION_EXTENSION_FILES[ERROR],
);
export const fetchPropertyValueReady = makeApiActionCreatorV3(
  api.fetchPropertyValueReady,
  FETCH_PROPERTY_VALUE_READY[START],
  FETCH_PROPERTY_VALUE_READY[SUCCESS],
  FETCH_PROPERTY_VALUE_READY[ERROR],
);
export const updatePropertyValueReady = makeApiActionCreatorV3(
  api.updatePropertyValueReady,
  UPDATE_PROPERTY_VALUE_READY[START],
  UPDATE_PROPERTY_VALUE_READY[SUCCESS],
  UPDATE_PROPERTY_VALUE_READY[ERROR],
);
export const updatePropertySpecialUseReset = makeApiActionCreatorV3(
  api.updatePropertySpecialUseReset,
  UPDATE_PROPERTY_SPECIAL_USE_RESET[START],
  UPDATE_PROPERTY_SPECIAL_USE_RESET[SUCCESS],
  UPDATE_PROPERTY_SPECIAL_USE_RESET[ERROR],
);
export const addPropertyNote = makeApiActionCreatorV3(
  api.addPropertyNote,
  PROPERTY_NOTE_ADD_START,
  PROPERTY_NOTE_ADD_SUCCESS,
  PROPERTY_NOTE_ADD_ERROR,
);
export const deletePropertyNote = makeApiActionCreatorV3(
  api.deletePropertyNote,
  PROPERTY_NOTE_DELETE_START,
  PROPERTY_NOTE_DELETE_SUCCESS,
  PROPERTY_NOTE_DELETE_ERROR,
);
export const validateProperty = makeApiActionCreatorV3(
  api.validateProperty,
  PROPERTY_VALIDATE_START,
  PROPERTY_VALIDATE_SUCCESS,
  PROPERTY_VALIDATE_ERROR,
);
export const fetchPropertyMenuprofiles = makeApiActionCreatorV3(
  api.fetchPropertyMenuprofiles,
  PROPERTY_FETCH_MENU_PROFILES[START],
  PROPERTY_FETCH_MENU_PROFILES[SUCCESS],
  PROPERTY_FETCH_MENU_PROFILES[ERROR],
);
export const fetchPropertySubPage = makeApiActionCreatorV3(
  api.fetchPropertySubPage,
  PROPERTY_FETCH_SUB_PAGE[START],
  PROPERTY_FETCH_SUB_PAGE[SUCCESS],
  PROPERTY_FETCH_SUB_PAGE[ERROR],
);
export const fetchPropertyHeader = makeApiActionCreatorV3(
  api.fetchPropertyHeader,
  PROPERTY_FETCH_HEADER[START],
  PROPERTY_FETCH_HEADER[SUCCESS],
  PROPERTY_FETCH_HEADER[ERROR],
);
export const fetchPropertySummary = makeApiActionCreatorV3(
  api.fetchPropertySummary,
  PROPERTY_FETCH_SUMMARY[START],
  PROPERTY_FETCH_SUMMARY[SUCCESS],
  PROPERTY_FETCH_SUMMARY[ERROR],
);
export const fetchOwnerValueSummary = makeApiActionCreatorV3(
  api.fetchOwnerValueSummary,
  PROPERTY_FETCH_OWNER_SUMMARY[START],
  PROPERTY_FETCH_OWNER_SUMMARY[SUCCESS],
  PROPERTY_FETCH_OWNER_SUMMARY[ERROR],
);
export const clearPropertySummary = () => ({
  type: PROPERTY_CLEAR_SUMMARY,
});

export const fetchPropertyLegalDescription = makeApiActionCreatorV3(
  api.fetchPropertyLegalDescription,
  PROPERTY_FETCH_LEGAL_DESCRIPTION[START],
  PROPERTY_FETCH_LEGAL_DESCRIPTION[SUCCESS],
  PROPERTY_FETCH_LEGAL_DESCRIPTION[ERROR],
);
export const fetchPropertyMobileHomes = makeApiActionCreatorV3(
  api.fetchPropertyMobileHomes,
  PROPERTY_FETCH_MOBILE_HOMES[START],
  PROPERTY_FETCH_MOBILE_HOMES[SUCCESS],
  PROPERTY_FETCH_MOBILE_HOMES[ERROR],
);
export const updatePropertyLegalDescription = makeApiActionCreatorV3(
  api.updatePropertyLegalDescription,
  PROPERTY_UPDATE_LEGAL_DESCRIPTION[START],
  PROPERTY_UPDATE_LEGAL_DESCRIPTION[SUCCESS],
  PROPERTY_UPDATE_LEGAL_DESCRIPTION[ERROR],
);
export const fetchPropertyMineralLegalDescription = makeApiActionCreatorV3(
  api.fetchPropertyMineralLegalDescription,
  PROPERTY_FETCH_MINERAL_LEGAL_DESCRIPTION[START],
  PROPERTY_FETCH_MINERAL_LEGAL_DESCRIPTION[SUCCESS],
  PROPERTY_FETCH_MINERAL_LEGAL_DESCRIPTION[ERROR],
);
export const updatePropertyMineralLegalDescription = makeApiActionCreatorV3(
  api.updatePropertyMineralLegalDescription,
  PROPERTY_UPDATE_MINERAL_LEGAL_DESCRIPTION[START],
  PROPERTY_UPDATE_MINERAL_LEGAL_DESCRIPTION[SUCCESS],
  PROPERTY_UPDATE_MINERAL_LEGAL_DESCRIPTION[ERROR],
);
export const fetchAutoCompleteMineralLegal = makeApiActionCreatorV3(
  api.fetchAutoCompleteMineralLegal,
  FETCH_AUTO_COMPLETE_MINERAL_LEGAL[START],
  FETCH_AUTO_COMPLETE_MINERAL_LEGAL[SUCCESS],
  FETCH_AUTO_COMPLETE_MINERAL_LEGAL[ERROR],
);
export const fetchPropertyIdentification = makeApiActionCreatorV3(
  api.fetchPropertyIdentification,
  PROPERTY_FETCH_IDENTIFICATION[START],
  PROPERTY_FETCH_IDENTIFICATION[SUCCESS],
  PROPERTY_FETCH_IDENTIFICATION[ERROR],
);
export const updatePropertyIdentification = makeApiActionCreatorV3(
  api.updatePropertyIdentification,
  PROPERTY_UPDATE_IDENTIFICATION[START],
  PROPERTY_UPDATE_IDENTIFICATION[SUCCESS],
  PROPERTY_UPDATE_IDENTIFICATION[ERROR],
);
export const fetchPropertySummaryBPP = makeApiActionCreatorV3(
  api.fetchPropertySummaryBPP,
  PROPERTY_FETCH_SUMMARY_BPP[START],
  PROPERTY_FETCH_SUMMARY_BPP[SUCCESS],
  PROPERTY_FETCH_SUMMARY_BPP[ERROR],
);
export const fetchPropertyCharacteristics = makeApiActionCreatorV3(
  api.fetchPropertyCharacteristics,
  PROPERTY_FETCH_CHARACTERISTICS[START],
  PROPERTY_FETCH_CHARACTERISTICS[SUCCESS],
  PROPERTY_FETCH_CHARACTERISTICS[ERROR],
);
export const updatePropertyCharacteristics = makeApiActionCreatorV3(
  api.updatePropertyCharacteristics,
  PROPERTY_UPDATE_CHARACTERISTICS[START],
  PROPERTY_UPDATE_CHARACTERISTICS[SUCCESS],
  PROPERTY_UPDATE_CHARACTERISTICS[ERROR],
);

export const fetchPropertyPrimaryOwner = makeApiActionCreatorV3(
  api.fetchPropertyPrimaryOwner,
  PROPERTY_FETCH_PRIMARY_OWNER[START],
  PROPERTY_FETCH_PRIMARY_OWNER[SUCCESS],
  PROPERTY_FETCH_PRIMARY_OWNER[ERROR],
);

export const addPropertyDummyTaxingUnit = (data) => ({
  type: PROPERTY_ADD_DUMMY_TAXING_UNIT,
  payload: data,
});
export const fetchPropertyTaxingUnits = makeApiActionCreatorV3(
  api.fetchPropertyTaxingUnits,
  PROPERTY_FETCH_TAXING_UNITS[START],
  PROPERTY_FETCH_TAXING_UNITS[SUCCESS],
  PROPERTY_FETCH_TAXING_UNITS[ERROR],
);
export const getPropertyBuilderAdjustments = makeApiActionCreatorV3(
  api.getPropertyBuilderAdjustments,
  PROPERTY_GET_BUILDER_ADJUSTMENTS[START],
  PROPERTY_GET_BUILDER_ADJUSTMENTS[SUCCESS],
  PROPERTY_GET_BUILDER_ADJUSTMENTS[ERROR],
);
export const updatePropertyBuilderAdjustments = makeApiActionCreatorV3(
  api.updatePropertyBuilderAdjustments,
  PROPERTY_UPDATE_BUILDER_ADJUSTMENTS[START],
  PROPERTY_UPDATE_BUILDER_ADJUSTMENTS[SUCCESS],
  PROPERTY_UPDATE_BUILDER_ADJUSTMENTS[ERROR],
);
export const fetchAllPropertyTaxingUnits = makeApiActionCreatorV3(
  api.fetchAllPropertyTaxingUnits,
  PROPERTY_FETCH_ALL_TAXING_UNITS[START],
  PROPERTY_FETCH_ALL_TAXING_UNITS[SUCCESS],
  PROPERTY_FETCH_ALL_TAXING_UNITS[ERROR],
);
export const createPropertyTaxingUnit = makeApiActionCreatorV3(
  api.createPropertyTaxingUnit,
  PROPERTY_CREATE_TAXING_UNIT[START],
  PROPERTY_CREATE_TAXING_UNIT[SUCCESS],
  PROPERTY_CREATE_TAXING_UNIT[ERROR],
);
export const updatePropertyTaxingUnit = makeApiActionCreatorV3(
  api.updatePropertyTaxingUnit,
  PROPERTY_UPDATE_TAXING_UNIT[START],
  PROPERTY_UPDATE_TAXING_UNIT[SUCCESS],
  PROPERTY_UPDATE_TAXING_UNIT[ERROR],
);
export const deletePropertyTaxingUnit = makeApiActionCreatorV3(
  api.deletePropertyTaxingUnit,
  PROPERTY_DELETE_TAXING_UNIT[START],
  PROPERTY_DELETE_TAXING_UNIT[SUCCESS],
  PROPERTY_DELETE_TAXING_UNIT[ERROR],
);
export const generateGeoID = makeApiActionCreatorV3(
  api.generateGeoID,
  GENERATE_GEOID_START,
  GENERATE_GEOID_SUCCESS,
  GENERATE_GEOID_ERROR,
);

export const fetchPropertyOwners = makeApiActionCreatorV3(
  api.fetchPropertyOwners,
  PROPERTY_FETCH_OWNERS[START],
  PROPERTY_FETCH_OWNERS[SUCCESS],
  PROPERTY_FETCH_OWNERS[ERROR],
);

export const fetchPropertyExemptions = makeApiActionCreatorV3(
  api.fetchPropertyExemptions,
  PROPERTY_FETCH_EXEMPTIONS[START],
  PROPERTY_FETCH_EXEMPTIONS[SUCCESS],
  PROPERTY_FETCH_EXEMPTIONS[ERROR],
);

export const clearPropertyExemptions = () => ({
  type: PROPERTY_CLEAR_EXEMPTIONS,
});

export const fetchPropertyExemption = makeApiActionCreatorV3(
  api.fetchPropertyExemption,
  PROPERTY_FETCH_EXEMPTION[START],
  PROPERTY_FETCH_EXEMPTION[SUCCESS],
  PROPERTY_FETCH_EXEMPTION[ERROR],
);

export const clearExemptions = () => ({
  type: CLEAR_EXEMPTIONS,
});
export const createPropertyExemption = makeApiActionCreatorV3(
  api.createPropertyExemption,
  PROPERTY_CREATE_EXEMPTION[START],
  PROPERTY_CREATE_EXEMPTION[SUCCESS],
  PROPERTY_CREATE_EXEMPTION[ERROR],
);
export const deletePropertyExemption = makeApiActionCreatorV3(
  api.deletePropertyExemption,
  PROPERTY_DELETE_EXEMPTION[START],
  PROPERTY_DELETE_EXEMPTION[SUCCESS],
  PROPERTY_DELETE_EXEMPTION[ERROR],
);
export const updatePropertyExemption = makeApiActionCreatorV3(
  api.updatePropertyExemption,
  PROPERTY_UPDATE_EXEMPTION[START],
  PROPERTY_UPDATE_EXEMPTION[SUCCESS],
  PROPERTY_UPDATE_EXEMPTION[ERROR],
);
export const fetchExemptionCode = makeApiActionCreatorV3(
  api.fetchExemptionCode,
  FETCH_EXEMPTION[START],
  FETCH_EXEMPTION[SUCCESS],
  FETCH_EXEMPTION[ERROR],
);
export function resetPropertyExemption() {
  return async (dispatch) => {
    dispatch({ type: PROPERTY_RESET_EXEMPTION });
  };
}
export const fetchPropertyEvents = makeApiActionCreatorV3(
  api.fetchPropertyEvents,
  PROPERTY_FETCH_EVENTS[START],
  PROPERTY_FETCH_EVENTS[SUCCESS],
  PROPERTY_FETCH_EVENTS[ERROR],
);
export const createPropertyEvent = makeApiActionCreatorV3(
  eventApi.createEvent,
  PROPERTY_CREATE_EVENT[START],
  PROPERTY_CREATE_EVENT[SUCCESS],
  PROPERTY_CREATE_EVENT[ERROR],
);
export const updatePropertyEvent = makeApiActionCreatorV3(
  eventApi.updateEvent,
  PROPERTY_UPDATE_EVENT[START],
  PROPERTY_UPDATE_EVENT[SUCCESS],
  PROPERTY_UPDATE_EVENT[ERROR],
);
export const deletePropertyEvent = makeApiActionCreatorV3(
  eventApi.deleteEvent,
  PROPERTY_DELETE_EVENT[START],
  PROPERTY_DELETE_EVENT[SUCCESS],
  PROPERTY_DELETE_EVENT[ERROR],
);
export const updatePropertyEventTagObject = makeApiActionCreatorV3(
  eventApi.updateEventTagObject,
  PROPERTY_UPDATE_EVENT_TAG_OBJECT[START],
  PROPERTY_UPDATE_EVENT_TAG_OBJECT[SUCCESS],
  PROPERTY_UPDATE_EVENT_TAG_OBJECT[ERROR],
);
export const fetchAllImprovementAdjustments = makeApiActionCreatorV3(
  api.fetchImprovementAdjustments,
  PROPERTY_FETCH_IMPROVEMENT_ADJUSTMENTS[START],
  PROPERTY_FETCH_IMPROVEMENT_ADJUSTMENTS[SUCCESS],
  PROPERTY_FETCH_IMPROVEMENT_ADJUSTMENTS[ERROR],
);
export const fetchImprovementAdjustTypes = makeApiActionCreatorV3(
  api.fetchImprovementAdjustTypes,
  PROPERTY_FETCH_IMPROVEMENT_ADJUST_TYPES[START],
  PROPERTY_FETCH_IMPROVEMENT_ADJUST_TYPES[SUCCESS],
  PROPERTY_FETCH_IMPROVEMENT_ADJUST_TYPES[ERROR],
);
export const createImprovementAdjustment = makeApiActionCreatorV3(
  api.createImprovementAdjustment,
  PROPERTY_CREATE_IMPROVEMENT_ADJUSTMENT[START],
  PROPERTY_CREATE_IMPROVEMENT_ADJUSTMENT[SUCCESS],
  PROPERTY_CREATE_IMPROVEMENT_ADJUSTMENT[ERROR],
);
export const updateImprovementAdjustment = makeApiActionCreatorV3(
  api.updateImprovementAdjustment,
  PROPERTY_UPDATE_IMPROVEMENT_ADJUSTMENT[START],
  PROPERTY_UPDATE_IMPROVEMENT_ADJUSTMENT[SUCCESS],
  PROPERTY_UPDATE_IMPROVEMENT_ADJUSTMENT[ERROR],
);
export const deleteImprovementAdjustment = makeApiActionCreatorV3(
  api.deleteImprovementAdjustment,
  PROPERTY_DELETE_IMPROVEMENT_ADJUSTMENT[START],
  PROPERTY_DELETE_IMPROVEMENT_ADJUSTMENT[SUCCESS],
  PROPERTY_DELETE_IMPROVEMENT_ADJUSTMENT[ERROR],
);
export const fetchAllLandAdjustments = makeApiActionCreatorV3(
  api.fetchLandAdjustments,
  PROPERTY_FETCH_LAND_ADJUSTMENTS[START],
  PROPERTY_FETCH_LAND_ADJUSTMENTS[SUCCESS],
  PROPERTY_FETCH_LAND_ADJUSTMENTS[ERROR],
);
export const fetchLandAdjustTypes = makeApiActionCreatorV3(
  api.fetchLandAdjustTypes,
  PROPERTY_FETCH_LAND_ADJUST_TYPES[START],
  PROPERTY_FETCH_LAND_ADJUST_TYPES[SUCCESS],
  PROPERTY_FETCH_LAND_ADJUST_TYPES[ERROR],
);
export const createLandAdjustment = makeApiActionCreatorV3(
  api.createLandAdjustment,
  PROPERTY_CREATE_LAND_ADJUSTMENT[START],
  PROPERTY_CREATE_LAND_ADJUSTMENT[SUCCESS],
  PROPERTY_CREATE_LAND_ADJUSTMENT[ERROR],
);
export const updateLandAdjustment = makeApiActionCreatorV3(
  api.updateLandAdjustment,
  PROPERTY_UPDATE_LAND_ADJUSTMENT[START],
  PROPERTY_UPDATE_LAND_ADJUSTMENT[SUCCESS],
  PROPERTY_UPDATE_LAND_ADJUSTMENT[ERROR],
);
export const deleteLandAdjustment = makeApiActionCreatorV3(
  api.deleteLandAdjustment,
  PROPERTY_DELETE_LAND_ADJUSTMENT[START],
  PROPERTY_DELETE_LAND_ADJUSTMENT[SUCCESS],
  PROPERTY_DELETE_LAND_ADJUSTMENT[ERROR],
);
export const fetchAllImprvDetailAdjustments = makeApiActionCreatorV3(
  api.fetchImprvDetailAdjustments,
  PROPERTY_FETCH_IMPRV_DETAIL_ADJUSTMENTS[START],
  PROPERTY_FETCH_IMPRV_DETAIL_ADJUSTMENTS[SUCCESS],
  PROPERTY_FETCH_IMPRV_DETAIL_ADJUSTMENTS[ERROR],
);
export const fetchImprvDetailAdjustTypes = makeApiActionCreatorV3(
  api.fetchImprvDetailAdjustTypes,
  PROPERTY_FETCH_IMPRV_DETAIL_ADJUST_TYPES[START],
  PROPERTY_FETCH_IMPRV_DETAIL_ADJUST_TYPES[SUCCESS],
  PROPERTY_FETCH_IMPRV_DETAIL_ADJUST_TYPES[ERROR],
);
export const createImprvDetailAdjustment = makeApiActionCreatorV3(
  api.createImprvDetailAdjustment,
  PROPERTY_CREATE_IMPRV_DETAIL_ADJUSTMENT[START],
  PROPERTY_CREATE_IMPRV_DETAIL_ADJUSTMENT[SUCCESS],
  PROPERTY_CREATE_IMPRV_DETAIL_ADJUSTMENT[ERROR],
);
export const updateImprvDetailAdjustment = makeApiActionCreatorV3(
  api.updateImprvDetailAdjustment,
  PROPERTY_UPDATE_IMPRV_DETAIL_ADJUSTMENT[START],
  PROPERTY_UPDATE_IMPRV_DETAIL_ADJUSTMENT[SUCCESS],
  PROPERTY_UPDATE_IMPRV_DETAIL_ADJUSTMENT[ERROR],
);
export const deleteImprvDetailAdjustment = makeApiActionCreatorV3(
  api.deleteImprvDetailAdjustment,
  PROPERTY_DELETE_IMPRV_DETAIL_ADJUSTMENT[START],
  PROPERTY_DELETE_IMPRV_DETAIL_ADJUSTMENT[SUCCESS],
  PROPERTY_DELETE_IMPRV_DETAIL_ADJUSTMENT[ERROR],
);

export const fetchZestimate = makeApiActionCreatorV3(
  api.fetchZestimate,
  ZILLOW_ZESTIMATE_FETCH[START],
  ZILLOW_ZESTIMATE_FETCH[SUCCESS],
  ZILLOW_ZESTIMATE_FETCH[ERROR],
);
export const fetchZProperty = makeApiActionCreatorV3(
  api.fetchZProperty,
  ZILLOW_ZPROPERTY_FETCH[START],
  ZILLOW_ZPROPERTY_FETCH[SUCCESS],
  ZILLOW_ZPROPERTY_FETCH[ERROR],
);
export const fetchZComps = makeApiActionCreatorV3(
  api.fetchZComps,
  ZILLOW_ZCOMPS_FETCH[START],
  ZILLOW_ZCOMPS_FETCH[SUCCESS],
  ZILLOW_ZCOMPS_FETCH[ERROR],
);
export const fetchZillowPropertyHeader = makeApiActionCreatorV3(
  api.fetchZillowPropertyHeader,
  ZILLOW_PROPERTY_HEADER_FETCH[START],
  ZILLOW_PROPERTY_HEADER_FETCH[SUCCESS],
  ZILLOW_PROPERTY_HEADER_FETCH[ERROR],
);

export const fetchImprovementInfluencer = makeApiActionCreatorV3(
  api.fetchImprovementInfluencer,
  PROPERTY_FETCH_IMPROVEMENT_INFLUENCER[START],
  PROPERTY_FETCH_IMPROVEMENT_INFLUENCER[SUCCESS],
  PROPERTY_FETCH_IMPROVEMENT_INFLUENCER[ERROR],
);
export const updateImprovementInfluencer = makeApiActionCreatorV3(
  api.updateImprovementInfluencer,
  PROPERTY_UPDATE_IMPROVEMENT_INFLUENCER[START],
  PROPERTY_UPDATE_IMPROVEMENT_INFLUENCER[SUCCESS],
  PROPERTY_UPDATE_IMPROVEMENT_INFLUENCER[ERROR],
);
export const fetchLandInfluencer = makeApiActionCreatorV3(
  api.fetchLandInfluencer,
  PROPERTY_FETCH_LAND_INFLUENCER[START],
  PROPERTY_FETCH_LAND_INFLUENCER[SUCCESS],
  PROPERTY_FETCH_LAND_INFLUENCER[ERROR],
);
export const updateLandInfluencer = makeApiActionCreatorV3(
  api.updateLandInfluencer,
  PROPERTY_UPDATE_LAND_INFLUENCER[START],
  PROPERTY_UPDATE_LAND_INFLUENCER[SUCCESS],
  PROPERTY_UPDATE_LAND_INFLUENCER[ERROR],
);
export const fetchPropertyMarketAreaModifiers = makeApiActionCreatorV3(
  api.fetchPropertyMarketAreaModifiers,
  PROPERTY_FETCH_MARKET_MODIFIERS[START],
  PROPERTY_FETCH_MARKET_MODIFIERS[SUCCESS],
  PROPERTY_FETCH_MARKET_MODIFIERS[ERROR],
);
export const fetchImprvDetailInfluencer = makeApiActionCreatorV3(
  api.fetchImprvDetailInfluencer,
  PROPERTY_FETCH_IMPRV_DETAIL_INFLUENCER[START],
  PROPERTY_FETCH_IMPRV_DETAIL_INFLUENCER[SUCCESS],
  PROPERTY_FETCH_IMPRV_DETAIL_INFLUENCER[ERROR],
);
export const updateImprvDetailInfluencer = makeApiActionCreatorV3(
  api.updateImprvDetailInfluencer,
  PROPERTY_UPDATE_IMPRV_DETAIL_INFLUENCER[START],
  PROPERTY_UPDATE_IMPRV_DETAIL_INFLUENCER[SUCCESS],
  PROPERTY_UPDATE_IMPRV_DETAIL_INFLUENCER[ERROR],
);

export const fetchPropertyValuationTypes = makeApiActionCreatorV3(
  api.fetchValuationTypes,
  PROPERTY_FETCH_VALUATION_TYPES[START],
  PROPERTY_FETCH_VALUATION_TYPES[SUCCESS],
  PROPERTY_FETCH_VALUATION_TYPES[ERROR],
);
export const fetchImprovementTypes = makeApiActionCreatorV3(
  api.fetchImprovementTypes,
  PROPERTY_FETCH_IMPROVEMENT_TYPES[START],
  PROPERTY_FETCH_IMPROVEMENT_TYPES[SUCCESS],
  PROPERTY_FETCH_IMPROVEMENT_TYPES[ERROR],
);

export const setValuationWidgetState = (widgetStateChange) => ({
  type: PROPERTY_SET_VALUATION_WIDGET_STATE,
  payload: widgetStateChange,
});

export const fetchPropertyValuations = makeApiActionCreatorV3(
  api.fetchPropertyValuations,
  PROPERTY_FETCH_VALUATIONS[START],
  PROPERTY_FETCH_VALUATIONS[SUCCESS],
  PROPERTY_FETCH_VALUATIONS[ERROR],
  true,
);
export const updatePropertyMarketIncludePresentation = makeApiActionCreatorV3(
  api.updatePropertyMarketIncludePresentation,
  PROPERTY_MARKET_INCLUDE_PRESENTATION[START],
  PROPERTY_MARKET_INCLUDE_PRESENTATION[SUCCESS],
  PROPERTY_MARKET_INCLUDE_PRESENTATION[ERROR],
);
export const updatePropertyEquityIncludePresentation = makeApiActionCreatorV3(
  api.updatePropertyEquityIncludePresentation,
  PROPERTY_EQUITY_INCLUDE_PRESENTATION[START],
  PROPERTY_EQUITY_INCLUDE_PRESENTATION[SUCCESS],
  PROPERTY_EQUITY_INCLUDE_PRESENTATION[ERROR],
);
export const createPropertyValuation = makeApiActionCreatorV3(
  api.createPropertyValuation,
  PROPERTY_CREATE_VALUATION[START],
  PROPERTY_CREATE_VALUATION[SUCCESS],
  PROPERTY_CREATE_VALUATION[ERROR],
);
export const createPropertyEconomicValuation = makeApiActionCreatorV3(
  api.createPropertyEconomicValuation,
  PROPERTY_CREATE_ECONOMIC_VALUATION[START],
  PROPERTY_CREATE_ECONOMIC_VALUATION[SUCCESS],
  PROPERTY_CREATE_ECONOMIC_VALUATION[ERROR],
);
export const updatePropertyValuation = makeApiActionCreatorV3(
  api.updatePropertyValuation,
  PROPERTY_UPDATE_VALUATION[START],
  PROPERTY_UPDATE_VALUATION[SUCCESS],
  PROPERTY_UPDATE_VALUATION[ERROR],
);
export const setPrimaryValuation = makeApiActionCreatorV3(
  api.setPrimaryValuation,
  PROPERTY_SET_PRIMARY_VALUATION[START],
  PROPERTY_SET_PRIMARY_VALUATION[SUCCESS],
  PROPERTY_SET_PRIMARY_VALUATION[ERROR],
);
export const deletePropertyValuation = makeApiActionCreatorV3(
  api.deletePropertyValuation,
  PROPERTY_DELETE_VALUATION[START],
  PROPERTY_DELETE_VALUATION[SUCCESS],
  PROPERTY_DELETE_VALUATION[ERROR],
);
export const distributePropertyValuation = makeApiActionCreatorV3(
  api.distributePropertyValuation,
  PROPERTY_DISTRIBUTE_VALUATION[START],
  PROPERTY_DISTRIBUTE_VALUATION[SUCCESS],
  PROPERTY_DISTRIBUTE_VALUATION[ERROR],
);
export const fetchPropertyImprovements = makeApiActionCreatorV3(
  api.fetchPropertyImprovements,
  PROPERTY_FETCH_IMPROVEMENTS[START],
  PROPERTY_FETCH_IMPROVEMENTS[SUCCESS],
  PROPERTY_FETCH_IMPROVEMENTS[ERROR],
  true,
);
export const createPropertyImprovement = makeApiActionCreatorV3(
  api.createPropertyImprovement,
  PROPERTY_CREATE_IMPROVEMENT[START],
  PROPERTY_CREATE_IMPROVEMENT[SUCCESS],
  PROPERTY_CREATE_IMPROVEMENT[ERROR],
);
export const updatePropertyImprovement = makeApiActionCreatorV3(
  api.updatePropertyImprovement,
  PROPERTY_UPDATE_IMPROVEMENT[START],
  PROPERTY_UPDATE_IMPROVEMENT[SUCCESS],
  PROPERTY_UPDATE_IMPROVEMENT[ERROR],
);
export const deletePropertyImprovement = makeApiActionCreatorV3(
  api.deletePropertyImprovement,
  PROPERTY_DELETE_IMPROVEMENT[START],
  PROPERTY_DELETE_IMPROVEMENT[SUCCESS],
  PROPERTY_DELETE_IMPROVEMENT[ERROR],
);
export const fetchPropertyImprovementDetails = makeApiActionCreatorV3(
  api.fetchPropertyImprovementDetails,
  PROPERTY_FETCH_IMPROVEMENT_DETAILS[START],
  PROPERTY_FETCH_IMPROVEMENT_DETAILS[SUCCESS],
  PROPERTY_FETCH_IMPROVEMENT_DETAILS[ERROR],
  true,
);
export const createPropertyImprovementDetail = makeApiActionCreatorV3(
  api.createPropertyImprovementDetail,
  PROPERTY_CREATE_IMPROVEMENT_DETAIL[START],
  PROPERTY_CREATE_IMPROVEMENT_DETAIL[SUCCESS],
  PROPERTY_CREATE_IMPROVEMENT_DETAIL[ERROR],
);
export const updatePropertyImprovementDetail = makeApiActionCreatorV3(
  api.updatePropertyImprovementDetail,
  PROPERTY_UPDATE_IMPROVEMENT_DETAIL[START],
  PROPERTY_UPDATE_IMPROVEMENT_DETAIL[SUCCESS],
  PROPERTY_UPDATE_IMPROVEMENT_DETAIL[ERROR],
);
export const deletePropertyImprovementDetail = makeApiActionCreatorV3(
  api.deletePropertyImprovementDetail,
  PROPERTY_DELETE_IMPROVEMENT_DETAIL[START],
  PROPERTY_DELETE_IMPROVEMENT_DETAIL[SUCCESS],
  PROPERTY_DELETE_IMPROVEMENT_DETAIL[ERROR],
);
export const fetchPropertyImprovementDetailFeatures = makeApiActionCreatorV3(
  api.fetchImprovementDetailFeatures,
  PROPERTY_FETCH_IMPROVEMENT_DETAIL_FEATURES[START],
  PROPERTY_FETCH_IMPROVEMENT_DETAIL_FEATURES[SUCCESS],
  PROPERTY_FETCH_IMPROVEMENT_DETAIL_FEATURES[ERROR],
  true,
);
export const savePropertyImprovementDetailFeatures = makeApiActionCreatorV3(
  api.saveImprovementDetailFeatures,
  PROPERTY_SAVE_IMPROVEMENT_DETAIL_FEATURES[START],
  PROPERTY_SAVE_IMPROVEMENT_DETAIL_FEATURES[SUCCESS],
  PROPERTY_SAVE_IMPROVEMENT_DETAIL_FEATURES[ERROR],
);
export const fetchPropertyLand = makeApiActionCreatorV3(
  api.fetchPropertyLand,
  PROPERTY_FETCH_LAND[START],
  PROPERTY_FETCH_LAND[SUCCESS],
  PROPERTY_FETCH_LAND[ERROR],
  true,
);
export const createPropertyLand = makeApiActionCreatorV3(
  api.createPropertyLand,
  PROPERTY_CREATE_LAND[START],
  PROPERTY_CREATE_LAND[SUCCESS],
  PROPERTY_CREATE_LAND[ERROR],
);
export const updatePropertyLand = makeApiActionCreatorV3(
  api.updatePropertyLand,
  PROPERTY_UPDATE_LAND[START],
  PROPERTY_UPDATE_LAND[SUCCESS],
  PROPERTY_UPDATE_LAND[ERROR],
);
export const deletePropertyLand = makeApiActionCreatorV3(
  api.deletePropertyLand,
  PROPERTY_DELETE_LAND[START],
  PROPERTY_DELETE_LAND[SUCCESS],
  PROPERTY_DELETE_LAND[ERROR],
);

export const createPropertyLandNote = makeApiActionCreatorV3(
  api.createPropertyLandNote,
  PROPERTY_CREATE_LAND_NOTE[START],
  PROPERTY_CREATE_LAND_NOTE[SUCCESS],
  PROPERTY_CREATE_LAND_NOTE[ERROR],
);
export const fetchPropertyLandNotes = makeApiActionCreatorV3(
  api.fetchPropertyLandNotes,
  PROPERTY_FETCH_LAND_NOTES[START],
  PROPERTY_FETCH_LAND_NOTES[SUCCESS],
  PROPERTY_FETCH_LAND_NOTES[ERROR],
  true,
);
export const updatePropertyLandNote = makeApiActionCreatorV3(
  api.updatePropertyLandNote,
  PROPERTY_UPDATE_LAND_NOTE[START],
  PROPERTY_UPDATE_LAND_NOTE[SUCCESS],
  PROPERTY_UPDATE_LAND_NOTE[ERROR],
);
export const deletePropertyLandNote = makeApiActionCreatorV3(
  api.deletePropertyLandNote,
  PROPERTY_DELETE_LAND_NOTE[START],
  PROPERTY_DELETE_LAND_NOTE[SUCCESS],
  PROPERTY_DELETE_LAND_NOTE[ERROR],
);

export const fetchPropertyPrimarySitus = makeApiActionCreatorV3(
  api.fetchPropertyPrimarySitus,
  PROPERTY_FETCH_PRIMARY_SITUS[START],
  PROPERTY_FETCH_PRIMARY_SITUS[SUCCESS],
  PROPERTY_FETCH_PRIMARY_SITUS[ERROR],
  true,
);
export const fetchPropertyAllSitus = makeApiActionCreatorV3(
  api.fetchPropertyAllSitus,
  PROPERTY_FETCH_ALL_SITUS[START],
  PROPERTY_FETCH_ALL_SITUS[SUCCESS],
  PROPERTY_FETCH_ALL_SITUS[ERROR],
  true,
);
export const createPropertySitus = makeApiActionCreatorV3(
  api.createPropertySitus,
  PROPERTY_CREATE_SITUS[START],
  PROPERTY_CREATE_SITUS[SUCCESS],
  PROPERTY_CREATE_SITUS[ERROR],
);
export const deletePropertySitus = makeApiActionCreatorV3(
  api.deletePropertySitus,
  PROPERTY_DELETE_SITUS[START],
  PROPERTY_DELETE_SITUS[SUCCESS],
  PROPERTY_DELETE_SITUS[ERROR],
);
export const setPropertyPrimarySitus = makeApiActionCreatorV3(
  api.setPropertySitusPrimary,
  PROPERTY_SET_PRIMARY_SITUS[START],
  PROPERTY_SET_PRIMARY_SITUS[SUCCESS],
  PROPERTY_SET_PRIMARY_SITUS[ERROR],
);
export const updatePropertySitus = makeApiActionCreatorV3(
  api.updatePropertySitus,
  PROPERTY_UPDATE_SITUS[START],
  PROPERTY_UPDATE_SITUS[SUCCESS],
  PROPERTY_UPDATE_SITUS[ERROR],
);

export const fetchPropertySize = makeApiActionCreatorV3(
  api.fetchPropertySize,
  PROPERTY_FETCH_SIZE[START],
  PROPERTY_FETCH_SIZE[SUCCESS],
  PROPERTY_FETCH_SIZE[ERROR],
  true,
);
export const fetchPropertyExemptionCard = makeApiActionCreatorV3(
  api.fetchPropertyExemptionCard,
  PROPERTY_FETCH_EXEMPTION_CARD[START],
  PROPERTY_FETCH_EXEMPTION_CARD[SUCCESS],
  PROPERTY_FETCH_EXEMPTION_CARD[ERROR],
  true,
);
export const fetchPropertyValueSummary = makeApiActionCreatorV3(
  api.fetchPropertyValueSummary,
  PROPERTY_FETCH_VALUE_SUMMARY[START],
  PROPERTY_FETCH_VALUE_SUMMARY[SUCCESS],
  PROPERTY_FETCH_VALUE_SUMMARY[ERROR],
  true,
);

export const fetchPropertyDropdowns = makeApiActionCreatorV3(
  api.getDropdownValues,
  PROPERTY_FETCH_DROPDOWNS[START],
  PROPERTY_FETCH_DROPDOWNS[SUCCESS],
  PROPERTY_FETCH_DROPDOWNS[ERROR],
);

export const fetchSubcomponentConfig = makeApiActionCreatorV3(
  api.fetchSubcomponentConfig,
  PROPERTY_FETCH_SUBCOMPONENT_CONFIG[START],
  PROPERTY_FETCH_SUBCOMPONENT_CONFIG[SUCCESS],
  PROPERTY_FETCH_SUBCOMPONENT_CONFIG[ERROR],
);

export const FETCH_BUILDER_PLAN_SUBCOMPONENT_CONFIG = createRequestTypes(
  'APPRAISAL/FETCH_BUILDER_PLAN_SUBCOMPONENT_CONFIG',
);

export const fetchBuilderPlanSubcomponentConfig = makeApiActionCreatorV3(
  api.fetchBuilderPlanSubcomponentConfig,
  FETCH_BUILDER_PLAN_SUBCOMPONENT_CONFIG[START],
  FETCH_BUILDER_PLAN_SUBCOMPONENT_CONFIG[SUCCESS],
  FETCH_BUILDER_PLAN_SUBCOMPONENT_CONFIG[ERROR],
);

export const recalculateProperty = makeApiActionCreatorV3(
  api.recalculateProperty,
  PROPERTY_RECALCULATE[START],
  PROPERTY_RECALCULATE[SUCCESS],
  PROPERTY_RECALCULATE[ERROR],
);

export const CHECK_RECALC_PROPERTY = createRequestTypes(
  'APPRAISAL/CHECK_RECALC_PROPERTY',
);

export const checkRecalcProperty = makeApiActionCreatorV3(
  api.checkRecalcProperty,
  CHECK_RECALC_PROPERTY[START],
  CHECK_RECALC_PROPERTY[SUCCESS],
  CHECK_RECALC_PROPERTY[ERROR],
);

export const fetchOwnershipPageData = () => async (dispatch, getState) => {
  const state = getState();
  const {
    pID: pid,
    pYear,
    pVersion,
    pRollCorr,
  } = state.getIn(['app', 'appraisal', 'property', 'header', 'data']).toJS();
  const owners = state
    .getIn(['app', 'appraisal', 'property', 'owners', 'data'])
    .toJS();
  dispatch(
    fetchPropertyExemptions({
      propertyId: pid,
      selectedYear: pYear,
      pVersion,
      pRollCorr,
    }),
  );

  dispatch(
    fetchPropertyOwnerNames({
      propertyId: pid,
      selectedYear: pYear,
      pVersion,
      pRollCorr,
    }),
  );

  dispatch(
    fetchPropertyHeader({
      propertyId: pid,
      selectedYear: pYear,
      pVersion,
      pRollCorr,
    }),
  );

  if (owners[0] && owners[0].pAccountID) {
    dispatch(
      fetchTaxable({
        pAccountId: owners[0].pAccountID,
      }),
    );

    dispatch(
      fetchPropertyAgentSummary({
        pAccountId: owners[0].pAccountID,
      }),
    );
  }
};

export const fetchRecalculatedValues = () => async (dispatch, getState) => {
  const state = getState();
  const {
    pID: pid,
    pYear,
    pRollCorr,
    pVersion,
  } = state.getIn(['app', 'appraisal', 'property', 'header', 'data']).toJS();
  const ownerNames = state.getIn([
    'app',
    'appraisal',
    'property',
    'owners',
    'data',
  ]);
  const currentTaxable = state.getIn([
    'app',
    'appraisal',
    'property',
    'taxables',
    'data',
  ]);
  const currentTaxableJs = (currentTaxable && currentTaxable.toJS()) || {};
  const ownerNamesJs = (ownerNames && ownerNames.toJS()) || [];
  if (
    currentTaxableJs &&
    currentTaxableJs.length > 0 &&
    currentTaxableJs[0].pAccountID
  ) {
    dispatch(
      fetchTaxable({
        pAccountId: currentTaxableJs[0].pAccountID,
      }),
    );
  } else {
    if (ownerNamesJs && ownerNamesJs.length) {
      ownerNamesJs.forEach((owner) => {
        dispatch(
          fetchTaxable({
            pAccountId: owner.pAccountID,
          }),
        );
      });
    }
  }

  dispatch(
    fetchPropertyValueSummary({
      propertyId: pid,
      selectedYear: pYear,
      pRollCorr,
      pVersion,
    }),
  );

  dispatch(
    fetchPropertyValuations({
      propertyId: pid,
      pYear: pYear,
      pRollCorr,
      pVersion,
    }),
  );

  dispatch(
    fetchAllValuationsBpp({
      propertyId: pid,
      pYear: pYear,
      pRollCorr,
      pVersion,
    }),
  );

  dispatch(
    fetchPropertyValueSummary({
      propertyId: pid,
      selectedYear: pYear,
      pRollCorr,
      pVersion,
    }),
  );

  dispatch(
    fetchOwnerValueSummary({
      propertyId: pid,
      pYear: pYear,
      pRollCorr,
      pVersion,
    }),
  );

  try {
    const { currentValuation, currentImprovement } = state
      .getIn(['app', 'appraisal', 'property', 'valuationWidgetState'])
      .toJS();
    if (currentValuation) {
      dispatch(fetchPropertyImprovements({ costId: currentValuation }));
      dispatch(fetchPropertyLand({ costId: currentValuation }));
    }
    if (currentImprovement) {
      dispatch(
        fetchPropertyImprovementDetails({ improvementId: currentImprovement }),
      );
    }
  } catch (err) {
    console.log('no current valuation or improvement');
  }

  try {
    const smartGroup = state
      .getIn(['app', 'appraisal', 'property', 'smartGroup', 'data'])
      .toJS();
    if (smartGroup) {
      dispatch(fetchSmartGroup({ groupId: smartGroup.groupID }));
      dispatch(
        fetchSmartGroupProperties({
          groupId: smartGroup.groupID,
        }),
      );
    }
  } catch (err) {
    console.log('no current smart group');
  }

  try {
    const personalDetails = state
      .getIn(['app', 'appraisal', 'property', 'allPersonalDetails', 'data'])
      .toJS();

    if (personalDetails && personalDetails.length) {
      const { pBusinessPropID } = personalDetails[0];
      dispatch(
        fetchPersonalDetailSummary({ pBusinessPropId: pBusinessPropID }),
      );
      dispatch(fetchAllPersonalDetails({ pBusinessPropId: pBusinessPropID }));
    }
  } catch (err) {
    console.log('no personal details');
  }
  try {
    const currentPersonalDetail = state
      .getIn(['app', 'appraisal', 'property', 'personalDetail', 'data'])
      .toJS();
    if (currentPersonalDetail && currentPersonalDetail.pDetailID) {
      const { pDetailID } = currentPersonalDetail;
      dispatch(fetchPersonalDetail({ detailId: pDetailID }));
    }
  } catch (err) {
    console.log('no current personal detail');
  }
  try {
    dispatch(
      fetchAllHsValueLimitations({
        pId: pid,
        pYear,
        pVersion,
        pRollCorr,
      }),
    );
  } catch (err) {
    console.log('no hs value limit');
  }
};

export function resetPropertyData() {
  return async (dispatch) => {
    dispatch({ type: PROPERTY_RESET_DATA });
  };
}

export const SET_BACK_PROPERTY = 'APPRAISAL/SET_BACK_PROPERTY';

export function setBackProperty({ propId, fromSearchType }) {
  return async (dispatch) => {
    dispatch({
      type: SET_BACK_PROPERTY,
      data: {
        propId,
        fromSearchType,
      },
    });
  };
}

export const SET_PROPERTY_EVENT_BACK_OPTION =
  'APPRAISAL/SET_PROPERTY_EVENT_BACK_OPTION';

export function setPropertyEventBackOption(option) {
  return async (dispatch) => {
    dispatch({
      type: SET_PROPERTY_EVENT_BACK_OPTION,
      data: option,
    });
  };
}

export const fetchSearchConfig = makeApiActionCreatorV3(
  api.fetchSearchConfig,
  FETCH_SEARCH_CONFIG_START,
  FETCH_SEARCH_CONFIG_SUCCESS,
  FETCH_SEARCH_CONFIG_ERROR,
);

export const fetchSearchResultsConfig = makeApiActionCreatorV3(
  api.fetchSearchResultsConfig,
  FETCH_SEARCH_RESULTS_CONFIG_START,
  FETCH_SEARCH_RESULTS_CONFIG_SUCCESS,
  FETCH_SEARCH_RESULTS_CONFIG_ERROR,
);

export const searchProperty = makeApiActionCreatorV3(
  api.searchProperty,
  PROPERTY_SEARCH_START,
  PROPERTY_SEARCH_SUCCESS,
  PROPERTY_SEARCH_ERROR,
);

export const searchPropertyStandalone = makeApiActionCreatorV3(
  api.searchPropertyStandalone,
  PROPERTY_SEARCH_STANDALONE_START,
  PROPERTY_SEARCH_STANDALONE_SUCCESS,
  PROPERTY_SEARCH_STANDALONE_ERROR,
);

export const searchPropertyExport = makeApiActionCreatorV3(
  api.searchPropertyExport,
  PROPERTY_SEARCH_STANDALONE_START,
  PROPERTY_SEARCH_STANDALONE_SUCCESS,
  PROPERTY_SEARCH_STANDALONE_ERROR,
);

export const fetchAppraisalConfiguration = makeApiActionCreatorV3(
  api.fetchAppraisalConfiguration,
  FETCH_APPRAISAL_CONFIGURATION_START,
  FETCH_APPRAISAL_CONFIGURATION_SUCCESS,
  FETCH_APPRAISAL_CONFIGURATION_ERROR,
);

export const fetchPropertyMassCreate = makeApiActionCreatorV3(
  api.fetchPropertyMassCreate,
  PROPERTY_MASS_CREATE_FETCH[START],
  PROPERTY_MASS_CREATE_FETCH[SUCCESS],
  PROPERTY_MASS_CREATE_FETCH[ERROR],
);

export const fetchIndividualMassCreate = makeApiActionCreatorV3(
  api.fetchIndividualMassCreate,
  PROPERTY_INDIVIDUAL_MASS_CREATE_FETCH[START],
  PROPERTY_INDIVIDUAL_MASS_CREATE_FETCH[SUCCESS],
  PROPERTY_INDIVIDUAL_MASS_CREATE_FETCH[ERROR],
);

export const createPropertyMassCreate = makeApiActionCreatorV3(
  api.createPropertyMassCreate,
  PROPERTY_MASS_CREATE_CREATE[START],
  PROPERTY_MASS_CREATE_CREATE[SUCCESS],
  PROPERTY_MASS_CREATE_CREATE[ERROR],
);

export const createMassCreatePrepData = makeApiActionCreatorV3(
  api.createMassCreatePrepData,
  PROPERTY_MASS_CREATE_PREP_DATA[START],
  PROPERTY_MASS_CREATE_PREP_DATA[SUCCESS],
  PROPERTY_MASS_CREATE_PREP_DATA[ERROR],
);

export const getMassCreateLegalDesc = makeApiActionCreatorV3(
  api.getMassCreateLegalDesc,
  PROPERTY_MASS_CREATE_LEGAL_DESC[START],
  PROPERTY_MASS_CREATE_LEGAL_DESC[SUCCESS],
  PROPERTY_MASS_CREATE_LEGAL_DESC[ERROR],
);

export const clearMassCreatePrepData = () => ({
  type: PROPERTY_MASS_CREATE_CLEAR_PREP_DATA,
});

export const createPropertyMassCreateProperties = makeApiActionCreatorV3(
  api.massCreateProperties,
  PROPERTY_MASS_CREATE_CREATE_PROPERTIES[START],
  PROPERTY_MASS_CREATE_CREATE_PROPERTIES[SUCCESS],
  PROPERTY_MASS_CREATE_CREATE_PROPERTIES[ERROR],
);

export const finalizeMassCreateRun = makeApiActionCreatorV3(
  api.finalizeMassCreateRun,
  PROPERTY_MASS_CREATE_FINALIZE[START],
  PROPERTY_MASS_CREATE_FINALIZE[SUCCESS],
  PROPERTY_MASS_CREATE_FINALIZE[ERROR],
);

export const fetchMassCreateProperties = makeApiActionCreatorV3(
  api.fetchMassCreateProperties,
  PROPERTY_MASS_CREATE_PROPERTIES[START],
  PROPERTY_MASS_CREATE_PROPERTIES[SUCCESS],
  PROPERTY_MASS_CREATE_PROPERTIES[ERROR],
);

export const deleteMassCreateRun = makeApiActionCreatorV3(
  api.deleteMassCreateRun,
  PROPERTY_MASS_CREATE_DELETE[START],
  PROPERTY_MASS_CREATE_DELETE[SUCCESS],
  PROPERTY_MASS_CREATE_DELETE[ERROR],
);

export const fetchAllPropertyMassCreateSettings = makeApiActionCreatorV3(
  api.fetchAllMassCreateSettings,
  PROPERTY_MASS_CREATE_SETTINGS_FETCH_ALL[START],
  PROPERTY_MASS_CREATE_SETTINGS_FETCH_ALL[SUCCESS],
  PROPERTY_MASS_CREATE_SETTINGS_FETCH_ALL[ERROR],
);

export const fetchPropertyMassCreateSetting = makeApiActionCreatorV3(
  api.fetchMassCreateSetting,
  PROPERTY_MASS_CREATE_SETTING_FETCH[START],
  PROPERTY_MASS_CREATE_SETTING_FETCH[SUCCESS],
  PROPERTY_MASS_CREATE_SETTING_FETCH[ERROR],
);

export const deletePropertyMassCreateSetting = makeApiActionCreatorV3(
  api.deleteMassCreateSettings,
  PROPERTY_MASS_CREATE_SETTING_DELETE[START],
  PROPERTY_MASS_CREATE_SETTING_DELETE[SUCCESS],
  PROPERTY_MASS_CREATE_SETTING_DELETE[ERROR],
);

export const fetchPropertyMassCreateSettingAvailPropTypes =
  makeApiActionCreatorV3(
    api.fetchAvailableMassCreateSettingPropTypes,
    PROPERTY_MASS_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES[START],
    PROPERTY_MASS_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES[SUCCESS],
    PROPERTY_MASS_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES[ERROR],
  );

export const addPropertyMassCreateSetting = makeApiActionCreatorV3(
  api.addMassCreateSetting,
  PROPERTY_MASS_CREATE_SETTING_ADD[START],
  PROPERTY_MASS_CREATE_SETTING_ADD[SUCCESS],
  PROPERTY_MASS_CREATE_SETTING_ADD[ERROR],
);

export const updatePropertyMassCreateSetting = makeApiActionCreatorV3(
  api.updateMassCreateSetting,
  PROPERTY_MASS_CREATE_SETTING_EDIT[START],
  PROPERTY_MASS_CREATE_SETTING_EDIT[SUCCESS],
  PROPERTY_MASS_CREATE_SETTING_EDIT[ERROR],
);

export const fetchPropertyMassCreatePage = makeApiActionCreatorV3(
  api.fetchMassCreatePropertyPage,
  PROPERTY_MASS_CREATE_PAGE_FETCH[START],
  PROPERTY_MASS_CREATE_PAGE_FETCH[SUCCESS],
  PROPERTY_MASS_CREATE_PAGE_FETCH[ERROR],
);

export const deleteApplication = makeApiActionCreatorV3(
  api.deleteApplication,
  DELETE_APPLICATION_START,
  DELETE_APPLICATION_SUCCESS,
  DELETE_APPLICATION_ERROR,
);

export const fetchApplicationExemptions = makeApiActionCreatorV3(
  api.fetchApplicationExemptions,
  FETCH_APPLICATION_EXEMPTIONS_START,
  FETCH_APPLICATION_EXEMPTIONS_SUCCESS,
  FETCH_APPLICATION_EXEMPTIONS_ERROR,
);

export const fetchApplications = makeApiActionCreatorV3(
  api.fetchApplications,
  FETCH_APPLICATIONS_START,
  FETCH_APPLICATIONS_SUCCESS,
  FETCH_APPLICATIONS_ERROR,
);

export const resetApplications = () => ({
  type: RESET_APPLICATIONS,
});

export const fetchApplication = makeApiActionCreatorV3(
  api.fetchApplication,
  FETCH_APPLICATION[START],
  FETCH_APPLICATION[SUCCESS],
  FETCH_APPLICATION[ERROR],
);

export const fetchApplicationType = makeApiActionCreatorV3(
  api.fetchApplicationType,
  FETCH_APPLICATION_TYPE_START,
  FETCH_APPLICATION_TYPE_SUCCESS,
  FETCH_APPLICATION_TYPE_ERROR,
);

export const fetchApplicationStatus = makeApiActionCreatorV3(
  api.fetchApplicationStatus,
  FETCH_APPLICATION_STATUS_START,
  FETCH_APPLICATION_STATUS_SUCCESS,
  FETCH_APPLICATION_STATUS_ERROR,
);

export const fetchApplicationOwners = makeApiActionCreatorV3(
  api.fetchApplicationOwners,
  FETCH_APPLICATION_OWNERS_START,
  FETCH_APPLICATION_OWNERS_SUCCESS,
  FETCH_APPLICATION_OWNERS_ERROR,
);

export const fetchApplicationIDType = makeApiActionCreatorV3(
  api.fetchApplicationIDType,
  FETCH_APPLICATION_ID_TYPE_START,
  FETCH_APPLICATION_ID_TYPE_SUCCESS,
  FETCH_APPLICATION_ID_TYPE_ERROR,
);

export const createApplication = makeApiActionCreatorV3(
  api.createApplication,
  CREATE_APPLICATION_START,
  CREATE_APPLICATION_SUCCESS,
  CREATE_APPLICATION_ERROR,
);

export const updateApplication = makeApiActionCreatorV3(
  api.updateApplication,
  UPDATE_APPLICATION_START,
  UPDATE_APPLICATION_SUCCESS,
  UPDATE_APPLICATION_ERROR,
);

export const completeApplication = makeApiActionCreatorV3(
  api.completeApplication,
  COMPLETE_APPLICATION[START],
  COMPLETE_APPLICATION[SUCCESS],
  COMPLETE_APPLICATION[ERROR],
);

export const completeApplicationMultiYear = makeApiActionCreatorV3(
  api.completeApplicationMultiYear,
  COMPLETE_APPLICATION_MULTI_YEAR[START],
  COMPLETE_APPLICATION_MULTI_YEAR[SUCCESS],
  COMPLETE_APPLICATION_MULTI_YEAR[ERROR],
);

export const fetchApplicationRollCorrectionCodes = makeApiActionCreatorV3(
  api.fetchApplicationRollCorrectionCodes,
  FETCH_APPLICATION_ROLL_CORRECTION_CODES_START,
  FETCH_APPLICATION_ROLL_CORRECTION_CODES_SUCCESS,
  FETCH_APPLICATION_ROLL_CORRECTION_CODES_ERROR,
);

export const fetchApplicationPropertyList = makeApiActionCreatorV3(
  api.fetchApplicationPropertyList,
  FETCH_APPLICATION_PROPERTY_LIST[START],
  FETCH_APPLICATION_PROPERTY_LIST[SUCCESS],
  FETCH_APPLICATION_PROPERTY_LIST[ERROR],
);

export const fetchCyclomediaBetterView = makeApiActionCreatorV3(
  api.fetchCyclomediaBetterView,
  FETCH_CYCLOMEDIA_BETTER_VIEW[START],
  FETCH_CYCLOMEDIA_BETTER_VIEW[SUCCESS],
  FETCH_CYCLOMEDIA_BETTER_VIEW[ERROR],
);

export const fetchExemptionCodefiles = makeApiActionCreatorV3(
  api.fetchExemptionCodefiles,
  FETCH_EXEMPTION_CODEFILES_START,
  FETCH_EXEMPTION_CODEFILES_SUCCESS,
  FETCH_EXEMPTION_CODEFILES_ERROR,
);

export const fetchAutoCompleteLegal = makeApiActionCreatorV3(
  api.fetchAutoCompleteLegal,
  FETCH_AUTO_COMPLETE_LEGAL_START,
  FETCH_AUTO_COMPLETE_LEGAL_SUCCESS,
  FETCH_AUTO_COMPLETE_LEGAL_ERROR,
);

export const fetchExemptionYears = makeApiActionCreatorV3(
  api.fetchExemptionYears,
  FETCH_EXEMPTION_YEARS_START,
  FETCH_EXEMPTION_YEARS_SUCCESS,
  FETCH_EXEMPTION_YEARS_ERROR,
);

export const createExemption = makeApiActionCreatorV3(
  api.createExemption,
  CREATE_EXEMPTION_START,
  CREATE_EXEMPTION_SUCCESS,
  CREATE_EXEMPTION_ERROR,
);

export const updateExemption = makeApiActionCreatorV3(
  api.updateExemption,
  UPDATE_EXEMPTION_START,
  UPDATE_EXEMPTION_SUCCESS,
  UPDATE_EXEMPTION_ERROR,
);

export const deleteExemption = makeApiActionCreatorV3(
  api.deleteExemption,
  DELETE_EXEMPTION_START,
  DELETE_EXEMPTION_SUCCESS,
  DELETE_EXEMPTION_ERROR,
);

export const approveExemption = makeApiActionCreatorV3(
  api.approveExemption,
  APPROVE_EXEMPTION_START,
  APPROVE_EXEMPTION_SUCCESS,
  APPROVE_EXEMPTION_ERROR,
);

export const denyExemption = makeApiActionCreatorV3(
  api.denyExemption,
  DENY_EXEMPTION_START,
  DENY_EXEMPTION_SUCCESS,
  DENY_EXEMPTION_ERROR,
);

export const undoExemption = makeApiActionCreatorV3(
  api.undoExemption,
  UNDO_EXEMPTION_START,
  UNDO_EXEMPTION_SUCCESS,
  UNDO_EXEMPTION_ERROR,
);

export const uploadApplicationFile = makeApiActionCreatorV3(
  api.uploadApplicationFile,
  UPLOAD_APPLICATION_FILE_START,
  UPLOAD_APPLICATION_FILE_SUCCESS,
  UPLOAD_APPLICATION_FILE_ERROR,
);

export const updateApplicationFile = makeApiActionCreatorV3(
  api.updateApplicationFile,
  UPDATE_APPLICATION_FILE_START,
  UPDATE_APPLICATION_FILE_SUCCESS,
  UPDATE_APPLICATION_FILE_ERROR,
);

export const downloadApplicationFile = makeApiActionCreatorV3(
  api.downloadApplicationFile,
  DOWNLOAD_APPLICATION_FILE_START,
  DOWNLOAD_APPLICATION_FILE_SUCCESS,
  DOWNLOAD_APPLICATION_FILE_ERROR,
);

export const retrieveApplicationFile = makeApiActionCreatorV3(
  api.retrieveApplicationFile,
  RETRIEVE_APPLICATION_FILE[START],
  RETRIEVE_APPLICATION_FILE[SUCCESS],
  RETRIEVE_APPLICATION_FILE[ERROR],
);

export const deleteApplicationFile = makeApiActionCreatorV3(
  api.deleteApplicationFile,
  DELETE_APPLICATION_FILE_START,
  DELETE_APPLICATION_FILE_SUCCESS,
  DELETE_APPLICATION_FILE_ERROR,
);

export const searchApplicationEvents = makeApiActionCreatorV3(
  api.searchApplicationEvents,
  SEARCH_APPLICATION_EVENTS_START,
  SEARCH_APPLICATION_EVENTS_SUCCESS,
  SEARCH_APPLICATION_EVENTS_ERROR,
);

export const fetchApplicationEventTypes = makeApiActionCreatorV3(
  api.fetchApplicationEventTypes,
  FETCH_APPLICATION_EVENT_TYPES_START,
  FETCH_APPLICATION_EVENT_TYPES_SUCCESS,
  FETCH_APPLICATION_EVENT_TYPES_ERROR,
);

export const fetchApplicationEventTags = makeApiActionCreatorV3(
  api.fetchApplicationEventTags,
  FETCH_APPLICATION_EVENT_TAGS_START,
  FETCH_APPLICATION_EVENT_TAGS_SUCCESS,
  FETCH_APPLICATION_EVENT_TAGS_ERROR,
);

export const fetchApplicationEventForms = makeApiActionCreatorV3(
  api.fetchApplicationEventForms,
  FETCH_APPLICATION_EVENT_FORMS_START,
  FETCH_APPLICATION_EVENT_FORMS_SUCCESS,
  FETCH_APPLICATION_EVENT_FORMS_ERROR,
);

export const changePage = (page) => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const changeRowsPerPage = (rowsPerPage) => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const changeSortModel = (model) => ({
  type: CHANGE_SORT_MODEL,
  payload: model,
});

export const changeFilterModel = (model) => ({
  type: CHANGE_FILTER_MODEL,
  payload: model,
});

export const updatePropertyExemptionReset = makeApiActionCreatorV3(
  api.updatePropertyExemptionReset,
  PROPERTY_EXEMPTION_RESET_UPDATE[START],
  PROPERTY_EXEMPTION_RESET_UPDATE[SUCCESS],
  PROPERTY_EXEMPTION_RESET_UPDATE[ERROR],
);

export const updatePropertyTaxDeferral = makeApiActionCreatorV3(
  api.updatePropertyTaxDeferral,
  PROPERTY_TAX_DEFERRAL_UPDATE[START],
  PROPERTY_TAX_DEFERRAL_UPDATE[SUCCESS],
  PROPERTY_TAX_DEFERRAL_UPDATE[ERROR],
);

export const fetchPropertyTaxDeferral = makeApiActionCreatorV3(
  api.fetchPropertyTaxDeferral,
  PROPERTY_TAX_DEFERRAL_FETCH[START],
  PROPERTY_TAX_DEFERRAL_FETCH[SUCCESS],
  PROPERTY_TAX_DEFERRAL_FETCH[ERROR],
);

export const postWalkthroughSettings = makeApiActionCreatorV3(
  api.postWalkthroughSettings,
  WALKTHROUGH_SETTINGS_POST[START],
  WALKTHROUGH_SETTINGS_POST[SUCCESS],
  WALKTHROUGH_SETTINGS_POST[ERROR],
);

export const fetchAllWalkthroughSettings = makeApiActionCreatorV3(
  api.fetchAllWalkthroughSettings,
  WALKTHROUGH_SETTINGS_FETCH_ALL[START],
  WALKTHROUGH_SETTINGS_FETCH_ALL[SUCCESS],
  WALKTHROUGH_SETTINGS_FETCH_ALL[ERROR],
);

export const updateWalkthroughSetting = makeApiActionCreatorV3(
  api.updateWalkthroughSetting,
  WALKTHROUGH_SETTING_UPDATE[START],
  WALKTHROUGH_SETTING_UPDATE[SUCCESS],
  WALKTHROUGH_SETTING_UPDATE[ERROR],
);

export const deleteWalkthroughSetting = makeApiActionCreatorV3(
  api.deleteWalkthroughSetting,
  WALKTHROUGH_SETTING_DELETE[START],
  WALKTHROUGH_SETTING_DELETE[SUCCESS],
  WALKTHROUGH_SETTING_DELETE[ERROR],
);

export const addMergeProperty = (data) => ({
  type: ADD_MERGE_PROPERTY,
  data,
});

export const removeMergeProperty = (propertyId) => ({
  type: REMOVE_MERGE_PROPERTY,
  data: propertyId,
});

export const resetMergeProperty = () => ({
  type: RESET_MERGE_PROPERTY,
});

export const createPropertyMerge = makeApiActionCreatorV3(
  api.createPropertyMerge,
  CREATE_PROPERTY_MERGE[START],
  CREATE_PROPERTY_MERGE[SUCCESS],
  CREATE_PROPERTY_MERGE[ERROR],
);

export const uploadPropertyMergeFile = makeApiActionCreatorV3(
  api.uploadPropertyMergeFile,
  UPLOAD_PROPERTY_MERGE_FILE[START],
  UPLOAD_PROPERTY_MERGE_FILE[SUCCESS],
  UPLOAD_PROPERTY_MERGE_FILE[ERROR],
);

export const createSingleProperty = makeApiActionCreatorV3(
  api.createSingleProperty,
  CREATE_SINGLE_PROPERTY[START],
  CREATE_SINGLE_PROPERTY[SUCCESS],
  CREATE_SINGLE_PROPERTY[ERROR],
);

export const deleteSingleProperty = makeApiActionCreatorV3(
  api.deleteSingleProperty,
  DELETE_SINGLE_PROPERTY[START],
  DELETE_SINGLE_PROPERTY[SUCCESS],
  DELETE_SINGLE_PROPERTY[ERROR],
);

export const fetchPropertyCreateSettingAvailPropTypes = makeApiActionCreatorV3(
  api.fetchAvailablePropertyCreateSettingPropTypes,
  PROPERTY_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES[START],
  PROPERTY_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES[SUCCESS],
  PROPERTY_CREATE_SETTING_FETCH_AVAIL_PROP_TYPES[ERROR],
);

export const fetchMergeToOwnerListing = makeApiActionCreatorV3(
  api.fetchPropertyMergeToOwnerListing,
  FETCH_MERGE_TO_PROPERTY_OWNERS[START],
  FETCH_MERGE_TO_PROPERTY_OWNERS[SUCCESS],
  FETCH_MERGE_TO_PROPERTY_OWNERS[ERROR],
);

export const fetchMergeFromOwnerListing = makeApiActionCreatorV3(
  api.fetchPropertyMergeFromOwnerListing,
  FETCH_MERGE_FROM_PROPERTY_OWNERS[START],
  FETCH_MERGE_FROM_PROPERTY_OWNERS[SUCCESS],
  FETCH_MERGE_FROM_PROPERTY_OWNERS[ERROR],
);

export const createPropertySplit = makeApiActionCreatorV3(
  api.createPropertySplit,
  CREATE_PROPERTY_SPLIT[START],
  CREATE_PROPERTY_SPLIT[SUCCESS],
  CREATE_PROPERTY_SPLIT[ERROR],
);

export const updateOwnershipPercent = makeApiActionCreatorV3(
  api.updateOwnershipPercent,
  UPDATE_OWNERSHIP_PERCENT[START],
  UPDATE_OWNERSHIP_PERCENT[SUCCESS],
  UPDATE_OWNERSHIP_PERCENT[ERROR],
);

export const updateLegalAcreage = makeApiActionCreatorV3(
  api.updateLegalAcreage,
  UPDATE_LEGAL_ACREAGE[START],
  UPDATE_LEGAL_ACREAGE[SUCCESS],
  UPDATE_LEGAL_ACREAGE[ERROR],
);

export const getPropertyInactiveReasons = makeApiActionCreatorV3(
  api.getPropertyInactiveReasons,
  GET_PROPERTY_INACTIVE_REASONS[START],
  GET_PROPERTY_INACTIVE_REASONS[SUCCESS],
  GET_PROPERTY_INACTIVE_REASONS[ERROR],
);

export const getPropertyReactivateReasons = makeApiActionCreatorV3(
  api.getPropertyReactivateReasons,
  GET_PROPERTY_REACTIVATE_REASONS[START],
  GET_PROPERTY_REACTIVATE_REASONS[SUCCESS],
  GET_PROPERTY_REACTIVATE_REASONS[ERROR],
);

export const propertyInactivate = makeApiActionCreatorV3(
  api.propertyInactivate,
  PROPERTY_INACTIVATE[START],
  PROPERTY_INACTIVATE[SUCCESS],
  PROPERTY_INACTIVATE[ERROR],
);

export const propertyReactivate = makeApiActionCreatorV3(
  api.propertyReactivate,
  PROPERTY_REACTIVATE[START],
  PROPERTY_REACTIVATE[SUCCESS],
  PROPERTY_REACTIVATE[ERROR],
);

export const getSplitReasons = makeApiActionCreatorV3(
  api.getSplitReasons,
  GET_SPLIT_REASONS[START],
  GET_SPLIT_REASONS[SUCCESS],
  GET_SPLIT_REASONS[ERROR],
);

export const resetPropertySplitData = () => ({
  type: RESET_PROPERTY_SPLIT_DATA,
});

export const fetchSplitMergeHistoryDeedInfo = makeApiActionCreatorV3(
  api.fetchSplitMergeHistoryDeedInfo,
  FETCH_SPLIT_MERGE_HISTORY_DEED_INFO[START],
  FETCH_SPLIT_MERGE_HISTORY_DEED_INFO[SUCCESS],
  FETCH_SPLIT_MERGE_HISTORY_DEED_INFO[ERROR],
);

export const updateSplitMergeHistoryChildren = makeApiActionCreatorV3(
  api.updateSplitMergeHistoryChildren,
  UPDATE_SPLIT_MERGE_HISTORY_CHILDREN[START],
  UPDATE_SPLIT_MERGE_HISTORY_CHILDREN[SUCCESS],
  UPDATE_SPLIT_MERGE_HISTORY_CHILDREN[ERROR],
);

export const fetchSplitMergeHistorySummary = makeApiActionCreatorV3(
  api.fetchSplitMergeHistorySummary,
  FETCH_SPLIT_MERGE_HISTORY_SUMMARY[START],
  FETCH_SPLIT_MERGE_HISTORY_SUMMARY[SUCCESS],
  FETCH_SPLIT_MERGE_HISTORY_SUMMARY[ERROR],
);

export const fetchAllValuationsBpp = makeApiActionCreatorV3(
  api.fetchAllValuationsBpp,
  FETCH_ALL_VALUATIONS_BPP[START],
  FETCH_ALL_VALUATIONS_BPP[SUCCESS],
  FETCH_ALL_VALUATIONS_BPP[ERROR],
  true,
);

export const fetchBppSubDetails = makeApiActionCreatorV3(
  api.fetchBppSubDetails,
  FETCH_BPP_SUB_DETAILS[START],
  FETCH_BPP_SUB_DETAILS[SUCCESS],
  FETCH_BPP_SUB_DETAILS[ERROR],
  true,
);

export const createBppSubDetail = makeApiActionCreatorV3(
  api.createBppSubDetail,
  CREATE_BPP_SUB_DETAIL[START],
  CREATE_BPP_SUB_DETAIL[SUCCESS],
  CREATE_BPP_SUB_DETAIL[ERROR],
);

export const updateBppSubDetail = makeApiActionCreatorV3(
  api.updateBppSubDetail,
  UPDATE_BPP_SUB_DETAIL[START],
  UPDATE_BPP_SUB_DETAIL[SUCCESS],
  UPDATE_BPP_SUB_DETAIL[ERROR],
);

export const deleteBppSubDetail = makeApiActionCreatorV3(
  api.deleteBppSubDetail,
  DELETE_BPP_SUB_DETAIL[START],
  DELETE_BPP_SUB_DETAIL[SUCCESS],
  DELETE_BPP_SUB_DETAIL[ERROR],
);

export const deleteAllBppSubDetails = makeApiActionCreatorV3(
  api.deleteAllBppSubDetails,
  DELETE_ALL_BPP_SUB_DETAILS[START],
  DELETE_ALL_BPP_SUB_DETAILS[SUCCESS],
  DELETE_ALL_BPP_SUB_DETAILS[ERROR],
);

export const massUpdateBppSubDetail = makeApiActionCreatorV3(
  api.massUpdateBppSubDetail,
  MASS_UPDATE_BPP_SUB_DETAIL[START],
  MASS_UPDATE_BPP_SUB_DETAIL[SUCCESS],
  MASS_UPDATE_BPP_SUB_DETAIL[ERROR],
);

export const createPropertyValuationBpp = makeApiActionCreatorV3(
  api.createPropertyValuationBpp,
  PROPERTY_CREATE_VALUATION_BPP[START],
  PROPERTY_CREATE_VALUATION_BPP[SUCCESS],
  PROPERTY_CREATE_VALUATION_BPP[ERROR],
);

export const fetchPersonalDepreciationCategoryMethods = makeApiActionCreatorV3(
  api.fetchPersonalDepreciationCategoryMethods,
  FETCH_PERSONAL_DEPRECIATION_CATEGORY_METHODS[START],
  FETCH_PERSONAL_DEPRECIATION_CATEGORY_METHODS[SUCCESS],
  FETCH_PERSONAL_DEPRECIATION_CATEGORY_METHODS[ERROR],
);

export const fetchPersonalDetailSummary = makeApiActionCreatorV3(
  api.fetchPersonalDetailSummary,
  FETCH_PERSONAL_DETAIL_SUMMARY[START],
  FETCH_PERSONAL_DETAIL_SUMMARY[SUCCESS],
  FETCH_PERSONAL_DETAIL_SUMMARY[ERROR],
);

export const fetchAllPersonalDetails = makeApiActionCreatorV3(
  api.fetchAllPersonalDetails,
  FETCH_ALL_PERSONAL_DETAILS[START],
  FETCH_ALL_PERSONAL_DETAILS[SUCCESS],
  FETCH_ALL_PERSONAL_DETAILS[ERROR],
);

export const exportAllPersonalDetails = makeApiActionCreatorV3(
  api.exportAllPersonalDetails,
  EXPORT_ALL_PERSONAL_DETAILS[START],
  EXPORT_ALL_PERSONAL_DETAILS[SUCCESS],
  EXPORT_ALL_PERSONAL_DETAILS[ERROR],
);

export const fetchPersonalDetail = makeApiActionCreatorV3(
  api.fetchPersonalDetail,
  FETCH_PERSONAL_DETAIL[START],
  FETCH_PERSONAL_DETAIL[SUCCESS],
  FETCH_PERSONAL_DETAIL[ERROR],
);

export const insertPersonalDetail = makeApiActionCreatorV3(
  api.insertPersonalDetail,
  INSERT_PERSONAL_DETAIL[START],
  INSERT_PERSONAL_DETAIL[SUCCESS],
  INSERT_PERSONAL_DETAIL[ERROR],
);

export const updatePersonalDetail = makeApiActionCreatorV3(
  api.updatePersonalDetail,
  UPDATE_PERSONAL_DETAIL[START],
  UPDATE_PERSONAL_DETAIL[SUCCESS],
  UPDATE_PERSONAL_DETAIL[ERROR],
);

export const deletePersonalDetail = makeApiActionCreatorV3(
  api.deletePersonalDetail,
  DELETE_PERSONAL_DETAIL[START],
  DELETE_PERSONAL_DETAIL[SUCCESS],
  DELETE_PERSONAL_DETAIL[ERROR],
);

export const deleteAllPersonalDetails = makeApiActionCreatorV3(
  api.deleteAllPersonalDetails,
  DELETE_ALL_PERSONAL_DETAILS[START],
  DELETE_ALL_PERSONAL_DETAILS[SUCCESS],
  DELETE_ALL_PERSONAL_DETAILS[ERROR],
);

export const fetchPersonalDetailTaxingUnits = makeApiActionCreatorV3(
  api.fetchPersonalDetailTaxingUnits,
  FETCH_PERSONAL_DETAIL_TAXING_UNITS[START],
  FETCH_PERSONAL_DETAIL_TAXING_UNITS[SUCCESS],
  FETCH_PERSONAL_DETAIL_TAXING_UNITS[ERROR],
);

export const insertPersonalDetailTaxingUnit = makeApiActionCreatorV3(
  api.insertPersonalDetailTaxingUnit,
  INSERT_PERSONAL_DETAIL_TAXING_UNIT[START],
  INSERT_PERSONAL_DETAIL_TAXING_UNIT[SUCCESS],
  INSERT_PERSONAL_DETAIL_TAXING_UNIT[ERROR],
);

export const updatePersonalDetailTaxingUnit = makeApiActionCreatorV3(
  api.updatePersonalDetailTaxingUnit,
  UPDATE_PERSONAL_DETAIL_TAXING_UNIT[START],
  UPDATE_PERSONAL_DETAIL_TAXING_UNIT[SUCCESS],
  UPDATE_PERSONAL_DETAIL_TAXING_UNIT[ERROR],
);

export const deletePersonalDetailTaxingUnit = makeApiActionCreatorV3(
  api.deletePersonalDetailTaxingUnit,
  DELETE_PERSONAL_DETAIL_TAXING_UNIT[START],
  DELETE_PERSONAL_DETAIL_TAXING_UNIT[SUCCESS],
  DELETE_PERSONAL_DETAIL_TAXING_UNIT[ERROR],
);

export const fetchValuationBppTypes = makeApiActionCreatorV3(
  api.fetchValuationBppTypes,
  FETCH_VALUATION_BPP_TYPES[START],
  FETCH_VALUATION_BPP_TYPES[SUCCESS],
  FETCH_VALUATION_BPP_TYPES[ERROR],
);

export const updateValuationBpp = makeApiActionCreatorV3(
  api.updateValuationBpp,
  UPDATE_VALUATION_BPP[START],
  UPDATE_VALUATION_BPP[SUCCESS],
  UPDATE_VALUATION_BPP[ERROR],
);

export const fetchAllRenditionsBpp = makeApiActionCreatorV3(
  api.fetchAllRenditionsBpp,
  FETCH_ALL_RENDITIONS_BPP[START],
  FETCH_ALL_RENDITIONS_BPP[SUCCESS],
  FETCH_ALL_RENDITIONS_BPP[ERROR],
  true,
);

export const fetchBPPLateRenditionPenalty = makeApiActionCreatorV3(
  api.fetchBPPLateRenditionPenalty,
  FETCH_BPP_LATE_RENDITION_PENALTY[START],
  FETCH_BPP_LATE_RENDITION_PENALTY[SUCCESS],
  FETCH_BPP_LATE_RENDITION_PENALTY[ERROR],
);

export const updateBPPLateRenditionPenalty = makeApiActionCreatorV3(
  api.updateBPPLateRenditionPenalty,
  UPDATE_BPP_LATE_RENDITION_PENALTY[START],
  UPDATE_BPP_LATE_RENDITION_PENALTY[SUCCESS],
  UPDATE_BPP_LATE_RENDITION_PENALTY[ERROR],
);

export const fetchBPPLateRenditionPenaltyNew = makeApiActionCreatorV3(
  api.fetchBPPLateRenditionPenaltyNew,
  FETCH_BPP_LATE_RENDITION_PENALTY[START],
  FETCH_BPP_LATE_RENDITION_PENALTY[SUCCESS],
  FETCH_BPP_LATE_RENDITION_PENALTY[ERROR],
);

export const updateBPPLateRenditionPenaltyNew = makeApiActionCreatorV3(
  api.updateBPPLateRenditionPenaltyNew,
  UPDATE_BPP_LATE_RENDITION_PENALTY[START],
  UPDATE_BPP_LATE_RENDITION_PENALTY[SUCCESS],
  UPDATE_BPP_LATE_RENDITION_PENALTY[ERROR],
);

export const updateBPPLateRenditionPenaltyInit = makeApiActionCreatorV3(
  api.updateBPPLateRenditionPenaltyNew,
  UPDATE_BPP_LATE_RENDITION_PENALTY_INIT[START],
  UPDATE_BPP_LATE_RENDITION_PENALTY_INIT[SUCCESS],
  UPDATE_BPP_LATE_RENDITION_PENALTY_INIT[ERROR],
);

export const fetchBPPRenditionExtensionRequests = makeApiActionCreatorV3(
  api.fetchBPPRenditionExtensionRequests,
  FETCH_BPP_RENDITION_EXTENSION_REQUESTS[START],
  FETCH_BPP_RENDITION_EXTENSION_REQUESTS[SUCCESS],
  FETCH_BPP_RENDITION_EXTENSION_REQUESTS[ERROR],
);

export const updateBPPRenditionExtensionRequests = makeApiActionCreatorV3(
  api.updateBPPRenditionExtensionRequests,
  UPDATE_BPP_RENDITION_EXTENSION_REQUESTS[START],
  UPDATE_BPP_RENDITION_EXTENSION_REQUESTS[SUCCESS],
  UPDATE_BPP_RENDITION_EXTENSION_REQUESTS[ERROR],
);

export const updateBPPRenditionExtensionRequestsInit = makeApiActionCreatorV3(
  api.updateBPPRenditionExtensionRequests,
  UPDATE_BPP_RENDITION_EXTENSION_REQUESTS_INIT[START],
  UPDATE_BPP_RENDITION_EXTENSION_REQUESTS_INIT[SUCCESS],
  UPDATE_BPP_RENDITION_EXTENSION_REQUESTS_INIT[ERROR],
);

export const resetRenditionsBpp = () => ({
  type: RESET_RENDITIONS_BPP,
});

export const insertPersonalRendition = makeApiActionCreatorV3(
  api.insertPersonalRendition,
  INSERT_PERSONAL_RENDITION[START],
  INSERT_PERSONAL_RENDITION[SUCCESS],
  INSERT_PERSONAL_RENDITION[ERROR],
);

export const updatePersonalRendition = makeApiActionCreatorV3(
  api.updatePersonalRendition,
  UPDATE_PERSONAL_RENDITION[START],
  UPDATE_PERSONAL_RENDITION[SUCCESS],
  UPDATE_PERSONAL_RENDITION[ERROR],
);

export const personalRenditionActivate = makeApiActionCreatorV3(
  api.personalRenditionActivate,
  PERSONAL_RENDITION_ACTIVATE[START],
  PERSONAL_RENDITION_ACTIVATE[SUCCESS],
  PERSONAL_RENDITION_ACTIVATE[ERROR],
);

export const personalRenditionDeactivate = makeApiActionCreatorV3(
  api.personalRenditionDeactivate,
  PERSONAL_RENDITION_DEACTIVATE[START],
  PERSONAL_RENDITION_DEACTIVATE[SUCCESS],
  PERSONAL_RENDITION_DEACTIVATE[ERROR],
);

export const deletePersonalRendition = makeApiActionCreatorV3(
  api.deletePersonalRendition,
  DELETE_PERSONAL_RENDITION[START],
  DELETE_PERSONAL_RENDITION[SUCCESS],
  DELETE_PERSONAL_RENDITION[ERROR],
);

export const insertPersonalRenditionFiles = makeApiActionCreatorV3(
  api.insertPersonalRenditionFiles,
  INSERT_PERSONAL_RENDITION_FILES[START],
  INSERT_PERSONAL_RENDITION_FILES[SUCCESS],
  INSERT_PERSONAL_RENDITION_FILES[ERROR],
);

export const updatePersonalRenditionFile = makeApiActionCreatorV3(
  api.updatePersonalRenditionFile,
  UPDATE_PERSONAL_RENDITION_FILE[START],
  UPDATE_PERSONAL_RENDITION_FILE[SUCCESS],
  UPDATE_PERSONAL_RENDITION_FILE[ERROR],
);

export const fetchPersonalRenditionFile = makeApiActionCreatorV3(
  api.getPersonalRenditionFile,
  FETCH_PERSONAL_RENDITION_FILE[START],
  FETCH_PERSONAL_RENDITION_FILE[SUCCESS],
  FETCH_PERSONAL_RENDITION_FILE[ERROR],
);

export const deletePersonalRenditionFile = makeApiActionCreatorV3(
  api.deletePersonalRenditionFile,
  DELETE_PERSONAL_RENDITION_FILE[START],
  DELETE_PERSONAL_RENDITION_FILE[SUCCESS],
  DELETE_PERSONAL_RENDITION_FILE[ERROR],
);

export const verifyPersonalRendition = makeApiActionCreatorV3(
  api.verifyPersonalRendition,
  VERIFY_PERSONAL_RENDITION[START],
  VERIFY_PERSONAL_RENDITION[SUCCESS],
  VERIFY_PERSONAL_RENDITION[ERROR],
);

export const unverifyPersonalRendition = makeApiActionCreatorV3(
  api.unverifyPersonalRendition,
  UNVERIFY_PERSONAL_RENDITION[START],
  UNVERIFY_PERSONAL_RENDITION[SUCCESS],
  UNVERIFY_PERSONAL_RENDITION[ERROR],
);

export const fetchPrimaryOwnerDetails = makeApiActionCreatorV3(
  api.fetchPrimaryOwnerDetails,
  FETCH_PRIMARY_OWNER_DETAILS[START],
  FETCH_PRIMARY_OWNER_DETAILS[SUCCESS],
  FETCH_PRIMARY_OWNER_DETAILS[ERROR],
  true,
);

export const clearPrimaryOwnerDetails = () => ({
  type: CLEAR_PRIMARY_OWNER_DETAILS,
});

export const fetchPreviousYearDetails = makeApiActionCreatorV3(
  api.fetchPreviousYearDetails,
  FETCH_PREVIOUS_YEAR_DETAILS[START],
  FETCH_PREVIOUS_YEAR_DETAILS[SUCCESS],
  FETCH_PREVIOUS_YEAR_DETAILS[ERROR],
  true,
);

export const insertPersonalDetailRendition = makeApiActionCreatorV3(
  api.insertPersonalDetailRendition,
  INSERT_PERSONAL_DETAIL_RENDITION[START],
  INSERT_PERSONAL_DETAIL_RENDITION[SUCCESS],
  INSERT_PERSONAL_DETAIL_RENDITION[ERROR],
);

export const deleteRenditionWalkthruDetail = (detailId) => ({
  type: DELETE_RENDITION_WALKTHRU_DETAIL,
  detailId,
});

export const deleteAllRenditionWalkthruDetails = () => ({
  type: DELETE_ALL_RENDITION_WALKTHRU_DETAILS,
});

export const insertRenditionWalkthruDetail = (data) => ({
  type: INSERT_RENDITION_WALKTHRU_DETAIL,
  data,
});

export const updateRenditionWalkthruDetail = ({ detailId, data }) => ({
  type: UPDATE_RENDITION_WALKTHRU_DETAIL,
  detailId,
  data,
});

export const fetchCanProcessRendition = makeApiActionCreatorV3(
  api.fetchCanProcessRendition,
  FETCH_CAN_PROCESS_RENDITION[START],
  FETCH_CAN_PROCESS_RENDITION[SUCCESS],
  FETCH_CAN_PROCESS_RENDITION[ERROR],
);

export const fetchExemptionNotes = makeApiActionCreatorV3(
  api.fetchExemptionNotes,
  EXEMPTION_NOTES_FETCH_START,
  EXEMPTION_NOTES_FETCH_SUCCESS,
  EXEMPTION_NOTES_FETCH_ERROR,
);

export const updateExemptionNote = makeApiActionCreatorV3(
  api.updateExemptionNote,
  EXEMPTION_NOTE_UPDATE_START,
  EXEMPTION_NOTE_UPDATE_SUCCESS,
  EXEMPTION_NOTE_UPDATE_ERROR,
);

export const addExemptionNote = makeApiActionCreatorV3(
  api.addExemptionNote,
  EXEMPTION_NOTE_ADD_START,
  EXEMPTION_NOTE_ADD_SUCCESS,
  EXEMPTION_NOTE_ADD_ERROR,
);

export const deleteExemptionNote = makeApiActionCreatorV3(
  api.deleteExemptionNote,
  EXEMPTION_NOTE_DELETE_START,
  EXEMPTION_NOTE_DELETE_SUCCESS,
  EXEMPTION_NOTE_DELETE_ERROR,
);

export const fetchAllDistinctExemptions = makeApiActionCreatorV3(
  api.fetchAllDistinctExemptions,
  FETCH_ALL_DISTINCT_EXEMPTIONS[START],
  FETCH_ALL_DISTINCT_EXEMPTIONS[SUCCESS],
  FETCH_ALL_DISTINCT_EXEMPTIONS[ERROR],
);

export const fetchCurrentApplicationOwners = makeApiActionCreatorV3(
  api.fetchCurrentApplicationOwners,
  FETCH_CURRENT_APPLICATION_OWNERS[START],
  FETCH_CURRENT_APPLICATION_OWNERS[SUCCESS],
  FETCH_CURRENT_APPLICATION_OWNERS[ERROR],
);

export function setSelectData(data) {
  return async (dispatch) => {
    dispatch({ type: SET_SELECTDATA, windowData: data });
  };
}

export function setSplitPropertyData(data) {
  return async (dispatch) => {
    dispatch({ type: SET_SPLITPROPERTYDATA, windowData: data });
  };
}

export function setPrintCardData(data) {
  return async (dispatch) => {
    dispatch({ type: SET_PRINT_CARD_DATA, windowData: data });
  };
}

export const fetchHSDetails = makeApiActionCreatorV3(
  api.fetchHSDetails,
  FETCH_HS_DETAILS[START],
  FETCH_HS_DETAILS[SUCCESS],
  FETCH_HS_DETAILS[ERROR],
);

export const fetchPropertyOwnerNames = makeApiActionCreatorV3(
  api.fetchPropertyOwnerNames,
  PROPERTY_FETCH_OWNER_NAMES[START],
  PROPERTY_FETCH_OWNER_NAMES[SUCCESS],
  PROPERTY_FETCH_OWNER_NAMES[ERROR],
);

export const fetchTaxable = makeApiActionCreatorV3(
  api.fetchTaxable,
  PROPERTY_FETCH_TAXABLES[START],
  PROPERTY_FETCH_TAXABLES[SUCCESS],
  PROPERTY_FETCH_TAXABLES[ERROR],
);

export const fetchTaxableDetails = makeApiActionCreatorV3(
  api.fetchTaxableDetails,
  PROPERTY_FETCH_TAXABLE_DETAILS[START],
  PROPERTY_FETCH_TAXABLE_DETAILS[SUCCESS],
  PROPERTY_FETCH_TAXABLE_DETAILS[ERROR],
);

export const fetchTaxingUnitSplitBoundaryLines = makeApiActionCreatorV3(
  api.fetchTaxingUnitSplitBoundaryLines,
  PROPERTY_FETCH_TAXING_UNIT_SPLIT_BOUNDARY_LINES[START],
  PROPERTY_FETCH_TAXING_UNIT_SPLIT_BOUNDARY_LINES[SUCCESS],
  PROPERTY_FETCH_TAXING_UNIT_SPLIT_BOUNDARY_LINES[ERROR],
);

export const updateTaxingUnitSplitBoundaryLines = makeApiActionCreatorV3(
  api.updateTaxingUnitSplitBoundaryLines,
  TAXING_UNIT_SPLIT_BOUNDARY_LINES_UPDATE[START],
  TAXING_UNIT_SPLIT_BOUNDARY_LINES_UPDATE[SUCCESS],
  TAXING_UNIT_SPLIT_BOUNDARY_LINES_UPDATE[ERROR],
);

export const fetchTaxingUnitSegments = makeApiActionCreatorV3(
  api.fetchTaxingUnitSegments,
  PROPERTY_FETCH_TAXING_UNIT_SEGMENTS[START],
  PROPERTY_FETCH_TAXING_UNIT_SEGMENTS[SUCCESS],
  PROPERTY_FETCH_TAXING_UNIT_SEGMENTS[ERROR],
);

export const fetchTaxingUnitSegment = makeApiActionCreatorV3(
  api.fetchTaxingUnitSegment,
  PROPERTY_FETCH_TAXING_UNIT_SEGMENT[START],
  PROPERTY_FETCH_TAXING_UNIT_SEGMENT[SUCCESS],
  PROPERTY_FETCH_TAXING_UNIT_SEGMENT[ERROR],
);

export const updateTaxingUnitSegment = makeApiActionCreatorV3(
  api.updateTaxingUnitSegment,
  PROPERTY_UPDATE_TAXING_UNIT_SEGMENT[START],
  PROPERTY_UPDATE_TAXING_UNIT_SEGMENT[SUCCESS],
  PROPERTY_UPDATE_TAXING_UNIT_SEGMENT[ERROR],
);

export const fetchPropertySmartGroups = makeApiActionCreatorV3(
  api.fetchPropertySmartGroups,
  PROPERTY_FETCH_SMART_GROUPS[START],
  PROPERTY_FETCH_SMART_GROUPS[SUCCESS],
  PROPERTY_FETCH_SMART_GROUPS[ERROR],
);

export const fetchSmartGroupProperties = makeApiActionCreatorV3(
  api.fetchSmartGroupProperties,
  PROPERTY_FETCH_SMART_GROUP_PROPERTIES[START],
  PROPERTY_FETCH_SMART_GROUP_PROPERTIES[SUCCESS],
  PROPERTY_FETCH_SMART_GROUP_PROPERTIES[ERROR],
);

export const insertSmartGroupProperty = makeApiActionCreatorV3(
  api.insertSmartGroupProperty,
  PROPERTY_INSERT_SMART_GROUP_PROPERTY[START],
  PROPERTY_INSERT_SMART_GROUP_PROPERTY[SUCCESS],
  PROPERTY_INSERT_SMART_GROUP_PROPERTY[ERROR],
);

export const deleteSmartGroupProperty = makeApiActionCreatorV3(
  api.deleteSmartGroupProperty,
  PROPERTY_DELETE_SMART_GROUP_PROPERTY[START],
  PROPERTY_DELETE_SMART_GROUP_PROPERTY[SUCCESS],
  PROPERTY_DELETE_SMART_GROUP_PROPERTY[ERROR],
);

export const fetchSmartGroup = makeApiActionCreatorV3(
  api.fetchSmartGroup,
  PROPERTY_FETCH_SMART_GROUP[START],
  PROPERTY_FETCH_SMART_GROUP[SUCCESS],
  PROPERTY_FETCH_SMART_GROUP[ERROR],
);

export const excludeOwnerFromHSSmartGroupCalc = makeApiActionCreatorV3(
  api.excludeOwnerFromHSSmartGroupCalc,
  PROPERTY_EXCLUDE_OWNER_FROM_HS_SMART_GROUP_CALC[START],
  PROPERTY_EXCLUDE_OWNER_FROM_HS_SMART_GROUP_CALC[SUCCESS],
  PROPERTY_EXCLUDE_OWNER_FROM_HS_SMART_GROUP_CALC[ERROR],
);

export const updateSmartGroup = makeApiActionCreatorV3(
  api.updateSmartGroup,
  PROPERTY_UPDATE_SMART_GROUP[START],
  PROPERTY_UPDATE_SMART_GROUP[SUCCESS],
  PROPERTY_UPDATE_SMART_GROUP[ERROR],
);

export const insertSmartGroupFile = makeApiActionCreatorV3(
  api.insertSmartGroupFile,
  PROPERTY_INSERT_SMART_GROUP_FILE[START],
  PROPERTY_INSERT_SMART_GROUP_FILE[SUCCESS],
  PROPERTY_INSERT_SMART_GROUP_FILE[ERROR],
);

export const deleteSmartGroupFile = makeApiActionCreatorV3(
  api.deleteSmartGroupFile,
  PROPERTY_DELETE_SMART_GROUP_FILE[START],
  PROPERTY_DELETE_SMART_GROUP_FILE[SUCCESS],
  PROPERTY_DELETE_SMART_GROUP_FILE[ERROR],
);

export const downloadSmartGroupFile = makeApiActionCreatorV3(
  api.downloadSmartGroupFile,
  PROPERTY_DOWNLOAD_SMART_GROUP_FILE[START],
  PROPERTY_DOWNLOAD_SMART_GROUP_FILE[SUCCESS],
  PROPERTY_DOWNLOAD_SMART_GROUP_FILE[ERROR],
);

export const updateSmartGroupFile = makeApiActionCreatorV3(
  api.updateSmartGroupFile,
  PROPERTY_UPDATE_SMART_GROUP_FILE[START],
  PROPERTY_UPDATE_SMART_GROUP_FILE[SUCCESS],
  PROPERTY_UPDATE_SMART_GROUP_FILE[ERROR],
);

export const fetchSmartGroupTypes = makeApiActionCreatorV3(
  api.fetchSmartGroupTypes,
  PROPERTY_FETCH_SMART_GROUP_TYPES[START],
  PROPERTY_FETCH_SMART_GROUP_TYPES[SUCCESS],
  PROPERTY_FETCH_SMART_GROUP_TYPES[ERROR],
);

export const insertSmartGroup = makeApiActionCreatorV3(
  api.insertSmartGroup,
  PROPERTY_INSERT_SMART_GROUP[START],
  PROPERTY_INSERT_SMART_GROUP[SUCCESS],
  PROPERTY_INSERT_SMART_GROUP[ERROR],
);

export const fetchSmartGroupsBySearch = makeApiActionCreatorV3(
  api.fetchSmartGroupsBySearch,
  PROPERTY_FETCH_SMART_GROUPS_BY_SEARCH[START],
  PROPERTY_FETCH_SMART_GROUPS_BY_SEARCH[SUCCESS],
  PROPERTY_FETCH_SMART_GROUPS_BY_SEARCH[ERROR],
);

export const resetSmartGroupsBySearch = () => ({
  type: PROPERTY_RESET_SMART_GROUPS_BY_SEARCH,
});

export const resetSmartGroup = () => ({
  type: PROPERTY_SMART_GROUP_RESET,
});

export const fetchPropertyInspections = makeApiActionCreatorV3(
  api.fetchPropertyInspections,
  PROPERTY_FETCH_INSPECTIONS[START],
  PROPERTY_FETCH_INSPECTIONS[SUCCESS],
  PROPERTY_FETCH_INSPECTIONS[ERROR],
);

export const resetInspections = () => ({
  type: PROPERTY_INSPECTIONS_RESET,
});

export const insertPropertyInspection = makeApiActionCreatorV3(
  api.insertPropertyInspection,
  PROPERTY_INSERT_INSPECTION[START],
  PROPERTY_INSERT_INSPECTION[SUCCESS],
  PROPERTY_INSERT_INSPECTION[ERROR],
);

export const fetchReasonCodes = makeApiActionCreatorV3(
  api.fetchReasonCodes,
  PROPERTY_FETCH_REASON_CODES[START],
  PROPERTY_FETCH_REASON_CODES[SUCCESS],
  PROPERTY_FETCH_REASON_CODES[ERROR],
);

export const fetchPropertyInspection = makeApiActionCreatorV3(
  api.fetchPropertyInspection,
  PROPERTY_FETCH_INSPECTION[START],
  PROPERTY_FETCH_INSPECTION[SUCCESS],
  PROPERTY_FETCH_INSPECTION[ERROR],
);

export const insertPropertyInspectionTags = makeApiActionCreatorV3(
  api.insertPropertyInspectionTags,
  PROPERTY_INSERT_INSPECTION_TAGS[START],
  PROPERTY_INSERT_INSPECTION_TAGS[SUCCESS],
  PROPERTY_INSERT_INSPECTION_TAGS[ERROR],
);

export const updatePropertyInspection = makeApiActionCreatorV3(
  api.updatePropertyInspection,
  PROPERTY_UPDATE_INSPECTION[START],
  PROPERTY_UPDATE_INSPECTION[SUCCESS],
  PROPERTY_UPDATE_INSPECTION[ERROR],
);

export const insertPropertyInspectionFile = makeApiActionCreatorV3(
  api.insertPropertyInspectionFile,
  PROPERTY_INSERT_INSPECTION_FILE[START],
  PROPERTY_INSERT_INSPECTION_FILE[SUCCESS],
  PROPERTY_INSERT_INSPECTION_FILE[ERROR],
);

export const deletePropertyInspectionFile = makeApiActionCreatorV3(
  api.deletePropertyInspectionFile,
  PROPERTY_DELETE_INSPECTION_FILE[START],
  PROPERTY_DELETE_INSPECTION_FILE[SUCCESS],
  PROPERTY_DELETE_INSPECTION_FILE[ERROR],
);

export const downloadPropertyInspectionFile = makeApiActionCreatorV3(
  api.downloadPropertyInspectionFile,
  PROPERTY_DOWNLOAD_INSPECTION_FILE[START],
  PROPERTY_DOWNLOAD_INSPECTION_FILE[SUCCESS],
  PROPERTY_DOWNLOAD_INSPECTION_FILE[ERROR],
);

export const updatePropertyInspectionFile = makeApiActionCreatorV3(
  api.updatePropertyInspectionFile,
  PROPERTY_UPDATE_INSPECTION_FILE[START],
  PROPERTY_UPDATE_INSPECTION_FILE[SUCCESS],
  PROPERTY_UPDATE_INSPECTION_FILE[ERROR],
);

export const fetchPropertyAppraisers = makeApiActionCreatorV3(
  api.fetchPropertyAppraisers,
  PROPERTY_FETCH_APPRAISERS[START],
  PROPERTY_FETCH_APPRAISERS[SUCCESS],
  PROPERTY_FETCH_APPRAISERS[ERROR],
);

export const updatePropertyAppraisers = makeApiActionCreatorV3(
  api.updatePropertyAppraisers,
  PROPERTY_UPDATE_APPRAISERS[START],
  PROPERTY_UPDATE_APPRAISERS[SUCCESS],
  PROPERTY_UPDATE_APPRAISERS[ERROR],
);

export const deletePropertyInspection = makeApiActionCreatorV3(
  api.deletePropertyInspection,
  PROPERTY_DELETE_INSPECTION[START],
  PROPERTY_DELETE_INSPECTION[SUCCESS],
  PROPERTY_DELETE_INSPECTION[ERROR],
);

export const fetchPropertyPrimaryAppraiser = makeApiActionCreatorV3(
  api.fetchPropertyPrimaryAppraiser,
  PROPERTY_FETCH_PRIMARY_APPRAISER[START],
  PROPERTY_FETCH_PRIMARY_APPRAISER[SUCCESS],
  PROPERTY_FETCH_PRIMARY_APPRAISER[ERROR],
);

export const fetchPropertyEditableStatus = makeApiActionCreatorV3(
  api.fetchPropertyEditableStatus,
  PROPERTY_FETCH_EDITABLE_STATUS[START],
  PROPERTY_FETCH_EDITABLE_STATUS[SUCCESS],
  PROPERTY_FETCH_EDITABLE_STATUS[ERROR],
);

export const fetchPropertyStatus = makeApiActionCreatorV3(
  api.fetchPropertyStatus,
  PROPERTY_FETCH_STATUS[START],
  PROPERTY_FETCH_STATUS[SUCCESS],
  PROPERTY_FETCH_STATUS[ERROR],
);

export const deleteSmartGroup = makeApiActionCreatorV3(
  api.deleteSmartGroup,
  PROPERTY_DELETE_SMART_GROUP[START],
  PROPERTY_DELETE_SMART_GROUP[SUCCESS],
  PROPERTY_DELETE_SMART_GROUP[ERROR],
);

export const fetchPropertyPrimaryImageUrl = makeApiActionCreatorV3(
  api.fetchPropertyPrimaryImageUrl,
  PROPERTY_FETCH_PRIMARY_IMAGE_URL[START],
  PROPERTY_FETCH_PRIMARY_IMAGE_URL[SUCCESS],
  PROPERTY_FETCH_PRIMARY_IMAGE_URL[ERROR],
);

export const fetchObjectEvents = makeApiActionCreatorV3(
  api.fetchObjectEvents,
  FETCH_OBJECT_EVENTS[START],
  FETCH_OBJECT_EVENTS[SUCCESS],
  FETCH_OBJECT_EVENTS[ERROR],
);

export const fetchPhotosAndDocuments = makeApiActionCreatorV3(
  api.fetchPhotosAndDocuments,
  FETCH_PHOTOS_AND_DOCUMENTS[START],
  FETCH_PHOTOS_AND_DOCUMENTS[SUCCESS],
  FETCH_PHOTOS_AND_DOCUMENTS[ERROR],
);

export const fetchPropertyAgentSummary = makeApiActionCreatorV3(
  api.fetchPropertyAgentSummary,
  PROPERTY_FETCH_AGENT_SUMMARY[START],
  PROPERTY_FETCH_AGENT_SUMMARY[SUCCESS],
  PROPERTY_FETCH_AGENT_SUMMARY[ERROR],
);

export const fetchPropertyAgentSummaryListing = makeApiActionCreatorV3(
  api.fetchPropertyAgentSummaryListing,
  PROPERTY_FETCH_AGENT_SUMMARY_LISTING[START],
  PROPERTY_FETCH_AGENT_SUMMARY_LISTING[SUCCESS],
  PROPERTY_FETCH_AGENT_SUMMARY_LISTING[ERROR],
);

export const fetchBuildingPermits = makeApiActionCreatorV3(
  api.fetchBuildingPermits,
  PROPERTY_FETCH_BUILDING_PERMITS[START],
  PROPERTY_FETCH_BUILDING_PERMITS[SUCCESS],
  PROPERTY_FETCH_BUILDING_PERMITS[ERROR],
);

export const resetBuildingPermits = () => ({
  type: PROPERTY_RESET_BUILDING_PERMITS,
});

export const fetchAllHsValueLimitations = makeApiActionCreatorV3(
  api.fetchAllHsValueLimitations,
  PROPERTY_FETCH_ALL_HS_VALUE_LIMITATIONS[START],
  PROPERTY_FETCH_ALL_HS_VALUE_LIMITATIONS[SUCCESS],
  PROPERTY_FETCH_ALL_HS_VALUE_LIMITATIONS[ERROR],
);

export const updateHsValueLimitation = makeApiActionCreatorV3(
  api.updatePropertyHsValueLimitation,
  PROPERTY_UPDATE_HS_VALUE_LIMITATION[START],
  PROPERTY_UPDATE_HS_VALUE_LIMITATION[SUCCESS],
  PROPERTY_UPDATE_HS_VALUE_LIMITATION[ERROR],
);

export const fetchSplitMergeHistory = makeApiActionCreatorV3(
  api.fetchSplitMergeHistory,
  PROPERTY_FETCH_SPLIT_MERGE_HISTORY[START],
  PROPERTY_FETCH_SPLIT_MERGE_HISTORY[SUCCESS],
  PROPERTY_FETCH_SPLIT_MERGE_HISTORY[ERROR],
);

export const fetchBuildingPermitIssuerCodes = makeApiActionCreatorV3(
  api.fetchBuildingPermitCodefiles,
  PROPERTY_FETCH_BUILDING_PERMIT_ISSUER_CODES[START],
  PROPERTY_FETCH_BUILDING_PERMIT_ISSUER_CODES[SUCCESS],
  PROPERTY_FETCH_BUILDING_PERMIT_ISSUER_CODES[ERROR],
);

export const fetchBuildingPermitTypes = makeApiActionCreatorV3(
  api.fetchBuildingPermitCodefiles,
  PROPERTY_FETCH_BUILDING_PERMIT_TYPES[START],
  PROPERTY_FETCH_BUILDING_PERMIT_TYPES[SUCCESS],
  PROPERTY_FETCH_BUILDING_PERMIT_TYPES[ERROR],
);

export const fetchBuildingPermitSubTypes = makeApiActionCreatorV3(
  api.fetchBuildingPermitCodefiles,
  PROPERTY_FETCH_BUILDING_PERMIT_SUB_TYPES[START],
  PROPERTY_FETCH_BUILDING_PERMIT_SUB_TYPES[SUCCESS],
  PROPERTY_FETCH_BUILDING_PERMIT_SUB_TYPES[ERROR],
);

export const fetchBuildingPermitStatus = makeApiActionCreatorV3(
  api.fetchBuildingPermitCodefiles,
  PROPERTY_FETCH_BUILDING_PERMIT_STATUS[START],
  PROPERTY_FETCH_BUILDING_PERMIT_STATUS[SUCCESS],
  PROPERTY_FETCH_BUILDING_PERMIT_STATUS[ERROR],
);

export const fetchBuildingPermitCADStatus = makeApiActionCreatorV3(
  api.fetchBuildingPermitCodefiles,
  PROPERTY_FETCH_BUILDING_PERMIT_CAD_STATUS[START],
  PROPERTY_FETCH_BUILDING_PERMIT_CAD_STATUS[SUCCESS],
  PROPERTY_FETCH_BUILDING_PERMIT_CAD_STATUS[ERROR],
);

export const fetchBuildingPermitPropertyCategories = makeApiActionCreatorV3(
  api.fetchBuildingPermitCodefiles,
  PROPERTY_FETCH_BUILDING_PERMIT_PROPERTY_CATEGORIES[START],
  PROPERTY_FETCH_BUILDING_PERMIT_PROPERTY_CATEGORIES[SUCCESS],
  PROPERTY_FETCH_BUILDING_PERMIT_PROPERTY_CATEGORIES[ERROR],
);

export const insertBuildingPermit = makeApiActionCreatorV3(
  api.insertBuildingPermit,
  PROPERTY_INSERT_BUILDING_PERMIT[START],
  PROPERTY_INSERT_BUILDING_PERMIT[SUCCESS],
  PROPERTY_INSERT_BUILDING_PERMIT[ERROR],
);

export const updateBuildingPermitTags = makeApiActionCreatorV3(
  api.updateBuildingPermitTags,
  PROPERTY_UPDATE_BUILDING_PERMIT_TAGS[START],
  PROPERTY_UPDATE_BUILDING_PERMIT_TAGS[SUCCESS],
  PROPERTY_UPDATE_BUILDING_PERMIT_TAGS[ERROR],
);

export const fetchBuildingPermit = makeApiActionCreatorV3(
  api.fetchBuildingPermit,
  PROPERTY_FETCH_BUILDING_PERMIT[START],
  PROPERTY_FETCH_BUILDING_PERMIT[SUCCESS],
  PROPERTY_FETCH_BUILDING_PERMIT[ERROR],
);

export const updateBuildingPermit = makeApiActionCreatorV3(
  api.updateBuildingPermit,
  PROPERTY_UPDATE_BUILDING_PERMIT[START],
  PROPERTY_UPDATE_BUILDING_PERMIT[SUCCESS],
  PROPERTY_UPDATE_BUILDING_PERMIT[ERROR],
);

export const fetchBuildingPermitProperties = makeApiActionCreatorV3(
  api.fetchBuildingPermitProperties,
  PROPERTY_FETCH_BUILDING_PERMIT_PROPERTIES[START],
  PROPERTY_FETCH_BUILDING_PERMIT_PROPERTIES[SUCCESS],
  PROPERTY_FETCH_BUILDING_PERMIT_PROPERTIES[ERROR],
);

export const insertBuildingPermitProperty = makeApiActionCreatorV3(
  api.insertBuildingPermitProperty,
  PROPERTY_INSERT_BUILDING_PERMIT_PROPERTY[START],
  PROPERTY_INSERT_BUILDING_PERMIT_PROPERTY[SUCCESS],
  PROPERTY_INSERT_BUILDING_PERMIT_PROPERTY[ERROR],
);

export const deleteBuildingPermitProperty = makeApiActionCreatorV3(
  api.deleteBuildingPermitProperty,
  PROPERTY_DELETE_BUILDING_PERMIT_PROPERTY[START],
  PROPERTY_DELETE_BUILDING_PERMIT_PROPERTY[SUCCESS],
  PROPERTY_DELETE_BUILDING_PERMIT_PROPERTY[ERROR],
);

export const insertBuildingPermitFile = makeApiActionCreatorV3(
  api.insertBuildingPermitFile,
  INSERT_BUILDING_PERMIT_FILE[START],
  INSERT_BUILDING_PERMIT_FILE[SUCCESS],
  INSERT_BUILDING_PERMIT_FILE[ERROR],
);

export const deleteBuildingPermitFile = makeApiActionCreatorV3(
  api.deleteBuildingPermitFile,
  DELETE_BUILDING_PERMIT_FILE[START],
  DELETE_BUILDING_PERMIT_FILE[SUCCESS],
  DELETE_BUILDING_PERMIT_FILE[ERROR],
);

export const downloadBuildingPermitFile = makeApiActionCreatorV3(
  api.downloadBuildingPermitFile,
  DOWNLOAD_BUILDING_PERMIT_FILE[START],
  DOWNLOAD_BUILDING_PERMIT_FILE[SUCCESS],
  DOWNLOAD_BUILDING_PERMIT_FILE[ERROR],
);
export const updateBuildingPermitFile = makeApiActionCreatorV3(
  api.updateBuildingPermitFile,
  UPDATE_BUILDING_PERMIT_FILE[START],
  UPDATE_BUILDING_PERMIT_FILE[SUCCESS],
  UPDATE_BUILDING_PERMIT_FILE[ERROR],
);

export const resetBuildingPermit = () => ({
  type: RESET_BUILDING_PERMIT,
});

export const fetchLastAppraisal = makeApiActionCreatorV3(
  api.fetchLastAppraisal,
  PROPERTY_FETCH_LAST_APPRAISAL[START],
  PROPERTY_FETCH_LAST_APPRAISAL[SUCCESS],
  PROPERTY_FETCH_LAST_APPRAISAL[ERROR],
);

export const updateLastAppraisal = makeApiActionCreatorV3(
  api.updateLastAppraisal,
  PROPERTY_UPDATE_LAST_APPRAISAL[START],
  PROPERTY_UPDATE_LAST_APPRAISAL[SUCCESS],
  PROPERTY_UPDATE_LAST_APPRAISAL[ERROR],
);

export const fetchCodefilePropertyTags = makeApiActionCreatorV3(
  api.fetchCodefilePropertyTags,
  PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS[START],
  PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS[SUCCESS],
  PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS[ERROR],
);

export const fetchCodefilePropertyTagsByYear = makeApiActionCreatorV3(
  api.fetchCodefilePropertyTags,
  PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS_BY_YEAR[START],
  PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS_BY_YEAR[SUCCESS],
  PROPERTY_FETCH_CODEFILE_PROPERTY_TAGS_BY_YEAR[ERROR],
);

export const fetchImprovementDetailTypes = makeApiActionCreatorV3(
  api.fetchImprovementDetailTypes,
  PROPERTY_FETCH_IMPROVEMENT_DETAIL_TYPES[START],
  PROPERTY_FETCH_IMPROVEMENT_DETAIL_TYPES[SUCCESS],
  PROPERTY_FETCH_IMPROVEMENT_DETAIL_TYPES[ERROR],
);

export const fetchPropertyTags = makeApiActionCreatorV3(
  api.fetchPropertyTags,
  PROPERTY_FETCH_PROPERTY_TAGS[START],
  PROPERTY_FETCH_PROPERTY_TAGS[SUCCESS],
  PROPERTY_FETCH_PROPERTY_TAGS[ERROR],
);

export const insertPropertyTag = makeApiActionCreatorV3(
  api.insertPropertyTag,
  PROPERTY_INSERT_PROPERTY_TAG[START],
  PROPERTY_INSERT_PROPERTY_TAG[SUCCESS],
  PROPERTY_INSERT_PROPERTY_TAG[ERROR],
);

export const deletePropertyTag = makeApiActionCreatorV3(
  api.deletePropertyTag,
  PROPERTY_DELETE_PROPERTY_TAG[START],
  PROPERTY_DELETE_PROPERTY_TAG[SUCCESS],
  PROPERTY_DELETE_PROPERTY_TAG[ERROR],
);

export const fetchPropertyLinks = makeApiActionCreatorV3(
  api.fetchPropertyLinks,
  FETCH_PROPERTY_LINKS[START],
  FETCH_PROPERTY_LINKS[SUCCESS],
  FETCH_PROPERTY_LINKS[ERROR],
);

export const deletePropertyLink = makeApiActionCreatorV3(
  api.deletePropertyLink,
  PROPERTY_LINK_DELETE[START],
  PROPERTY_LINK_DELETE[SUCCESS],
  PROPERTY_LINK_DELETE[ERROR],
);

export const insertPropertyLink = makeApiActionCreatorV3(
  api.insertPropertyLink,
  PROPERTY_LINK_INSERT[START],
  PROPERTY_LINK_INSERT[SUCCESS],
  PROPERTY_LINK_INSERT[ERROR],
);

export const fetchRecalculationJob = makeApiActionCreatorV3(
  api.fetchRecalculationJob,
  PROPERTY_FETCH_RECALCULATION_JOB[START],
  PROPERTY_FETCH_RECALCULATION_JOB[SUCCESS],
  PROPERTY_FETCH_RECALCULATION_JOB[ERROR],
);

export const duplicateImprovement = makeApiActionCreatorV3(
  api.duplicateImprovement,
  IMPROVEMENT_DUPLICATE[START],
  IMPROVEMENT_DUPLICATE[SUCCESS],
  IMPROVEMENT_DUPLICATE[ERROR],
);

export const duplicateImprovementDetail = makeApiActionCreatorV3(
  api.duplicateImprovementDetail,
  IMPROVEMENT_DETAIL_DUPLICATE[START],
  IMPROVEMENT_DETAIL_DUPLICATE[SUCCESS],
  IMPROVEMENT_DETAIL_DUPLICATE[ERROR],
);

export const duplicateLand = makeApiActionCreatorV3(
  api.duplicateLand,
  LAND_DUPLICATE[START],
  LAND_DUPLICATE[SUCCESS],
  LAND_DUPLICATE[ERROR],
);

export const fetchMostCurrentProperty = makeApiActionCreatorV3(
  api.fetchMostCurrentProperty,
  FETCH_MOST_CURRENT_PROPERTY[START],
  FETCH_MOST_CURRENT_PROPERTY[SUCCESS],
  FETCH_MOST_CURRENT_PROPERTY[ERROR],
);

export const fetchMostCurrentPropertyByYear = makeApiActionCreatorV3(
  api.fetchMostCurrentPropertyByYear,
  FETCH_MOST_CURRENT_PROPERTY[START],
  FETCH_MOST_CURRENT_PROPERTY[SUCCESS],
  FETCH_MOST_CURRENT_PROPERTY[ERROR],
);

export const fetchRollHistory = makeApiActionCreatorV3(
  api.fetchRollHistory,
  PROPERTY_FETCH_ROLL_HISTORY[START],
  PROPERTY_FETCH_ROLL_HISTORY[SUCCESS],
  PROPERTY_FETCH_ROLL_HISTORY[ERROR],
);

export const fetchAppraisalNoticeHistory = makeApiActionCreatorV3(
  api.fetchAppraisalNoticeHistory,
  PROPERTY_FETCH_APPRAISAL_NOTICE_HISTORY[START],
  PROPERTY_FETCH_APPRAISAL_NOTICE_HISTORY[SUCCESS],
  PROPERTY_FETCH_APPRAISAL_NOTICE_HISTORY[ERROR],
);

export const fetchCurrentImprovements = makeApiActionCreatorV3(
  api.fetchCurrentImprovements,
  PROPERTY_FETCH_CURRENT_IMPROVEMENTS[START],
  PROPERTY_FETCH_CURRENT_IMPROVEMENTS[SUCCESS],
  PROPERTY_FETCH_CURRENT_IMPROVEMENTS[ERROR],
);

export const copySpecificImprovement = makeApiActionCreatorV3(
  api.copySpecificImprovement,
  PROPERTY_COPY_SPECIFIC_IMPROVEMENT[START],
  PROPERTY_COPY_SPECIFIC_IMPROVEMENT[SUCCESS],
  PROPERTY_COPY_SPECIFIC_IMPROVEMENT[ERROR],
);

export const copySpecificImprovementBuilder = makeApiActionCreatorV3(
  api.copySpecificImprovementBuilder,
  PROPERTY_COPY_SPECIFIC_IMPROVEMENT[START],
  PROPERTY_COPY_SPECIFIC_IMPROVEMENT[SUCCESS],
  PROPERTY_COPY_SPECIFIC_IMPROVEMENT[ERROR],
);

export const fetchCurrentLands = makeApiActionCreatorV3(
  api.fetchCurrentLands,
  PROPERTY_FETCH_CURRENT_LANDS[START],
  PROPERTY_FETCH_CURRENT_LANDS[SUCCESS],
  PROPERTY_FETCH_CURRENT_LANDS[ERROR],
);

export const copySpecificLand = makeApiActionCreatorV3(
  api.copySpecificLand,
  PROPERTY_COPY_SPECIFIC_LAND[START],
  PROPERTY_COPY_SPECIFIC_LAND[SUCCESS],
  PROPERTY_COPY_SPECIFIC_LAND[ERROR],
);

export const copySpecificLandBuilder = makeApiActionCreatorV3(
  api.copySpecificLandBuilder,
  PROPERTY_COPY_SPECIFIC_LAND[START],
  PROPERTY_COPY_SPECIFIC_LAND[SUCCESS],
  PROPERTY_COPY_SPECIFIC_LAND[ERROR],
);

export const fetchOpenRollCorrectionsByYear = makeApiActionCreatorV3(
  api.fetchOpenRollCorrectionsByYear,
  FETCH_OPEN_ROLL_CORRECTIONS[START],
  FETCH_OPEN_ROLL_CORRECTIONS[SUCCESS],
  FETCH_OPEN_ROLL_CORRECTIONS[ERROR],
);

export const fetchPropertyRollCorrectionInfo = makeApiActionCreatorV3(
  api.fetchPropertyRollCorrectionInfo,
  FETCH_PROPERTY_ROLL_CORRECTION_INFO[START],
  FETCH_PROPERTY_ROLL_CORRECTION_INFO[SUCCESS],
  FETCH_PROPERTY_ROLL_CORRECTION_INFO[ERROR],
);

export const updatePropertyRollCorrectionInfo = makeApiActionCreatorV3(
  api.updatePropertyRollCorrectionInfo,
  UPDATE_PROPERTY_ROLL_CORRECTION_INFO[START],
  UPDATE_PROPERTY_ROLL_CORRECTION_INFO[SUCCESS],
  UPDATE_PROPERTY_ROLL_CORRECTION_INFO[ERROR],
);

export const insertRollCorrection = makeApiActionCreatorV3(
  api.insertRollCorrection,
  INSERT_ROLL_CORRECTION[START],
  INSERT_ROLL_CORRECTION[SUCCESS],
  INSERT_ROLL_CORRECTION[ERROR],
);

export const createPropertyRollCorrection = makeApiActionCreatorV3(
  api.createPropertyRollCorrection,
  CREATE_PROPERTY_ROLL_CORRECTION[START],
  CREATE_PROPERTY_ROLL_CORRECTION[SUCCESS],
  CREATE_PROPERTY_ROLL_CORRECTION[ERROR],
);

export const removePropertyFromRollCorrection = makeApiActionCreatorV3(
  api.removePropertyFromRollCorrection,
  REMOVE_PROPERTY_FROM_ROLL_CORRECTION[START],
  REMOVE_PROPERTY_FROM_ROLL_CORRECTION[SUCCESS],
  REMOVE_PROPERTY_FROM_ROLL_CORRECTION[ERROR],
);

export const getPropertyFiles = makeApiActionCreatorV3(
  api.getPropertyFiles,
  GET_PROPERTY_FILES[START],
  GET_PROPERTY_FILES[SUCCESS],
  GET_PROPERTY_FILES[ERROR],
);

export const uploadPropertyFile = makeApiActionCreatorV3(
  api.uploadPropertyFile,
  UPLOAD_PROPERTY_FILE[START],
  UPLOAD_PROPERTY_FILE[SUCCESS],
  UPLOAD_PROPERTY_FILE[ERROR],
);

export const uploadPropertyPrimaryImage = makeApiActionCreatorV3(
  api.uploadPropertyPrimaryImage,
  UPLOAD_PROPERTY_PRIMARY_IMAGE[START],
  UPLOAD_PROPERTY_PRIMARY_IMAGE[SUCCESS],
  UPLOAD_PROPERTY_PRIMARY_IMAGE[ERROR],
);

export const updateCurrentPropertyPrimaryImage = makeApiActionCreatorV3(
  api.updateCurrentPropertyPrimaryImage,
  UPDATE_CURRENT_PROPERTY_PRIMARY_IMAGE[START],
  UPDATE_CURRENT_PROPERTY_PRIMARY_IMAGE[SUCCESS],
  UPDATE_CURRENT_PROPERTY_PRIMARY_IMAGE[ERROR],
);

export const deletePropertyFile = makeApiActionCreatorV3(
  api.deletePropertyFile,
  DELETE_PROPERTY_FILE[START],
  DELETE_PROPERTY_FILE[SUCCESS],
  DELETE_PROPERTY_FILE[ERROR],
);
export const updatePropertyFile = makeApiActionCreatorV3(
  api.updatePropertyFile,
  UPDATE_PROPERTY_FILE[START],
  UPDATE_PROPERTY_FILE[SUCCESS],
  UPDATE_PROPERTY_FILE[ERROR],
);
export const downloadPropertyFile = makeApiActionCreatorV3(
  api.downloadPropertyFile,
  DOWNLOAD_PROPERTY_FILE[START],
  DOWNLOAD_PROPERTY_FILE[SUCCESS],
  DOWNLOAD_PROPERTY_FILE[ERROR],
);

export const fetchPropertyPlats = makeApiActionCreatorV3(
  api.fetchPropertyPlats,
  PROPERTY_FETCH_PLATS[START],
  PROPERTY_FETCH_PLATS[SUCCESS],
  PROPERTY_FETCH_PLATS[ERROR],
);

export const downloadPropertyPlat = makeApiActionCreatorV3(
  api.downloadPropertyPlat,
  PROPERTY_DOWNLOAD_PLAT[START],
  PROPERTY_DOWNLOAD_PLAT[SUCCESS],
  PROPERTY_DOWNLOAD_PLAT[ERROR],
);

export const deletePropertyMassCreateProperty = makeApiActionCreatorV3(
  api.deletePropertyMassCreateProperty,
  PROPERTY_DELETE_MASS_CREATE_PROPERTY[START],
  PROPERTY_DELETE_MASS_CREATE_PROPERTY[SUCCESS],
  PROPERTY_DELETE_MASS_CREATE_PROPERTY[ERROR],
);

export const fetchJanOneOwner = makeApiActionCreatorV3(
  api.fetchJanOneOwner,
  FETCH_JAN_ONE_OWNER[START],
  FETCH_JAN_ONE_OWNER[SUCCESS],
  FETCH_JAN_ONE_OWNER[ERROR],
);

export const fetchCalculationRules = makeApiActionCreatorV3(
  api.fetchCalculationRules,
  FETCH_CALCULATION_RULES[START],
  FETCH_CALCULATION_RULES[SUCCESS],
  FETCH_CALCULATION_RULES[ERROR],
);

export const fetchAllocationFactors = makeApiActionCreatorV3(
  api.fetchAllocationFactors,
  FETCH_ALLOCATION_FACTORS[START],
  FETCH_ALLOCATION_FACTORS[SUCCESS],
  FETCH_ALLOCATION_FACTORS[ERROR],
);

export const RESET_ALLOCATION_FACTORS = 'APPRAISAL/RESET_ALLOCATION_FACTORS';

export const resetAllocationFactors = () => ({
  type: RESET_ALLOCATION_FACTORS,
});

export const deleteAllocationFactor = makeApiActionCreatorV3(
  api.deleteAllocationFactor,
  DELETE_ALLOCATION_FACTOR[START],
  DELETE_ALLOCATION_FACTOR[SUCCESS],
  DELETE_ALLOCATION_FACTOR[ERROR],
);

export const updateAllocationFactor = makeApiActionCreatorV3(
  api.updateAllocationFactor,
  UPDATE_ALLOCATION_FACTOR[START],
  UPDATE_ALLOCATION_FACTOR[SUCCESS],
  UPDATE_ALLOCATION_FACTOR[ERROR],
);

export const insertAllocationFactor = makeApiActionCreatorV3(
  api.insertAllocationFactor,
  INSERT_ALLOCATION_FACTOR[START],
  INSERT_ALLOCATION_FACTOR[SUCCESS],
  INSERT_ALLOCATION_FACTOR[ERROR],
);

export const fetchTaxingUnitLookup = makeApiActionCreatorV3(
  api.fetchTaxingUnitLookup,
  FETCH_TAXING_UNIT_LOOKUP[START],
  FETCH_TAXING_UNIT_LOOKUP[SUCCESS],
  FETCH_TAXING_UNIT_LOOKUP[ERROR],
);

export const processTaxingUnitAffidavit = makeApiActionCreatorV3(
  api.processTaxingUnitAffidavit,
  PROCESS_TAXING_UNIT_AFFIDAVIT[START],
  PROCESS_TAXING_UNIT_AFFIDAVIT[SUCCESS],
  PROCESS_TAXING_UNIT_AFFIDAVIT[ERROR],
);

export const fetchPropertyForSIT = makeApiActionCreatorV3(
  api.fetchPropertyForSIT,
  FETCH_PROPERTY_FOR_SIT[START],
  FETCH_PROPERTY_FOR_SIT[SUCCESS],
  FETCH_PROPERTY_FOR_SIT[ERROR],
);

export const enableSIT = makeApiActionCreatorV3(
  api.enableSIT,
  ENABLE_SIT[START],
  ENABLE_SIT[SUCCESS],
  ENABLE_SIT[ERROR],
);

export const disableSIT = makeApiActionCreatorV3(
  api.disableSIT,
  DISABLE_SIT[START],
  DISABLE_SIT[SUCCESS],
  DISABLE_SIT[ERROR],
);

export const fetchSITDetails = makeApiActionCreatorV3(
  api.fetchSITDetails,
  FETCH_SIT_DETAILS[START],
  FETCH_SIT_DETAILS[SUCCESS],
  FETCH_SIT_DETAILS[ERROR],
);

export const fetchSIT = makeApiActionCreatorV3(
  api.fetchSIT,
  FETCH_SIT[START],
  FETCH_SIT[SUCCESS],
  FETCH_SIT[ERROR],
);

export const updateSIT = makeApiActionCreatorV3(
  api.updateSIT,
  UPDATE_SIT[START],
  UPDATE_SIT[SUCCESS],
  UPDATE_SIT[ERROR],
);

export const fetchSITDetail = makeApiActionCreatorV3(
  api.fetchSITDetail,
  FETCH_SIT_DETAIL[START],
  FETCH_SIT_DETAIL[SUCCESS],
  FETCH_SIT_DETAIL[ERROR],
);

export const updateSITDetail = makeApiActionCreatorV3(
  api.updateSITDetail,
  UPDATE_SIT_DETAIL[START],
  UPDATE_SIT_DETAIL[SUCCESS],
  UPDATE_SIT_DETAIL[ERROR],
);

export const insertSITDetail = makeApiActionCreatorV3(
  api.insertSITDetail,
  INSERT_SIT_DETAIL[START],
  INSERT_SIT_DETAIL[SUCCESS],
  INSERT_SIT_DETAIL[ERROR],
);

export const deleteSITDetail = makeApiActionCreatorV3(
  api.deleteSITDetail,
  DELETE_SIT_DETAIL[START],
  DELETE_SIT_DETAIL[SUCCESS],
  DELETE_SIT_DETAIL[ERROR],
);

export const insertSitDetailFile = makeApiActionCreatorV3(
  api.insertSitDetailFile,
  INSERT_SIT_DETAIL_FILE[START],
  INSERT_SIT_DETAIL_FILE[SUCCESS],
  INSERT_SIT_DETAIL_FILE[ERROR],
);

export const deleteSitDetailFile = makeApiActionCreatorV3(
  api.deleteSitDetailFile,
  DELETE_SIT_DETAIL_FILE[START],
  DELETE_SIT_DETAIL_FILE[SUCCESS],
  DELETE_SIT_DETAIL_FILE[ERROR],
);

export const downloadSitDetailFile = makeApiActionCreatorV3(
  api.downloadSitDetailFile,
  DOWNLOAD_SIT_DETAIL_FILE[START],
  DOWNLOAD_SIT_DETAIL_FILE[SUCCESS],
  DOWNLOAD_SIT_DETAIL_FILE[ERROR],
);

export const updateSitDetailFile = makeApiActionCreatorV3(
  api.updateSitDetailFile,
  UPDATE_SIT_DETAIL_FILE[START],
  UPDATE_SIT_DETAIL_FILE[SUCCESS],
  UPDATE_SIT_DETAIL_FILE[ERROR],
);

export const insertSitFile = makeApiActionCreatorV3(
  api.insertSitFile,
  INSERT_SIT_FILE[START],
  INSERT_SIT_FILE[SUCCESS],
  INSERT_SIT_FILE[ERROR],
);

export const deleteSitFile = makeApiActionCreatorV3(
  api.deleteSitFile,
  DELETE_SIT_FILE[START],
  DELETE_SIT_FILE[SUCCESS],
  DELETE_SIT_FILE[ERROR],
);

export const downloadSitFile = makeApiActionCreatorV3(
  api.downloadSitFile,
  DOWNLOAD_SIT_FILE[START],
  DOWNLOAD_SIT_FILE[SUCCESS],
  DOWNLOAD_SIT_FILE[ERROR],
);

export const updateSitFile = makeApiActionCreatorV3(
  api.updateSitFile,
  UPDATE_SIT_FILE[START],
  UPDATE_SIT_FILE[SUCCESS],
  UPDATE_SIT_FILE[ERROR],
);

export const createBppImport = makeApiActionCreatorV3(
  api.createBppImport,
  CREATE_BPP_IMPORT[START],
  CREATE_BPP_IMPORT[SUCCESS],
  CREATE_BPP_IMPORT[ERROR],
);

export const fetchBppImport = makeApiActionCreatorV3(
  api.fetchBppImport,
  FETCH_BPP_IMPORT[START],
  FETCH_BPP_IMPORT[SUCCESS],
  FETCH_BPP_IMPORT[ERROR],
);

export const fetchBppImportErrors = makeApiActionCreatorV3(
  api.fetchBppImportErrors,
  FETCH_BPP_IMPORT_ERRORS[START],
  FETCH_BPP_IMPORT_ERRORS[SUCCESS],
  FETCH_BPP_IMPORT_ERRORS[ERROR],
);

export const clearImportErrors = makeApiActionCreatorV3(
  api.clearImportErrors,
  CLEAR_IMPORT_ERRORS[START],
  CLEAR_IMPORT_ERRORS[SUCCESS],
  CLEAR_IMPORT_ERRORS[ERROR],
);

export const fetchMarketApproachValuation = makeApiActionCreatorV3(
  api.fetchMarketApproachValuation,
  FETCH_MARKET_APPROACH_VALUATION[START],
  FETCH_MARKET_APPROACH_VALUATION[SUCCESS],
  FETCH_MARKET_APPROACH_VALUATION[ERROR],
  true,
);

export const updateMarketApproachAutoSelect = makeApiActionCreatorV3(
  api.updateMarketApproachAutoSelect,
  UPDATE_MARKET_APPROACH_AUTO_SELECT[START],
  UPDATE_MARKET_APPROACH_AUTO_SELECT[SUCCESS],
  UPDATE_MARKET_APPROACH_AUTO_SELECT[ERROR],
);

export const updateMarketApproachSetLandGrid = makeApiActionCreatorV3(
  api.updateMarketApproachSetLandGrid,
  UPDATE_MARKET_APPROACH_AUTO_SELECT[START],
  UPDATE_MARKET_APPROACH_AUTO_SELECT[SUCCESS],
  UPDATE_MARKET_APPROACH_AUTO_SELECT[ERROR],
);

export const fetchMarketApproachCompImages = makeApiActionCreatorV3(
  api.fetchMarketApproachCompImages,
  FETCH_MARKET_APPROACH_COMP_IMAGES[START],
  FETCH_MARKET_APPROACH_COMP_IMAGES[SUCCESS],
  FETCH_MARKET_APPROACH_COMP_IMAGES[ERROR],
);

export const refreshMarketApproach = makeApiActionCreatorV3(
  api.refreshMarketApproach,
  REFRESH_MARKET_APPROACH[START],
  REFRESH_MARKET_APPROACH[SUCCESS],
  REFRESH_MARKET_APPROACH[ERROR],
);

export const deleteMarketApproachComps = makeApiActionCreatorV3(
  api.deleteMarketApproachComps,
  DELETE_MARKET_APPROACH_COMPS[START],
  DELETE_MARKET_APPROACH_COMPS[SUCCESS],
  DELETE_MARKET_APPROACH_COMPS[ERROR],
);

export const fetchEquityApproachValuation = makeApiActionCreatorV3(
  api.fetchEquityApproachValuation,
  FETCH_EQUITY_APPROACH_VALUATION[START],
  FETCH_EQUITY_APPROACH_VALUATION[SUCCESS],
  FETCH_EQUITY_APPROACH_VALUATION[ERROR],
  true,
);

export const updateEquityApproachAutoSelect = makeApiActionCreatorV3(
  api.updateEquityApproachAutoSelect,
  UPDATE_EQUITY_APPROACH_AUTO_SELECT[START],
  UPDATE_EQUITY_APPROACH_AUTO_SELECT[SUCCESS],
  UPDATE_EQUITY_APPROACH_AUTO_SELECT[ERROR],
);

export const updateEquityApproachSetLandGrid = makeApiActionCreatorV3(
  api.updateEquityApproachSetLandGrid,
  UPDATE_EQUITY_APPROACH_AUTO_SELECT[START],
  UPDATE_EQUITY_APPROACH_AUTO_SELECT[SUCCESS],
  UPDATE_EQUITY_APPROACH_AUTO_SELECT[ERROR],
);

export const fetchEquityApproachCompImages = makeApiActionCreatorV3(
  api.fetchEquityApproachCompImages,
  FETCH_EQUITY_APPROACH_COMP_IMAGES[START],
  FETCH_EQUITY_APPROACH_COMP_IMAGES[SUCCESS],
  FETCH_EQUITY_APPROACH_COMP_IMAGES[ERROR],
);

export const refreshEquityApproach = makeApiActionCreatorV3(
  api.refreshEquityApproach,
  REFRESH_EQUITY_APPROACH[START],
  REFRESH_EQUITY_APPROACH[SUCCESS],
  REFRESH_EQUITY_APPROACH[ERROR],
);

export const deleteEquityApproachComps = makeApiActionCreatorV3(
  api.deleteEquityApproachComps,
  DELETE_EQUITY_APPROACH_COMPS[START],
  DELETE_EQUITY_APPROACH_COMPS[SUCCESS],
  DELETE_EQUITY_APPROACH_COMPS[ERROR],
);

export const fetchAppeals = makeApiActionCreatorV3(
  api.fetchAppeals,
  FETCH_APPEALS[START],
  FETCH_APPEALS[SUCCESS],
  FETCH_APPEALS[ERROR],
  true,
);

export const FETCH_PROPERTY_SEARCH = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_SEARCH',
);

export const fetchPropertySearch = makeApiActionCreatorV3(
  api.fetchPropertySearch,
  FETCH_PROPERTY_SEARCH[START],
  FETCH_PROPERTY_SEARCH[SUCCESS],
  FETCH_PROPERTY_SEARCH[ERROR],
);

export const FETCH_PROPERTY_SEARCH_MULTI = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_SEARCH_MULTI',
);

export const fetchPropertySearchMulti = makeApiActionCreatorV3(
  api.fetchPropertySearchMulti,
  FETCH_PROPERTY_SEARCH_MULTI[START],
  FETCH_PROPERTY_SEARCH_MULTI[SUCCESS],
  FETCH_PROPERTY_SEARCH_MULTI[ERROR],
);

export const FETCH_NEXT_GEOID = createRequestTypes(
  'APPRAISAL/FETCH_NEXT_GEOID',
);

export const fetchNextGeoID = makeApiActionCreatorV3(
  api.fetchNextGeoID,
  FETCH_NEXT_GEOID[START],
  FETCH_NEXT_GEOID[SUCCESS],
  FETCH_NEXT_GEOID[ERROR],
);

export const FETCH_PREVIOUS_GEOID = createRequestTypes(
  'APPRAISAL/FETCH_PREVIOUS_GEOID',
);

export const fetchPreviousGeoID = makeApiActionCreatorV3(
  api.fetchPreviousGeoID,
  FETCH_PREVIOUS_GEOID[START],
  FETCH_PREVIOUS_GEOID[SUCCESS],
  FETCH_PREVIOUS_GEOID[ERROR],
);

export const FETCH_NEXT_BLOCKLOT = createRequestTypes(
  'APPRAISAL/FETCH_NEXT_BLOCKLOT',
);

export const fetchNextBlockLot = makeApiActionCreatorV3(
  api.fetchNextBlockLot,
  FETCH_NEXT_BLOCKLOT[START],
  FETCH_NEXT_BLOCKLOT[SUCCESS],
  FETCH_NEXT_BLOCKLOT[ERROR],
);

export const FETCH_PREVIOUS_BLOCKLOT = createRequestTypes(
  'APPRAISAL/FETCH_PREVIOUS_BLOCKLOT',
);

export const fetchPreviousBlockLot = makeApiActionCreatorV3(
  api.fetchPreviousBlockLot,
  FETCH_PREVIOUS_BLOCKLOT[START],
  FETCH_PREVIOUS_BLOCKLOT[SUCCESS],
  FETCH_PREVIOUS_BLOCKLOT[ERROR],
);

export const FETCH_MARKET_APPROACH_SUBJECT = createRequestTypes(
  'APPRAISAL/FETCH_MARKET_APPROACH_SUBJECT',
);

export const fetchMarketApproachSubject = makeApiActionCreatorV3(
  api.fetchMarketApproachSubject,
  FETCH_MARKET_APPROACH_SUBJECT[START],
  FETCH_MARKET_APPROACH_SUBJECT[SUCCESS],
  FETCH_MARKET_APPROACH_SUBJECT[ERROR],
);

export const FETCH_EQUITY_APPROACH_SUBJECT = createRequestTypes(
  'APPRAISAL/FETCH_EQUITY_APPROACH_SUBJECT',
);

export const fetchEquityApproachSubject = makeApiActionCreatorV3(
  api.fetchEquityApproachSubject,
  FETCH_EQUITY_APPROACH_SUBJECT[START],
  FETCH_EQUITY_APPROACH_SUBJECT[SUCCESS],
  FETCH_EQUITY_APPROACH_SUBJECT[ERROR],
);
export const FETCH_MARKET_TIERS = createRequestTypes(
  'APPRAISAL/FETCH_MARKET_TIERS',
);

export const fetchMarketApproachTiers = makeApiActionCreatorV3(
  api.fetchMarketApproachTiers,
  FETCH_MARKET_TIERS[START],
  FETCH_MARKET_TIERS[SUCCESS],
  FETCH_MARKET_TIERS[ERROR],
);

export const FETCH_EQUITY_TIERS = createRequestTypes(
  'APPRAISAL/FETCH_EQUITY_TIERS',
);

export const fetchEquityApproachTiers = makeApiActionCreatorV3(
  api.fetchEquityApproachTiers,
  FETCH_EQUITY_TIERS[START],
  FETCH_EQUITY_TIERS[SUCCESS],
  FETCH_EQUITY_TIERS[ERROR],
);

export const MARKET_APPROACH_MANUAL_SELECTION = createRequestTypes(
  'APPRAISAL/MARKET_APPROACH_MANUAL_SELECTION',
);

export const marketApproachManualSelection = makeApiActionCreatorV3(
  api.marketApproachManualSelection,
  MARKET_APPROACH_MANUAL_SELECTION[START],
  MARKET_APPROACH_MANUAL_SELECTION[SUCCESS],
  MARKET_APPROACH_MANUAL_SELECTION[ERROR],
);

export const EQUITY_APPROACH_MANUAL_SELECTION = createRequestTypes(
  'APPRAISAL/EQUITY_APPROACH_MANUAL_SELECTION',
);

export const equityApproachManualSelection = makeApiActionCreatorV3(
  api.equityApproachManualSelection,
  EQUITY_APPROACH_MANUAL_SELECTION[START],
  EQUITY_APPROACH_MANUAL_SELECTION[SUCCESS],
  EQUITY_APPROACH_MANUAL_SELECTION[ERROR],
);

export const MARKET_APPROACH_MANUAL_RESET = createRequestTypes(
  'APPRAISAL/MARKET_APPROACH_MANUAL_RESET',
);

export const marketApproachManualReset = () => ({
  type: MARKET_APPROACH_MANUAL_RESET,
});

export const EQUITY_APPROACH_MANUAL_RESET = createRequestTypes(
  'APPRAISAL/EQUITY_APPROACH_MANUAL_RESET',
);

export const equityApproachManualReset = () => ({
  type: EQUITY_APPROACH_MANUAL_RESET,
});

export const MARKET_APPROACH_ADD_COMP_LIST = createRequestTypes(
  'APPRAISAL/MARKET_APPROACH_ADD_COMP_LIST',
);

export const marketApproachAddCompList = makeApiActionCreatorV3(
  api.marketApproachAddCompList,
  MARKET_APPROACH_ADD_COMP_LIST[START],
  MARKET_APPROACH_ADD_COMP_LIST[SUCCESS],
  MARKET_APPROACH_ADD_COMP_LIST[ERROR],
);

export const EQUITY_APPROACH_ADD_COMP_LIST = createRequestTypes(
  'APPRAISAL/EQUITY_APPROACH_ADD_COMP_LIST',
);

export const equityApproachAddCompList = makeApiActionCreatorV3(
  api.equityApproachAddCompList,
  EQUITY_APPROACH_ADD_COMP_LIST[START],
  EQUITY_APPROACH_ADD_COMP_LIST[SUCCESS],
  EQUITY_APPROACH_ADD_COMP_LIST[ERROR],
);

export const FETCH_PROPERTY_EFILE = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_EFILE',
);

export const fetchPropertyEfile = makeApiActionCreatorV3(
  api.fetchPropertyEfile,
  FETCH_PROPERTY_EFILE[START],
  FETCH_PROPERTY_EFILE[SUCCESS],
  FETCH_PROPERTY_EFILE[ERROR],
);

export const UPDATE_PROPERTY_EFILE = createRequestTypes(
  'APPRAISAL/UPDATE_PROPERTY_EFILE',
);

export const updatePropertyEfile = makeApiActionCreatorV3(
  api.updatePropertyEfile,
  UPDATE_PROPERTY_EFILE[START],
  UPDATE_PROPERTY_EFILE[SUCCESS],
  UPDATE_PROPERTY_EFILE[ERROR],
);

export const GENERATE_PROPERTY_EFILE_PIN = createRequestTypes(
  'APPRAISAL/GENERATE_PROPERTY_EFILE_PIN',
);

export const generatePropertyEfilePin = makeApiActionCreatorV3(
  api.generatePropertyEfilePin,
  GENERATE_PROPERTY_EFILE_PIN[START],
  GENERATE_PROPERTY_EFILE_PIN[SUCCESS],
  GENERATE_PROPERTY_EFILE_PIN[ERROR],
);

export const FETCH_PROPERTY_EQUITY_SUBJECT = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_EQUITY_SUBJECT',
);

export const fetchPropertyEquitySubject = makeApiActionCreatorV3(
  api.fetchPropertyEquitySubject,
  FETCH_PROPERTY_EQUITY_SUBJECT[START],
  FETCH_PROPERTY_EQUITY_SUBJECT[SUCCESS],
  FETCH_PROPERTY_EQUITY_SUBJECT[ERROR],
);

export const SEARCH_PROPERTY_EQUITY = createRequestTypes(
  'APPRAISAL/SEARCH_PROPERTY_EQUITY',
);

export const searchPropertyEquity = makeApiActionCreatorV3(
  api.searchPropertyEquity,
  SEARCH_PROPERTY_EQUITY[START],
  SEARCH_PROPERTY_EQUITY[SUCCESS],
  SEARCH_PROPERTY_EQUITY[ERROR],
);

export const FETCH_METHODS = createRequestTypes('APPRAISAL/FETCH_METHODS');

export const fetchMethods = makeApiActionCreatorV3(
  api.fetchMethods,
  FETCH_METHODS[START],
  FETCH_METHODS[SUCCESS],
  FETCH_METHODS[ERROR],
);

export const FETCH_MODELS = createRequestTypes('APPRAISAL/FETCH_MODELS');

export const fetchModels = makeApiActionCreatorV3(
  api.fetchModels,
  FETCH_MODELS[START],
  FETCH_MODELS[SUCCESS],
  FETCH_MODELS[ERROR],
);

export const fetchPropertyEconUnit = makeApiActionCreatorV3(
  api.fetchPropertyEconUnit,
  PROPERTY_FETCH_ECON_UNIT[START],
  PROPERTY_FETCH_ECON_UNIT[SUCCESS],
  PROPERTY_FETCH_ECON_UNIT[ERROR],
);

export const FETCH_PROPERTY_ERRORS = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_ERRORS',
);

export const fetchPropertyErrors = makeApiActionCreatorV3(
  api.fetchPropertyErrors,
  FETCH_PROPERTY_ERRORS[START],
  FETCH_PROPERTY_ERRORS[SUCCESS],
  FETCH_PROPERTY_ERRORS[ERROR],
);

export const PROPERTY_UPDATE_INACTIVE_NOTE = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_INACTIVE_NOTE',
);

export const updatePropertyInactiveNote = makeApiActionCreatorV3(
  api.updatePropertyInactiveNote,
  PROPERTY_UPDATE_INACTIVE_NOTE[START],
  PROPERTY_UPDATE_INACTIVE_NOTE[SUCCESS],
  PROPERTY_UPDATE_INACTIVE_NOTE[ERROR],
);

export const PROPERTY_UPDATE_REACTIVE_NOTE = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_REACTIVE_NOTE',
);

export const updatePropertyReactiveNote = makeApiActionCreatorV3(
  api.updatePropertyReactiveNote,
  PROPERTY_UPDATE_REACTIVE_NOTE[START],
  PROPERTY_UPDATE_REACTIVE_NOTE[SUCCESS],
  PROPERTY_UPDATE_REACTIVE_NOTE[ERROR],
);

export const fetchGroupOpenRollCorrections = makeApiActionCreatorV3(
  api.fetchGroupOpenRollCorrections,
  FETCH_GROUP_OPEN_ROLL_CORRECTIONS[START],
  FETCH_GROUP_OPEN_ROLL_CORRECTIONS[SUCCESS],
  FETCH_GROUP_OPEN_ROLL_CORRECTIONS[ERROR],
);

export const copyPropertyOtherYears = makeApiActionCreatorV3(
  api.copyPropertyOtherYears,
  COPY_PROPERTY_OTHER_YEARS[START],
  COPY_PROPERTY_OTHER_YEARS[SUCCESS],
  COPY_PROPERTY_OTHER_YEARS[ERROR],
);

export const movePropertyOtherCorrection = makeApiActionCreatorV3(
  api.movePropertyOtherCorrection,
  MOVE_PROPERTY_OTHER_CORRECTION[START],
  MOVE_PROPERTY_OTHER_CORRECTION[SUCCESS],
  MOVE_PROPERTY_OTHER_CORRECTION[ERROR],
);

export const quickPropertyLookup = makeApiActionCreatorV3(
  api.quickPropertyLookup,
  QUICK_PROPERTY_LOOKUP[START],
  QUICK_PROPERTY_LOOKUP[SUCCESS],
  QUICK_PROPERTY_LOOKUP[ERROR],
);

export const fetchPropertyNotifications = makeApiActionCreatorV3(
  api.fetchPropertyNotifications,
  FETCH_PROPERTY_NOTIFICATIONS[START],
  FETCH_PROPERTY_NOTIFICATIONS[SUCCESS],
  FETCH_PROPERTY_NOTIFICATIONS[ERROR],
  true,
);

export const PROPERTY_SEARCH_PARAMS_FETCH = createRequestTypes(
  'APPRAISAL/PROPERTY_SEARCH_PARAMS_FETCH',
);

export const fetchPropertySearchParams = makeApiActionCreatorV3(
  api.fetchPropertySearchParams,
  PROPERTY_SEARCH_PARAMS_FETCH[START],
  PROPERTY_SEARCH_PARAMS_FETCH[SUCCESS],
  PROPERTY_SEARCH_PARAMS_FETCH[ERROR],
);

export const PROPERTY_SEARCH_PARAM_FETCH = createRequestTypes(
  'APPRAISAL/PROPERTY_SEARCH_PARAM_FETCH',
);

export const fetchPropertySearchParam = makeApiActionCreatorV3(
  api.fetchPropertySearchParam,
  PROPERTY_SEARCH_PARAM_FETCH[START],
  PROPERTY_SEARCH_PARAM_FETCH[SUCCESS],
  PROPERTY_SEARCH_PARAM_FETCH[ERROR],
);

export const PROPERTY_SEARCH_PARAM_INSERT = createRequestTypes(
  'APPRAISAL/PROPERTY_SEARCH_PARAM_INSERT',
);

export const insertPropertySearchParam = makeApiActionCreatorV3(
  api.insertPropertySearchParam,
  PROPERTY_SEARCH_PARAM_INSERT[START],
  PROPERTY_SEARCH_PARAM_INSERT[SUCCESS],
  PROPERTY_SEARCH_PARAM_INSERT[ERROR],
);

export const PROPERTY_SEARCH_PARAM_UPDATE = createRequestTypes(
  'APPRAISAL/PROPERTY_SEARCH_PARAM_UPDATE',
);

export const updatePropertySearchParam = makeApiActionCreatorV3(
  api.updatePropertySearchParam,
  PROPERTY_SEARCH_PARAM_UPDATE[START],
  PROPERTY_SEARCH_PARAM_UPDATE[SUCCESS],
  PROPERTY_SEARCH_PARAM_UPDATE[ERROR],
);

export const PROPERTY_SEARCH_PARAM_DUPLICATE = createRequestTypes(
  'APPRAISAL/PROPERTY_SEARCH_PARAM_DUPLICATE',
);

export const duplicatePropertySearchParam = makeApiActionCreatorV3(
  api.duplicatePropertySearchParam,
  PROPERTY_SEARCH_PARAM_DUPLICATE[START],
  PROPERTY_SEARCH_PARAM_DUPLICATE[SUCCESS],
  PROPERTY_SEARCH_PARAM_DUPLICATE[ERROR],
);

export const PROPERTY_SEARCH_PARAM_DELETE = createRequestTypes(
  'APPRAISAL/PROPERTY_SEARCH_PARAM_DELETE',
);

export const deletePropertySearchParam = makeApiActionCreatorV3(
  api.deletePropertySearchParam,
  PROPERTY_SEARCH_PARAM_DELETE[START],
  PROPERTY_SEARCH_PARAM_DELETE[SUCCESS],
  PROPERTY_SEARCH_PARAM_DELETE[ERROR],
);

export const PROPERTY_SEARCH_PARAM_RESET = `${namespace}/PROPERTY_SEARCH_PARAM_RESET`;

export const resetPropertySearchParam = () => ({
  type: PROPERTY_SEARCH_PARAM_RESET,
});

export const PROPERTY_SEARCH_PARAM_SET = `${namespace}/PROPERTY_SEARCH_PARAM_SET`;

export const setPropertySearchParam = (searchParamID) => ({
  type: PROPERTY_SEARCH_PARAM_SET,
  searchParamID,
});

export const PROPERTY_SET_SEARCH_FORM_DATA = `${namespace}/PROPERTY_SET_SEARCH_FORM_DATA`;
export const setPropertyFormData = (formData) => ({
  type: PROPERTY_SET_SEARCH_FORM_DATA,
  payload: formData,
});

export const PROPERTY_FETCH_APPRAISAL_COMPANIES = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_APPRAISAL_COMPANIES',
);

export const fetchPropertyAppraisalCompanies = makeApiActionCreatorV3(
  api.fetchPropertyAppraisalCompanies,
  PROPERTY_FETCH_APPRAISAL_COMPANIES[START],
  PROPERTY_FETCH_APPRAISAL_COMPANIES[SUCCESS],
  PROPERTY_FETCH_APPRAISAL_COMPANIES[ERROR],
);

export const PROPERTY_Add_APPRAISAL_COMPANY = createRequestTypes(
  'APPRAISAL/PROPERTY_Add_APPRAISAL_COMPANY',
);

export const addPropertyAppraisalCompany = makeApiActionCreatorV3(
  api.addPropertyAppraisalCompany,
  PROPERTY_Add_APPRAISAL_COMPANY[START],
  PROPERTY_Add_APPRAISAL_COMPANY[SUCCESS],
  PROPERTY_Add_APPRAISAL_COMPANY[ERROR],
);

export const PROPERTY_DELETE_APPRAISAL_COMPANY = createRequestTypes(
  'APPRAISAL/PROPERTY_DELETE_APPRAISAL_COMPANY',
);

export const deletePropertyAppraisalCompany = makeApiActionCreatorV3(
  api.deletePropertyAppraisalCompany,
  PROPERTY_DELETE_APPRAISAL_COMPANY[START],
  PROPERTY_DELETE_APPRAISAL_COMPANY[SUCCESS],
  PROPERTY_DELETE_APPRAISAL_COMPANY[ERROR],
);

export const PROPERTY_UPDATE_APPRAISAL_COMPANY = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_APPRAISAL_COMPANY',
);

export const updatePropertyAppraisalCompany = makeApiActionCreatorV3(
  api.updatePropertyAppraisalCompany,
  PROPERTY_UPDATE_APPRAISAL_COMPANY[START],
  PROPERTY_UPDATE_APPRAISAL_COMPANY[SUCCESS],
  PROPERTY_UPDATE_APPRAISAL_COMPANY[ERROR],
);

export const PROPERTY_FETCH_APPRAISAL_COMPANY_LAST_IMPORT = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_APPRAISAL_COMPANY_LAST_IMPORT',
);

export const fetchPropertyAppraisalCompanyLastImport = makeApiActionCreatorV3(
  api.fetchPropertyAppraisalCompanyLastImport,
  PROPERTY_FETCH_APPRAISAL_COMPANY_LAST_IMPORT[START],
  PROPERTY_FETCH_APPRAISAL_COMPANY_LAST_IMPORT[SUCCESS],
  PROPERTY_FETCH_APPRAISAL_COMPANY_LAST_IMPORT[ERROR],
);

export const PROPERTY_FETCH_WORK_ITEMS = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_WORK_ITEMS',
);

export const fetchPropertyWorkItems = makeApiActionCreatorV3(
  api.fetchPropertyWorkItems,
  PROPERTY_FETCH_WORK_ITEMS[START],
  PROPERTY_FETCH_WORK_ITEMS[SUCCESS],
  PROPERTY_FETCH_WORK_ITEMS[ERROR],
  true,
);

export const PROPERTY_FETCH_TAX_OFFICE_IDENTIFIER = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_TAX_OFFICE_IDENTIFIER',
);

export const fetchPropertyTaxOfficeIdentifier = makeApiActionCreatorV3(
  api.fetchPropertyTaxOfficeIdentifier,
  PROPERTY_FETCH_TAX_OFFICE_IDENTIFIER[START],
  PROPERTY_FETCH_TAX_OFFICE_IDENTIFIER[SUCCESS],
  PROPERTY_FETCH_TAX_OFFICE_IDENTIFIER[ERROR],
);

export const PROPERTY_UPDATE_TAX_OFFICE_IDENTIFIER = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_TAX_OFFICE_IDENTIFIER',
);

export const updatePropertyTaxOfficeIdentifier = makeApiActionCreatorV3(
  api.updatePropertyTaxOfficeIdentifier,
  PROPERTY_UPDATE_TAX_OFFICE_IDENTIFIER[START],
  PROPERTY_UPDATE_TAX_OFFICE_IDENTIFIER[SUCCESS],
  PROPERTY_UPDATE_TAX_OFFICE_IDENTIFIER[ERROR],
);

export const PROPERTY_CHECK_SMART_GROUP = createRequestTypes(
  'APPRAISAL/PROPERTY_CHECK_SMART_GROUP',
);

export const checkPropertySmartGroup = makeApiActionCreatorV3(
  api.checkPropertySmartGroup,
  PROPERTY_CHECK_SMART_GROUP[START],
  PROPERTY_CHECK_SMART_GROUP[SUCCESS],
  PROPERTY_CHECK_SMART_GROUP[ERROR],
);

export const fetchPropertyCases = makeApiActionCreatorV3(
  api.fetchPropertyCases,
  FETCH_PROPERTY_CASES[START],
  FETCH_PROPERTY_CASES[SUCCESS],
  FETCH_PROPERTY_CASES[ERROR],
);

export const fetchPropertyAllCases = makeApiActionCreatorV3(
  api.fetchPropertyAllCases,
  FETCH_PROPERTY_CASES[START],
  FETCH_PROPERTY_CASES[SUCCESS],
  FETCH_PROPERTY_CASES[ERROR],
);

export const SET_SELECTED_PERSONAL_DETAIL_ID =
  'APPRAISAL/SET_SELECTED_PERSONAL_DETAIL_ID';

export function setSelectedPersonalDetailID(id) {
  return async (dispatch) => {
    dispatch({
      type: SET_SELECTED_PERSONAL_DETAIL_ID,
      data: id,
    });
  };
}

export const SET_DASHBOARD_BREADCRUMB = 'APPRAISAL/SET_DASHBOARD_BREADCRUMB';

export function setDashboardBreadcrumb(val) {
  return async (dispatch) => {
    dispatch({
      type: SET_DASHBOARD_BREADCRUMB,
      data: val,
    });
  };
}

export const PROPERTY_SEARCH_RENDITION = createRequestTypes(
  'APPRAISAL/PROPERTY_SEARCH_RENDITION',
);

export const searchPropertyRendition = makeApiActionCreatorV3(
  api.searchPropertyRendition,
  PROPERTY_SEARCH_RENDITION[START],
  PROPERTY_SEARCH_RENDITION[SUCCESS],
  PROPERTY_SEARCH_RENDITION[ERROR],
);

export const PROPERTY_FETCH_RENDERED_VALUE = createRequestTypes(
  'APPRAISAL/PROPERTY_FETCH_RENDERED_VALUE',
);

export const fetchRenderedValue = makeApiActionCreatorV3(
  api.fetchRenderedValue,
  PROPERTY_FETCH_RENDERED_VALUE[START],
  PROPERTY_FETCH_RENDERED_VALUE[SUCCESS],
  PROPERTY_FETCH_RENDERED_VALUE[ERROR],
);

export const PROPERTY_UPDATE_RENDERED_VALUE = createRequestTypes(
  'APPRAISAL/PROPERTY_UPDATE_RENDERED_VALUE',
);

export const updateRenderedValue = makeApiActionCreatorV3(
  api.updateRenderedValue,
  PROPERTY_UPDATE_RENDERED_VALUE[START],
  PROPERTY_UPDATE_RENDERED_VALUE[SUCCESS],
  PROPERTY_UPDATE_RENDERED_VALUE[ERROR],
);

export const PROPERTY_RENDITION_UPLOAD_FILES = createRequestTypes(
  'APPRAISAL/PROPERTY_RENDITION_UPLOAD_FILES',
);

export const uploadRenditionFiles = makeApiActionCreatorV3(
  api.uploadRenditionFiles,
  PROPERTY_RENDITION_UPLOAD_FILES[START],
  PROPERTY_RENDITION_UPLOAD_FILES[SUCCESS],
  PROPERTY_RENDITION_UPLOAD_FILES[ERROR],
);

export const PROPERTY_RENDITION_PROCESS = createRequestTypes(
  'APPRAISAL/PROPERTY_RENDITION_PROCESS',
);

export const processRendition = makeApiActionCreatorV3(
  api.processRendition,
  PROPERTY_RENDITION_PROCESS[START],
  PROPERTY_RENDITION_PROCESS[SUCCESS],
  PROPERTY_RENDITION_PROCESS[ERROR],
);

export const PROPERTY_RENDITION_CREATE = createRequestTypes(
  'APPRAISAL/PROPERTY_RENDITION_CREATE',
);

export const createRendition = makeApiActionCreatorV3(
  api.processRendition,
  PROPERTY_RENDITION_CREATE[START],
  PROPERTY_RENDITION_CREATE[SUCCESS],
  PROPERTY_RENDITION_CREATE[ERROR],
);

export const PROPERTY_TIRZ_FETCH = createRequestTypes(
  'APPRAISAL/PROPERTY_TIRZ_FETCH',
);

export const fetchPropertyTIRZ = makeApiActionCreatorV3(
  api.fetchPropertyTIRZ,
  PROPERTY_TIRZ_FETCH[START],
  PROPERTY_TIRZ_FETCH[SUCCESS],
  PROPERTY_TIRZ_FETCH[ERROR],
);

export const PROPERTY_TIRZ_REMOVE = createRequestTypes(
  'APPRAISAL/PROPERTY_TIRZ_REMOVE',
);

export const removePropertyTIRZ = makeApiActionCreatorV3(
  api.removePropertyTIRZ,
  PROPERTY_TIRZ_REMOVE[START],
  PROPERTY_TIRZ_REMOVE[SUCCESS],
  PROPERTY_TIRZ_REMOVE[ERROR],
);

export const PROPERTY_TIRZ_ADD = createRequestTypes(
  'APPRAISAL/PROPERTY_TIRZ_ADD',
);

export const addPropertyTIRZ = makeApiActionCreatorV3(
  api.addPropertyTIRZ,
  PROPERTY_TIRZ_ADD[START],
  PROPERTY_TIRZ_ADD[SUCCESS],
  PROPERTY_TIRZ_ADD[ERROR],
);

export const PROPERTY_TIRZ_TAXING_UNITS_FETCH = createRequestTypes(
  'APPRAISAL/PROPERTY_TIRZ_TAXING_UNITS_FETCH',
);

export const fetchPropertyTIRZTaxingUnits = makeApiActionCreatorV3(
  api.fetchPropertyTIRZTaxingUnits,
  PROPERTY_TIRZ_TAXING_UNITS_FETCH[START],
  PROPERTY_TIRZ_TAXING_UNITS_FETCH[SUCCESS],
  PROPERTY_TIRZ_TAXING_UNITS_FETCH[ERROR],
);

export const PROPERTY_TIRZ_TAXING_UNITS_VALUES_CLEAR = createRequestTypes(
  'APPRAISAL/PROPERTY_TIRZ_TAXING_UNITS_VALUES_CLEAR',
);

export const clearPropertyTIRZTaxingUnitsValues = makeApiActionCreatorV3(
  api.clearPropertyTIRZTaxingUnitsValues,
  PROPERTY_TIRZ_TAXING_UNITS_VALUES_CLEAR[START],
  PROPERTY_TIRZ_TAXING_UNITS_VALUES_CLEAR[SUCCESS],
  PROPERTY_TIRZ_TAXING_UNITS_VALUES_CLEAR[ERROR],
);

export const PROPERTY_TIRZ_TAXING_UNIT_COPY = createRequestTypes(
  'APPRAISAL/PROPERTY_TIRZ_TAXING_UNIT_COPY',
);

export const copyPropertyTIRZTaxingUnit = makeApiActionCreatorV3(
  api.copyPropertyTIRZTaxingUnit,
  PROPERTY_TIRZ_TAXING_UNIT_COPY[START],
  PROPERTY_TIRZ_TAXING_UNIT_COPY[SUCCESS],
  PROPERTY_TIRZ_TAXING_UNIT_COPY[ERROR],
);

export const PROPERTY_TIRZ_TAXING_UNIT_ADD = createRequestTypes(
  'APPRAISAL/PROPERTY_TIRZ_TAXING_UNIT_ADD',
);

export const addPropertyTIRZTaxingUnit = makeApiActionCreatorV3(
  api.addPropertyTIRZTaxingUnit,
  PROPERTY_TIRZ_TAXING_UNIT_ADD[START],
  PROPERTY_TIRZ_TAXING_UNIT_ADD[SUCCESS],
  PROPERTY_TIRZ_TAXING_UNIT_ADD[ERROR],
);

export const PROPERTY_TIRZ_TAXING_UNIT_UPDATE = createRequestTypes(
  'APPRAISAL/PROPERTY_TIRZ_TAXING_UNIT_UPDATE',
);

export const updatePropertyTIRZTaxingUnit = makeApiActionCreatorV3(
  api.updatePropertyTIRZTaxingUnit,
  PROPERTY_TIRZ_TAXING_UNIT_UPDATE[START],
  PROPERTY_TIRZ_TAXING_UNIT_UPDATE[SUCCESS],
  PROPERTY_TIRZ_TAXING_UNIT_UPDATE[ERROR],
);

export const PROPERTY_VALUE_LOCK_STATUS_FETCH = createRequestTypes(
  'APPRAISAL/PROPERTY_VALUE_LOCK_STATUS_FETCH',
);

export const fetchPropertyValueLockStatus = makeApiActionCreatorV3(
  api.fetchPropertyValueLockStatus,
  PROPERTY_VALUE_LOCK_STATUS_FETCH[START],
  PROPERTY_VALUE_LOCK_STATUS_FETCH[SUCCESS],
  PROPERTY_VALUE_LOCK_STATUS_FETCH[ERROR],
);

export const PROPERTY_VALUE_LOCK_STATUS_UPDATE = createRequestTypes(
  'APPRAISAL/PROPERTY_VALUE_LOCK_STATUS_UPDATE',
);

export const updatePropertyValueLockStatus = makeApiActionCreatorV3(
  api.updatePropertyValueLockStatus,
  PROPERTY_VALUE_LOCK_STATUS_UPDATE[START],
  PROPERTY_VALUE_LOCK_STATUS_UPDATE[SUCCESS],
  PROPERTY_VALUE_LOCK_STATUS_UPDATE[ERROR],
);

export const FETCH_PERSONAL_DETAIL_FILES = createRequestTypes(
  'APPRAISAL/FETCH_PERSONAL_DETAIL_FILES',
);

export const fetchPersonalDetailFiles = makeApiActionCreatorV3(
  api.fetchPersonalDetailFiles,
  FETCH_PERSONAL_DETAIL_FILES[START],
  FETCH_PERSONAL_DETAIL_FILES[SUCCESS],
  FETCH_PERSONAL_DETAIL_FILES[ERROR],
);

export const INSERT_PERSONAL_DETAIL_FILE = createRequestTypes(
  'APPRAISAL/INSERT_PERSONAL_DETAIL_FILE',
);

export const insertPersonalDetailFile = makeApiActionCreatorV3(
  api.insertPersonalDetailFile,
  INSERT_PERSONAL_DETAIL_FILE[START],
  INSERT_PERSONAL_DETAIL_FILE[SUCCESS],
  INSERT_PERSONAL_DETAIL_FILE[ERROR],
);

export const DOWNLOAD_PERSONAL_DETAIL_FILE = createRequestTypes(
  'APPRAISAL/DOWNLOAD_PERSONAL_DETAIL_FILE',
);

export const downloadPersonalDetailFile = makeApiActionCreatorV3(
  api.downloadPersonalDetailFile,
  DOWNLOAD_PERSONAL_DETAIL_FILE[START],
  DOWNLOAD_PERSONAL_DETAIL_FILE[SUCCESS],
  DOWNLOAD_PERSONAL_DETAIL_FILE[ERROR],
);

export const DELETE_PERSONAL_DETAIL_FILE = createRequestTypes(
  'APPRAISAL/DELETE_PERSONAL_DETAIL_FILE',
);

export const deletePersonalDetailFile = makeApiActionCreatorV3(
  api.deletePersonalDetailFile,
  DELETE_PERSONAL_DETAIL_FILE[START],
  DELETE_PERSONAL_DETAIL_FILE[SUCCESS],
  DELETE_PERSONAL_DETAIL_FILE[ERROR],
);

export const UPDATE_PERSONAL_DETAIL_FILE = createRequestTypes(
  'APPRAISAL/UPDATE_PERSONAL_DETAIL_FILE',
);

export const updatePersonalDetailFile = makeApiActionCreatorV3(
  api.updatePersonalDetailFile,
  UPDATE_PERSONAL_DETAIL_FILE[START],
  UPDATE_PERSONAL_DETAIL_FILE[SUCCESS],
  UPDATE_PERSONAL_DETAIL_FILE[ERROR],
);

export const FETCH_PERSONAL_DETAIL_NOTES = createRequestTypes(
  'APPRAISAL/FETCH_PERSONAL_DETAIL_NOTES',
);

export const fetchPersonalDetailNotes = makeApiActionCreatorV3(
  api.fetchPersonalDetailNotes,
  FETCH_PERSONAL_DETAIL_NOTES[START],
  FETCH_PERSONAL_DETAIL_NOTES[SUCCESS],
  FETCH_PERSONAL_DETAIL_NOTES[ERROR],
);

export const INSERT_PERSONAL_DETAIL_NOTE = createRequestTypes(
  'APPRAISAL/INSERT_PERSONAL_DETAIL_NOTE',
);

export const insertPersonalDetailNote = makeApiActionCreatorV3(
  api.insertPersonalDetailNote,
  INSERT_PERSONAL_DETAIL_NOTE[START],
  INSERT_PERSONAL_DETAIL_NOTE[SUCCESS],
  INSERT_PERSONAL_DETAIL_NOTE[ERROR],
);

export const DOWNLOAD_PERSONAL_DETAIL_NOTE = createRequestTypes(
  'APPRAISAL/DOWNLOAD_PERSONAL_DETAIL_NOTE',
);

export const fetchPersonalDetailNote = makeApiActionCreatorV3(
  api.fetchPersonalDetailNote,
  DOWNLOAD_PERSONAL_DETAIL_NOTE[START],
  DOWNLOAD_PERSONAL_DETAIL_NOTE[SUCCESS],
  DOWNLOAD_PERSONAL_DETAIL_NOTE[ERROR],
);

export const DELETE_PERSONAL_DETAIL_NOTE = createRequestTypes(
  'APPRAISAL/DELETE_PERSONAL_DETAIL_NOTE',
);

export const deletePersonalDetailNote = makeApiActionCreatorV3(
  api.deletePersonalDetailNote,
  DELETE_PERSONAL_DETAIL_NOTE[START],
  DELETE_PERSONAL_DETAIL_NOTE[SUCCESS],
  DELETE_PERSONAL_DETAIL_NOTE[ERROR],
);

export const UPDATE_PERSONAL_DETAIL_NOTE = createRequestTypes(
  'APPRAISAL/UPDATE_PERSONAL_DETAIL_NOTE',
);

export const updatePersonalDetailNote = makeApiActionCreatorV3(
  api.updatePersonalDetailNote,
  UPDATE_PERSONAL_DETAIL_NOTE[START],
  UPDATE_PERSONAL_DETAIL_NOTE[SUCCESS],
  UPDATE_PERSONAL_DETAIL_NOTE[ERROR],
);

export const FETCH_PROPERTY_SALE_LISTING = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_SALE_LISTING',
);

export const fetchPropertySalesListing = makeApiActionCreatorV3(
  api.fetchPropertySalesListing,
  FETCH_PROPERTY_SALE_LISTING[START],
  FETCH_PROPERTY_SALE_LISTING[SUCCESS],
  FETCH_PROPERTY_SALE_LISTING[ERROR],
);

export const UPDATE_PROPERTY_EQUITY_GRID_COMMENT = createRequestTypes(
  'APPRAISAL/UPDATE_PROPERTY_EQUITY_GRID_COMMENT',
);

export const updatePropertyEquityGridComment = makeApiActionCreatorV3(
  api.updatePropertyEquityGridComment,
  UPDATE_PROPERTY_EQUITY_GRID_COMMENT[START],
  UPDATE_PROPERTY_EQUITY_GRID_COMMENT[SUCCESS],
  UPDATE_PROPERTY_EQUITY_GRID_COMMENT[ERROR],
);

export const UPDATE_PROPERTY_MARKET_GRID_COMMENT = createRequestTypes(
  'APPRAISAL/UPDATE_PROPERTY_MARKET_GRID_COMMENT',
);

export const updatePropertyMarketGridComment = makeApiActionCreatorV3(
  api.updatePropertyMarketGridComment,
  UPDATE_PROPERTY_MARKET_GRID_COMMENT[START],
  UPDATE_PROPERTY_MARKET_GRID_COMMENT[SUCCESS],
  UPDATE_PROPERTY_MARKET_GRID_COMMENT[ERROR],
);

export const FETCH_CONFIGURATION_BY_NAME = createRequestTypes(
  'APPRAISAL/FETCH_CONFIGURATION_BY_NAME',
);

export const fetchConfigurationByName = makeApiActionCreatorV3(
  api.fetchConfigurationByName,
  FETCH_CONFIGURATION_BY_NAME[START],
  FETCH_CONFIGURATION_BY_NAME[SUCCESS],
  FETCH_CONFIGURATION_BY_NAME[ERROR],
);

export const FETCH_PROPERTY_HOMESITE_FLAGS = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_HOMESITE_FLAGS',
);

export const fetchPropertyHomesiteFlags = makeApiActionCreatorV3(
  api.fetchPropertyHomesiteFlags,
  FETCH_PROPERTY_HOMESITE_FLAGS[START],
  FETCH_PROPERTY_HOMESITE_FLAGS[SUCCESS],
  FETCH_PROPERTY_HOMESITE_FLAGS[ERROR],
);

export const SET_PROPERTY_HOMESITE_FLAG = createRequestTypes(
  'APPRAISAL/SET_PROPERTY_HOMESITE_FLAG',
);

export const setPropertyHomesiteFlag = makeApiActionCreatorV3(
  api.setPropertyHomesiteFlag,
  SET_PROPERTY_HOMESITE_FLAG[START],
  SET_PROPERTY_HOMESITE_FLAG[SUCCESS],
  SET_PROPERTY_HOMESITE_FLAG[ERROR],
);

//fetchStateCodeListing
export const FETCH_PROPERTY_STATE_CODE_LISTING = createRequestTypes(
  'APPRAISAL/FETCH_PROPERTY_STATE_CODE_LISTING',
);

export const fetchStateCodeListing = makeApiActionCreatorV3(
  api.fetchStateCodeListing,
  FETCH_PROPERTY_STATE_CODE_LISTING[START],
  FETCH_PROPERTY_STATE_CODE_LISTING[SUCCESS],
  FETCH_PROPERTY_STATE_CODE_LISTING[ERROR],
);

export const FETCH_OPEN_ROLL_CORRECTION_GROUPS = createRequestTypes(
  `${namespace}/FETCH_OPEN_ROLL_CORRECTION_GROUPS`,
);

export const fetchOpenRollCorrectionGroups = makeApiActionCreatorV3(
  api.fetchOpenRollCorrectionGroups,
  FETCH_OPEN_ROLL_CORRECTION_GROUPS[START],
  FETCH_OPEN_ROLL_CORRECTION_GROUPS[SUCCESS],
  FETCH_OPEN_ROLL_CORRECTION_GROUPS[ERROR],
);

export const FETCH_CAN_COPY_CURRENT_YEAR = createRequestTypes(
  `${namespace}/FETCH_CAN_COPY_CURRENT_YEAR`,
);

export const fetchCanCopyCurrentYear = makeApiActionCreatorV3(
  api.fetchCanCopyCurrentYear,
  FETCH_CAN_COPY_CURRENT_YEAR[START],
  FETCH_CAN_COPY_CURRENT_YEAR[SUCCESS],
  FETCH_CAN_COPY_CURRENT_YEAR[ERROR],
);

export const COPY_PROPERTY_CURRENT_YEAR = createRequestTypes(
  `${namespace}/COPY_PROPERTY_CURRENT_YEAR`,
);

export const copyPropertyCurrentYear = makeApiActionCreatorV3(
  api.copyPropertyCurrentYear,
  COPY_PROPERTY_CURRENT_YEAR[START],
  COPY_PROPERTY_CURRENT_YEAR[SUCCESS],
  COPY_PROPERTY_CURRENT_YEAR[ERROR],
);

export const CHANGE_PROPERTY_TYPE = createRequestTypes(
  `${namespace}/CHANGE_PROPERTY_TYPE`,
);

export const changePropertyType = makeApiActionCreatorV3(
  api.changePropertyType,
  CHANGE_PROPERTY_TYPE[START],
  CHANGE_PROPERTY_TYPE[SUCCESS],
  CHANGE_PROPERTY_TYPE[ERROR],
);

export const FETCH_IMAGE_GALLERY_OPTIONS = createRequestTypes(
  `${namespace}/FETCH_IMAGE_GALLERY_OPTIONS`,
);

export const fetchImageGalleryOptions = makeApiActionCreatorV3(
  api.fetchImageGalleryOptions,
  FETCH_IMAGE_GALLERY_OPTIONS[START],
  FETCH_IMAGE_GALLERY_OPTIONS[SUCCESS],
  FETCH_IMAGE_GALLERY_OPTIONS[ERROR],
);

export const FETCH_IMAGE_GALLERY_DATA = createRequestTypes(
  `${namespace}/FETCH_IMAGE_GALLERY_DATA`,
);

export const fetchImageGalleryData = makeApiActionCreatorV3(
  api.fetchImageGalleryData,
  FETCH_IMAGE_GALLERY_DATA[START],
  FETCH_IMAGE_GALLERY_DATA[SUCCESS],
  FETCH_IMAGE_GALLERY_DATA[ERROR],
);

export const SET_TAX_OFFICE_REF_ID = createRequestTypes(
  `${namespace}/SET_TAX_OFFICE_REF_ID`,
);

export const setTaxOfficeRefId = makeApiActionCreatorV3(
  api.setTaxOfficeRefId,
  SET_TAX_OFFICE_REF_ID[START],
  SET_TAX_OFFICE_REF_ID[SUCCESS],
  SET_TAX_OFFICE_REF_ID[ERROR],
);

export const CAN_CREATE_FUTURE_VERSION = createRequestTypes(
  `${namespace}/CAN_CREATE_FUTURE_VERSION`,
);

export const canCreateFutureVersion = makeApiActionCreatorV3(
  api.canCreateFutureVersion,
  CAN_CREATE_FUTURE_VERSION[START],
  CAN_CREATE_FUTURE_VERSION[SUCCESS],
  CAN_CREATE_FUTURE_VERSION[ERROR],
);

export const CREATE_FUTURE_VERSION = createRequestTypes(
  `${namespace}/CREATE_FUTURE_VERSION`,
);

export const createFutureVersion = makeApiActionCreatorV3(
  api.createFutureVersion,
  CREATE_FUTURE_VERSION[START],
  CREATE_FUTURE_VERSION[SUCCESS],
  CREATE_FUTURE_VERSION[ERROR],
);

export const DELETE_FUTURE_VERSION = createRequestTypes(
  `${namespace}/DELETE_FUTURE_VERSION`,
);

export const deleteFutureVersion = makeApiActionCreatorV3(
  api.deleteFutureVersion,
  DELETE_FUTURE_VERSION[START],
  DELETE_FUTURE_VERSION[SUCCESS],
  DELETE_FUTURE_VERSION[ERROR],
);

export const HAS_FUTURE_VERSION = createRequestTypes(
  `${namespace}/HAS_FUTURE_VERSION`,
);

export const hasFutureVersion = makeApiActionCreatorV3(
  api.hasFutureVersion,
  HAS_FUTURE_VERSION[START],
  HAS_FUTURE_VERSION[SUCCESS],
  HAS_FUTURE_VERSION[ERROR],
);

export const FETCH_PROPERTY_MARKET_VALUE_WITH_VALUE_TYPE = createRequestTypes(
  `${namespace}/FETCH_PROPERTY_MARKET_VALUE_WITH_VALUE_TYPE`,
);

export const fetchPropertyMarketValueWithValueType = makeApiActionCreatorV3(
  api.fetchPropertyMarketValueWithValueType,
  FETCH_PROPERTY_MARKET_VALUE_WITH_VALUE_TYPE[START],
  FETCH_PROPERTY_MARKET_VALUE_WITH_VALUE_TYPE[SUCCESS],
  FETCH_PROPERTY_MARKET_VALUE_WITH_VALUE_TYPE[ERROR],
);

export const FETCH_FLAT_VALUATION_CONFIG = createRequestTypes(
  `${namespace}/FETCH_FLAT_VALUATION_CONFIG`,
);

export const fetchFlatValuationConfig = makeApiActionCreatorV3(
  api.fetchFlatValuationConfig,
  FETCH_FLAT_VALUATION_CONFIG[START],
  FETCH_FLAT_VALUATION_CONFIG[SUCCESS],
  FETCH_FLAT_VALUATION_CONFIG[ERROR],
);

export const FETCH_TAX_LIMITATION_CALC_START_YEAR = createRequestTypes(
  `${namespace}/FETCH_TAX_LIMITATION_CALC_START_YEAR`,
);

export const fetchTaxLimitationCalcStartYear = makeApiActionCreatorV3(
  api.fetchTaxLimitationCalcStartYear,
  FETCH_TAX_LIMITATION_CALC_START_YEAR[START],
  FETCH_TAX_LIMITATION_CALC_START_YEAR[SUCCESS],
  FETCH_TAX_LIMITATION_CALC_START_YEAR[ERROR],
);

export const FETCH_PROPERTY_TAX_LIMITATIONS = createRequestTypes(
  `${namespace}/FETCH_PROPERTY_TAX_LIMITATIONS`,
);

export const fetchPropertyTaxLimitations = makeApiActionCreatorV3(
  api.fetchPropertyTaxLimitations,
  FETCH_PROPERTY_TAX_LIMITATIONS[START],
  FETCH_PROPERTY_TAX_LIMITATIONS[SUCCESS],
  FETCH_PROPERTY_TAX_LIMITATIONS[ERROR],
);

export const UPDATE_PROPERTY_TAX_LIMITATIONS = createRequestTypes(
  `${namespace}/UPDATE_PROPERTY_TAX_LIMITATIONS`,
);

export const updatePropertyTaxLimitations = makeApiActionCreatorV3(
  api.updatePropertyTaxLimitations,
  UPDATE_PROPERTY_TAX_LIMITATIONS[START],
  UPDATE_PROPERTY_TAX_LIMITATIONS[SUCCESS],
  UPDATE_PROPERTY_TAX_LIMITATIONS[ERROR],
);

export const FETCH_PROPERTY_TAX_LIMITATION = createRequestTypes(
  `${namespace}/FETCH_PROPERTY_TAX_LIMITATION`,
);

export const fetchPropertyTaxLimitation = makeApiActionCreatorV3(
  api.fetchPropertyTaxLimitation,
  FETCH_PROPERTY_TAX_LIMITATION[START],
  FETCH_PROPERTY_TAX_LIMITATION[SUCCESS],
  FETCH_PROPERTY_TAX_LIMITATION[ERROR],
);

export const FETCH_CALCULATION_HISTORY = createRequestTypes(
  `${namespace}/FETCH_CALCULATION_HISTORY`,
);

export const fetchCalculationHistory = makeApiActionCreatorV3(
  api.fetchCalculationHistory,
  FETCH_CALCULATION_HISTORY[START],
  FETCH_CALCULATION_HISTORY[SUCCESS],
  FETCH_CALCULATION_HISTORY[ERROR],
);

export const COMPUTE_LIMITATION = createRequestTypes(
  `${namespace}/COMPUTE_LIMITATION`,
);

export const computeLimitation = makeApiActionCreatorV3(
  api.computeLimitation,
  COMPUTE_LIMITATION[START],
  COMPUTE_LIMITATION[SUCCESS],
  COMPUTE_LIMITATION[ERROR],
);

export const COMPUTE_LIMITATION_CALC_UPDATE_TAXING_UNIT = createRequestTypes(
  `${namespace}/COMPUTE_LIMITATION_CALC_UPDATE_TAXING_UNIT`,
);

export const computeLimitationCalcUpdateTaxingUnit = makeApiActionCreatorV3(
  api.computeLimitationCalcUpdateTaxingUnit,
  COMPUTE_LIMITATION_CALC_UPDATE_TAXING_UNIT[START],
  COMPUTE_LIMITATION_CALC_UPDATE_TAXING_UNIT[SUCCESS],
  COMPUTE_LIMITATION_CALC_UPDATE_TAXING_UNIT[ERROR],
);

export const SAVE_PROPERTY_TAX_LIMITATION = createRequestTypes(
  `${namespace}/SAVE_PROPERTY_TAX_LIMITATION`,
);

export const savePropertyTaxLimitation = makeApiActionCreatorV3(
  api.savePropertyTaxLimitation,
  SAVE_PROPERTY_TAX_LIMITATION[START],
  SAVE_PROPERTY_TAX_LIMITATION[SUCCESS],
  SAVE_PROPERTY_TAX_LIMITATION[ERROR],
);

export const CREATE_PROPERTY_TAX_LIMITATION = createRequestTypes(
  `${namespace}/CREATE_PROPERTY_TAX_LIMITATION`,
);

export const createPropertyTaxLimitation = makeApiActionCreatorV3(
  api.createPropertyTaxLimitation,
  CREATE_PROPERTY_TAX_LIMITATION[START],
  CREATE_PROPERTY_TAX_LIMITATION[SUCCESS],
  CREATE_PROPERTY_TAX_LIMITATION[ERROR],
);

export const DELETE_PROPERTY_TAX_LIMITATION = createRequestTypes(
  `${namespace}/DELETE_PROPERTY_TAX_LIMITATION`,
);

export const deletePropertyTaxLimitation = makeApiActionCreatorV3(
  api.deletePropertyTaxLimitation,
  DELETE_PROPERTY_TAX_LIMITATION[START],
  DELETE_PROPERTY_TAX_LIMITATION[SUCCESS],
  DELETE_PROPERTY_TAX_LIMITATION[ERROR],
);

export const UPDATE_TAX_LIMITATION_CALC_START_YEAR = createRequestTypes(
  `${namespace}/UPDATE_TAX_LIMITATION_CALC_START_YEAR`,
);

export const updateTaxLimitationCalcStartYear = makeApiActionCreatorV3(
  api.updateTaxLimitationCalcStartYear,
  UPDATE_TAX_LIMITATION_CALC_START_YEAR[START],
  UPDATE_TAX_LIMITATION_CALC_START_YEAR[SUCCESS],
  UPDATE_TAX_LIMITATION_CALC_START_YEAR[ERROR],
);

export const FETCH_TAX_LIMITATION_HISTORY = createRequestTypes(
  `${namespace}/FETCH_TAX_LIMITATION_HISTORY`,
);

export const fetchTaxLimitationHistory = makeApiActionCreatorV3(
  api.fetchTaxLimitationHistory,
  FETCH_TAX_LIMITATION_HISTORY[START],
  FETCH_TAX_LIMITATION_HISTORY[SUCCESS],
  FETCH_TAX_LIMITATION_HISTORY[ERROR],
);

export const FETCH_PUBLIC_PROPERTY_ASSOCIATED_USERS = createRequestTypes(
  `${namespace}/FETCH_PUBLIC_PROPERTY_ASSOCIATED_USERS`,
);

export const fetchPublicPropertyAssociatedUsers = makeApiActionCreatorV3(
  api.fetchPublicPropertyAssociatedUsers,
  FETCH_PUBLIC_PROPERTY_ASSOCIATED_USERS[START],
  FETCH_PUBLIC_PROPERTY_ASSOCIATED_USERS[SUCCESS],
  FETCH_PUBLIC_PROPERTY_ASSOCIATED_USERS[ERROR],
);

export const FETCH_PROPERTY_ELECTRONIC_REQUESTS = createRequestTypes(
  `${namespace}/FETCH_PROPERTY_ELECTRONIC_REQUESTS`,
);

export const fetchPropertyElectronicRequests = makeApiActionCreatorV3(
  api.fetchPropertyElectronicRequests,
  FETCH_PROPERTY_ELECTRONIC_REQUESTS[START],
  FETCH_PROPERTY_ELECTRONIC_REQUESTS[SUCCESS],
  FETCH_PROPERTY_ELECTRONIC_REQUESTS[ERROR],
);

export const FETCH_PUBLIC_USER_AUTHORIZED_EVENTS = createRequestTypes(
  `${namespace}/FETCH_PUBLIC_USER_AUTHORIZED_EVENTS`,
);

export const fetchPublicUserAuthorizedEventForms = makeApiActionCreatorV3(
  api.fetchPublicUserAuthorizedEventForms,
  FETCH_PUBLIC_USER_AUTHORIZED_EVENTS[START],
  FETCH_PUBLIC_USER_AUTHORIZED_EVENTS[SUCCESS],
  FETCH_PUBLIC_USER_AUTHORIZED_EVENTS[ERROR],
);

export const FETCH_PROPERTY_YEARS = createRequestTypes(
  `${namespace}/FETCH_PROPERTY_YEARS`,
);

export const fetchPropertyYears = makeApiActionCreatorV3(
  api.fetchPropertyYears,
  FETCH_PROPERTY_YEARS[START],
  FETCH_PROPERTY_YEARS[SUCCESS],
  FETCH_PROPERTY_YEARS[ERROR],
);

export const FETCH_OWNERSHIP_CHAIN_ALL_YEARS = createRequestTypes(
  `${namespace}/FETCH_OWNERSHIP_CHAIN_ALL_YEARS`,
);

export const fetchOwnershipChainAllYears = makeApiActionCreatorV3(
  api.fetchOwnershipChainAllYears,
  FETCH_OWNERSHIP_CHAIN_ALL_YEARS[START],
  FETCH_OWNERSHIP_CHAIN_ALL_YEARS[SUCCESS],
  FETCH_OWNERSHIP_CHAIN_ALL_YEARS[ERROR],
);

export const FETCH_NOTICES_PROPERTY_EFILE = createRequestTypes(
  `${namespace}/FETCH_NOTICES_PROPERTY_EFILE`,
);

export const fetchNoticesPropertyEfile = makeApiActionCreatorV3(
  api.fetchNoticesPropertyEfile,
  FETCH_NOTICES_PROPERTY_EFILE[START],
  FETCH_NOTICES_PROPERTY_EFILE[SUCCESS],
  FETCH_NOTICES_PROPERTY_EFILE[ERROR],
);

export const UPDATE_NOTICES_PROPERTY_EFILE = createRequestTypes(
  `${namespace}/UPDATE_NOTICES_PROPERTY_EFILE`,
);

export const updateNoticesPropertyEfile = makeApiActionCreatorV3(
  api.updateNoticesPropertyEfile,
  UPDATE_NOTICES_PROPERTY_EFILE[START],
  UPDATE_NOTICES_PROPERTY_EFILE[SUCCESS],
  UPDATE_NOTICES_PROPERTY_EFILE[ERROR],
);

export const GENERATE_NOTICES_PROPERTY_EFILE = createRequestTypes(
  `${namespace}/GENERATE_NOTICES_PROPERTY_EFILE`,
);

export const generateNoticesPropertyEfile = makeApiActionCreatorV3(
  api.generateNoticesPropertyEfile,
  GENERATE_NOTICES_PROPERTY_EFILE[START],
  GENERATE_NOTICES_PROPERTY_EFILE[SUCCESS],
  GENERATE_NOTICES_PROPERTY_EFILE[ERROR],
);

export const FETCH_NOTICES_PROPERTY_PUBLIC_USERS = createRequestTypes(
  `${namespace}/FETCH_NOTICES_PROPERTY_PUBLIC_USERS`,
);

export const fetchNoticesPropertyPublicUsers = makeApiActionCreatorV3(
  api.fetchNoticesPropertyPublicUsers,
  FETCH_NOTICES_PROPERTY_PUBLIC_USERS[START],
  FETCH_NOTICES_PROPERTY_PUBLIC_USERS[SUCCESS],
  FETCH_NOTICES_PROPERTY_PUBLIC_USERS[ERROR],
);

export const FETCH_NOTICES_PROPERTY_EFILE_HISTORY = createRequestTypes(
  `${namespace}/FETCH_NOTICES_PROPERTY_EFILE_HISTORY`,
);

export const fetchNoticesPropertyEfileHistory = makeApiActionCreatorV3(
  api.fetchNoticesPropertyEfileHistory,
  FETCH_NOTICES_PROPERTY_EFILE_HISTORY[START],
  FETCH_NOTICES_PROPERTY_EFILE_HISTORY[SUCCESS],
  FETCH_NOTICES_PROPERTY_EFILE_HISTORY[ERROR],
);

export const FETCH_TIMBER78_TAXING_UNITS = createRequestTypes(
  `${namespace}/FETCH_TIMBER78_TAXING_UNITS`,
);

export const fetchTimber78TaxingUnits = makeApiActionCreatorV3(
  api.fetchTimber78TaxingUnits,
  FETCH_TIMBER78_TAXING_UNITS[START],
  FETCH_TIMBER78_TAXING_UNITS[SUCCESS],
  FETCH_TIMBER78_TAXING_UNITS[ERROR],
);

export const UPDATE_TIMBER78_TAXING_UNITS_PRICE_PER_ACRE = createRequestTypes(
  `${namespace}/UPDATE_TIMBER78_TAXING_UNITS_PRICE_PER_ACRE`,
);

export const updateTimber78TaxingUnitsPricePerAcre = makeApiActionCreatorV3(
  api.updateTimber78TaxingUnitsPricePerAcre,
  UPDATE_TIMBER78_TAXING_UNITS_PRICE_PER_ACRE[START],
  UPDATE_TIMBER78_TAXING_UNITS_PRICE_PER_ACRE[SUCCESS],
  UPDATE_TIMBER78_TAXING_UNITS_PRICE_PER_ACRE[ERROR],
);

export const COPY_TAXING_UNIT_PRICE_PER_ACRE_FROM_PROPERTY = createRequestTypes(
  `${namespace}/COPY_TAXING_UNIT_PRICE_PER_ACRE_FROM_PROPERTY`,
);

export const copyTaxingUnitPricePerAcreFromAnotherProperty =
  makeApiActionCreatorV3(
    api.copyTaxingUnitPricePerAcreFromAnotherProperty,
    COPY_TAXING_UNIT_PRICE_PER_ACRE_FROM_PROPERTY[START],
    COPY_TAXING_UNIT_PRICE_PER_ACRE_FROM_PROPERTY[SUCCESS],
    COPY_TAXING_UNIT_PRICE_PER_ACRE_FROM_PROPERTY[ERROR],
  );

export const DELETE_MASS_PROPERTIES = createRequestTypes(
  `${namespace}/DELETE_MASS_PROPERTIES`,
);

export const deleteMassProperties = makeApiActionCreatorV3(
  api.deleteMassProperties,
  DELETE_MASS_PROPERTIES[START],
  DELETE_MASS_PROPERTIES[SUCCESS],
  DELETE_MASS_PROPERTIES[ERROR],
);

export const TRANSFTER_UDI_OWNERSHIP = createRequestTypes(
  `${namespace}/TRANSFTER_UDI_OWNERSHIP`,
);

export const transferUDIOwnership = makeApiActionCreatorV3(
  api.transferUDIOwnership,
  TRANSFTER_UDI_OWNERSHIP[START],
  TRANSFTER_UDI_OWNERSHIP[SUCCESS],
  TRANSFTER_UDI_OWNERSHIP[ERROR],
);

export const FETCH_TRANSFER_UDI_OWNERSHIP_START_YEAR = createRequestTypes(
  `${namespace}/FETCH_TRANSFER_UDI_OWNERSHIP_START_YEAR`,
);

export const fetchTransferUDIOwnershipStartYear = makeApiActionCreatorV3(
  api.fetchTransferUDIOwnershipStartYear,
  FETCH_TRANSFER_UDI_OWNERSHIP_START_YEAR[START],
  FETCH_TRANSFER_UDI_OWNERSHIP_START_YEAR[SUCCESS],
  FETCH_TRANSFER_UDI_OWNERSHIP_START_YEAR[ERROR],
);

export const FETCH_IMP_DETAIL_MANAGER_CHARACTERISTICS = createRequestTypes(
  `${namespace}/FETCH_IMP_DETAIL_MANAGER_CHARACTERISTICS`,
);

export const fetchImpDetailManagerCharacteristics = makeApiActionCreatorV3(
  api.fetchImpDetailManagerCharacteristics,
  FETCH_IMP_DETAIL_MANAGER_CHARACTERISTICS[START],
  FETCH_IMP_DETAIL_MANAGER_CHARACTERISTICS[SUCCESS],
  FETCH_IMP_DETAIL_MANAGER_CHARACTERISTICS[ERROR],
);

export const UPDATE_IMP_DETAIL_MANAGER_CHARACTERISTICS = createRequestTypes(
  `${namespace}/UPDATE_IMP_DETAIL_MANAGER_CHARACTERISTICS`,
);

export const updateImpDetailManagerCharacteristics = makeApiActionCreatorV3(
  api.updateImpDetailManagerCharacteristics,
  UPDATE_IMP_DETAIL_MANAGER_CHARACTERISTICS[START],
  UPDATE_IMP_DETAIL_MANAGER_CHARACTERISTICS[SUCCESS],
  UPDATE_IMP_DETAIL_MANAGER_CHARACTERISTICS[ERROR],
);

export const FETCH_IMP_DETAIL_MANAGER_CONDITIONS = createRequestTypes(
  `${namespace}/FETCH_IMP_DETAIL_MANAGER_CONDITIONS`,
);

export const fetchImpDetailManagerConditions = makeApiActionCreatorV3(
  api.fetchImpDetailManagerConditions,
  FETCH_IMP_DETAIL_MANAGER_CONDITIONS[START],
  FETCH_IMP_DETAIL_MANAGER_CONDITIONS[SUCCESS],
  FETCH_IMP_DETAIL_MANAGER_CONDITIONS[ERROR],
);

export const UPDATE_IMP_DETAIL_MANAGER_CONDITIONS = createRequestTypes(
  `${namespace}/UPDATE_IMP_DETAIL_MANAGER_CONDITIONS`,
);

export const updateImpDetailManagerConditions = makeApiActionCreatorV3(
  api.updateImpDetailManagerConditions,
  UPDATE_IMP_DETAIL_MANAGER_CONDITIONS[START],
  UPDATE_IMP_DETAIL_MANAGER_CONDITIONS[SUCCESS],
  UPDATE_IMP_DETAIL_MANAGER_CONDITIONS[ERROR],
);

export const FETCH_IMP_DETAIL_MANAGER_NEW_VALUE = createRequestTypes(
  `${namespace}/FETCH_IMP_DETAIL_MANAGER_NEW_VALUE`,
);

export const fetchImpDetailManagerNewValue = makeApiActionCreatorV3(
  api.fetchImpDetailManagerNewValue,
  FETCH_IMP_DETAIL_MANAGER_NEW_VALUE[START],
  FETCH_IMP_DETAIL_MANAGER_NEW_VALUE[SUCCESS],
  FETCH_IMP_DETAIL_MANAGER_NEW_VALUE[ERROR],
);

export const UPDATE_IMP_DETAIL_MANAGER_NEW_VALUE = createRequestTypes(
  `${namespace}/UPDATE_IMP_DETAIL_MANAGER_NEW_VALUE`,
);

export const updateImpDetailManagerNewValue = makeApiActionCreatorV3(
  api.updateImpDetailManagerNewValue,
  UPDATE_IMP_DETAIL_MANAGER_NEW_VALUE[START],
  UPDATE_IMP_DETAIL_MANAGER_NEW_VALUE[SUCCESS],
  UPDATE_IMP_DETAIL_MANAGER_NEW_VALUE[ERROR],
);

export const FETCH_IMP_DETAIL_MANAGER_PRICING_MODEL = createRequestTypes(
  `${namespace}/FETCH_IMP_DETAIL_MANAGER_PRICING_MODEL`,
);

export const fetchImpDetailManagerPricingModel = makeApiActionCreatorV3(
  api.fetchImpDetailManagerPricingModel,
  FETCH_IMP_DETAIL_MANAGER_PRICING_MODEL[START],
  FETCH_IMP_DETAIL_MANAGER_PRICING_MODEL[SUCCESS],
  FETCH_IMP_DETAIL_MANAGER_PRICING_MODEL[ERROR],
);

export const UPDATE_IMP_DETAIL_MANAGER_PRICING_MODEL = createRequestTypes(
  `${namespace}/UPDATE_IMP_DETAIL_MANAGER_PRICING_MODEL`,
);

export const updateImpDetailManagerPricingModel = makeApiActionCreatorV3(
  api.updateImpDetailManagerPricingModel,
  UPDATE_IMP_DETAIL_MANAGER_PRICING_MODEL[START],
  UPDATE_IMP_DETAIL_MANAGER_PRICING_MODEL[SUCCESS],
  UPDATE_IMP_DETAIL_MANAGER_PRICING_MODEL[ERROR],
);

export const FETCH_IMP_DETAIL_MANAGER_ADJUSTMENT = createRequestTypes(
  `${namespace}/FETCH_IMP_DETAIL_MANAGER_ADJUSTMENT`,
);

export const fetchImpDetailManagerAdjustment = makeApiActionCreatorV3(
  api.fetchImpDetailManagerAdjustment,
  FETCH_IMP_DETAIL_MANAGER_ADJUSTMENT[START],
  FETCH_IMP_DETAIL_MANAGER_ADJUSTMENT[SUCCESS],
  FETCH_IMP_DETAIL_MANAGER_ADJUSTMENT[ERROR],
);

export const UPDATE_IMP_DETAIL_MANAGER_ADJUSTMENT = createRequestTypes(
  `${namespace}/UPDATE_IMP_DETAIL_MANAGER_ADJUSTMENT`,
);

export const updateImpDetailManagerAdjustment = makeApiActionCreatorV3(
  api.updateImpDetailManagerAdjustment,
  UPDATE_IMP_DETAIL_MANAGER_ADJUSTMENT[START],
  UPDATE_IMP_DETAIL_MANAGER_ADJUSTMENT[SUCCESS],
  UPDATE_IMP_DETAIL_MANAGER_ADJUSTMENT[ERROR],
);

export const VALIDATE_PID_LIST = createRequestTypes(
  `${namespace}/VALIDATE_PID_LIST`,
);

export const validatePIDList = makeApiActionCreatorV3(
  api.validatePIDList,
  VALIDATE_PID_LIST[START],
  VALIDATE_PID_LIST[SUCCESS],
  VALIDATE_PID_LIST[ERROR],
);

export const FETCH_DEANNEXATIONS = createRequestTypes(
  `${namespace}/FETCH_DEANNEXATIONS`,
);

export const fetchDeannexations = makeApiActionCreatorV3(
  api.fetchDeannexations,
  FETCH_DEANNEXATIONS[START],
  FETCH_DEANNEXATIONS[SUCCESS],
  FETCH_DEANNEXATIONS[ERROR],
);

export const DELETE_DEANNEXATION = createRequestTypes(
  `${namespace}/DELETE_DEANNEXATION`,
);

export const deleteDeannexation = makeApiActionCreatorV3(
  api.deleteDeannexation,
  DELETE_DEANNEXATION[START],
  DELETE_DEANNEXATION[SUCCESS],
  DELETE_DEANNEXATION[ERROR],
);

export const SET_RECALCULATE_TRIGGER = createRequestTypes(
  'APPRAISAL/SET_RECALCULATE_TRIGGER',
);

export function setRecalculateTrigger(data) {
  return async (dispatch) => {
    dispatch({ type: SET_RECALCULATE_TRIGGER, data });
  };
}

export const triggerRecalculate = () => async (dispatch) => {
  dispatch(setRecalculateTrigger(true));
  dispatch(setRecalculateTrigger(false));
};

export const SET_PROPERTIES_MASS_UPDATE_MULTI_YEAR = createRequestTypes(
  'APPRAISAL/SET_PROPERTIES_MASS_UPDATE_MULTI_YEAR',
);

export function setPropertiesMassUpdateMultiYear(data) {
  return async (dispatch) => {
    dispatch({ type: SET_PROPERTIES_MASS_UPDATE_MULTI_YEAR, data });
  };
}

export const fetchImprovementHistoryManager = makeApiActionCreatorV3(
  api.fetchImprovementHistoryManager,
  'FETCH_IMPROVEMENT_HISTORY_MANAGER_START',
  'FETCH_IMPROVEMENT_HISTORY_MANAGER_SUCCESS',
  'FETCH_IMPROVEMENT_HISTORY_MANAGER_ERROR',
);

export const updateImprovementHistoryManager = makeApiActionCreatorV3(
  api.updateImprovementHistoryManager,
  'UPDATE_IMPROVEMENT_HISTORY_MANAGER_START',
  'UPDATE_IMPROVEMENT_HISTORY_MANAGER_SUCCESS',
  'UPDATE_IMPROVEMENT_HISTORY_MANAGER_ERROR',
);

export const CLEAR_IMPROVEMENT_HISTORY_MANAGER_LINK = createRequestTypes(
  `${namespace}/CLEAR_IMPROVEMENT_HISTORY_MANAGER_LINK`,
);

export const clearImprovementHistoryManagerLink = makeApiActionCreatorV3(
  api.clearImprovementHistoryManagerLink,
  CLEAR_IMPROVEMENT_HISTORY_MANAGER_LINK[START],
  CLEAR_IMPROVEMENT_HISTORY_MANAGER_LINK[SUCCESS],
  CLEAR_IMPROVEMENT_HISTORY_MANAGER_LINK[ERROR],
);

export const fetchImprovementDetailHistoryManager = makeApiActionCreatorV3(
  api.fetchImprovementDetailHistoryManager,
  'FETCH_IMPROVEMENT_DETAIL_HISTORY_MANAGER_START',
  'FETCH_IMPROVEMENT_DETAIL_HISTORY_MANAGER_SUCCESS',
  'FETCH_IMPROVEMENT_DETAIL_HISTORY_MANAGER_ERROR',
);

export const updateImprovementDetailHistoryManager = makeApiActionCreatorV3(
  api.updateImprovementDetailHistoryManager,
  'UPDATE_IMPROVEMENT_DETAIL_HISTORY_MANAGER_START',
  'UPDATE_IMPROVEMENT_DETAIL_HISTORY_MANAGER_SUCCESS',
  'UPDATE_IMPROVEMENT_DETAIL_HISTORY_MANAGER_ERROR',
);

export const clearImprovementDetailHistoryManagerLink = makeApiActionCreatorV3(
  api.clearImprovementDetailHistoryManagerLink,
  'CLEAR_IMPROVEMENT_DETAIL_HISTORY_MANAGER_LINK_START',
  'CLEAR_IMPROVEMENT_DETAIL_HISTORY_MANAGER_LINK_SUCCESS',
  'CLEAR_IMPROVEMENT_DETAIL_HISTORY_MANAGER_LINK_ERROR',
);

export const workItemsUpdated = () => ({
  type: WORK_ITEMS_UPDATED,
});

// Action Types
export const FETCH_PROPERTY_YEARS_REQUEST = 'FETCH_PROPERTY_YEARS_REQUEST';
export const FETCH_PROPERTY_YEARS_SUCCESS = 'FETCH_PROPERTY_YEARS_SUCCESS';
export const FETCH_PROPERTY_YEARS_FAILURE = 'FETCH_PROPERTY_YEARS_FAILURE';

export const FETCH_OWNERSHIP_CHAIN_REQUEST = 'FETCH_OWNERSHIP_CHAIN_REQUEST';
export const FETCH_OWNERSHIP_CHAIN_SUCCESS = 'FETCH_OWNERSHIP_CHAIN_SUCCESS';
export const FETCH_OWNERSHIP_CHAIN_FAILURE = 'FETCH_OWNERSHIP_CHAIN_FAILURE';

// Action Creators
export const fetchPropertyYearsRequest = () => ({
  type: FETCH_PROPERTY_YEARS_REQUEST,
});

export const fetchPropertyYearsSuccess = (data) => ({
  type: FETCH_PROPERTY_YEARS_SUCCESS,
  payload: data,
});

export const fetchPropertyYearsFailure = (error) => ({
  type: FETCH_PROPERTY_YEARS_FAILURE,
  payload: error,
});

export const fetchOwnershipChainRequest = () => ({
  type: FETCH_OWNERSHIP_CHAIN_REQUEST,
});

export const fetchOwnershipChainSuccess = (data) => ({
  type: FETCH_OWNERSHIP_CHAIN_SUCCESS,
  payload: data,
});

export const fetchOwnershipChainFailure = (error) => ({
  type: FETCH_OWNERSHIP_CHAIN_FAILURE,
  payload: error,
});

export const getPropertyYears =
  ({ pID }) =>
  async (dispatch) => {
    dispatch(fetchPropertyYearsRequest());
    try {
      const response = await api.fetchPropertyYears({ pID });
      dispatch(fetchPropertyYearsSuccess(response));
      return response;
    } catch (error) {
      dispatch(fetchPropertyYearsFailure(error));
      throw error;
    }
  };

export const getOwnershipChainAllYears =
  ({ pID }) =>
  async (dispatch) => {
    dispatch(fetchOwnershipChainRequest());
    try {
      const response = await api.fetchOwnershipChainAllYears({ pID });
      dispatch(fetchOwnershipChainSuccess(response));
      return response;
    } catch (error) {
      dispatch(fetchOwnershipChainFailure(error));
      throw error;
    }
  };

export const getOwnershipChainByYear =
  ({ pID, pYear }) =>
  async (dispatch) => {
    console.log('actions/property.js - getOwnershipChainByYear : ', pID, pYear);
    dispatch(fetchOwnershipChainRequest());
    try {
      const response = await api.fetchOwnershipChainByYear({ pID, pYear });
      dispatch(fetchOwnershipChainSuccess(response));
      return response;
    } catch (error) {
      dispatch(fetchOwnershipChainFailure(error));
      throw error;
    }
  };

export const fetchPropertyYearsAction = (pID) => async (dispatch) => {
  dispatch(fetchPropertyYearsRequest());
  try {
    const response = await api.fetchPropertyYears({ pID });
    dispatch(fetchPropertyYearsSuccess(response));
    return response;
  } catch (error) {
    dispatch(fetchPropertyYearsFailure(error));
    throw error;
  }
};

export const FETCH_OWNERSHIP_CHAIN_BY_YEAR = createRequestTypes(
  `${namespace}/FETCH_OWNERSHIP_CHAIN_BY_YEAR`,
);

export const fetchOwnershipChainByYear = makeApiActionCreatorV3(
  api.fetchOwnershipChainByYear,
  FETCH_OWNERSHIP_CHAIN_BY_YEAR[START],
  FETCH_OWNERSHIP_CHAIN_BY_YEAR[SUCCESS],
  FETCH_OWNERSHIP_CHAIN_BY_YEAR[ERROR],
);
